import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _extends3 from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      .recharts-surface {\n        overflow: visible;\n      }\n      .recharts-legend-wrapper {\n        z-index: -1;\n      }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from "react";
import React__default, { useRef, useCallback, useEffect, useState } from "react";
import { forwardRef as forwardRef$1, FormHelperText as FormHelperText$1, FormLabel as FormLabel$1, FormErrorMessage as FormErrorMessage$1, FormControl, Input as Input$1, Box as Box$2, InputGroup, InputLeftElement, InputRightElement, Button as Button$1, Progress as Progress$1, extendTheme, theme as theme$1, ChakraProvider, Grid as Grid$1, GridItem, createIcon, Icon as Icon$2, Heading as Heading$2, chakra as chakra$1, Text as Text$2, Accordion as Accordion$1, AccordionItem as AccordionItem$1, AccordionButton, AccordionIcon, AccordionPanel, Square as Square$1, Circle as Circle$1, Center as Center$2, Stack as Stack$2, Badge as Badge$2, SimpleGrid as SimpleGrid$2, CircularProgress as CircularProgress$1, CircularProgressLabel, Table as Table$1, Thead as Thead$1, Tbody as Tbody$1, TableCaption as TableCaption$1, Tfoot as Tfoot$1, Th as Th$1, Tr as Tr$1, Td as Td$1, Textarea as Textarea$1, Flex as Flex$2, IconButton as IconButton$1, NumberInput as NumberInput$1, NumberInputField, NumberInputStepper, NumberIncrementStepper, NumberDecrementStepper, Spinner as Spinner$1, Breadcrumb, BreadcrumbItem, BreadcrumbLink, ModalOverlay, Modal, ModalContent, ModalCloseButton, ModalHeader, ModalFooter } from "@chakra-ui/react";
import { Alert, AlertDescription, AlertDialog, AlertDialogBody, AlertDialogCloseButton, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, AlertIcon, AlertTitle, ButtonGroup, Checkbox, CheckboxGroup, Circle, Divider, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerFooter, DrawerHeader, DrawerOverlay, FormControl as FormControl2, Grid, GridItem as GridItem2, Image, Link, LinkBox, LinkOverlay, List, ListIcon, ListItem, Menu, MenuButton, MenuCommand, MenuDivider, MenuGroup, MenuIcon, MenuItem, MenuItemOption, MenuList, MenuOptionGroup, Modal as Modal2, ModalBody, ModalCloseButton as ModalCloseButton2, ModalContent as ModalContent2, ModalFooter as ModalFooter2, ModalHeader as ModalHeader2, ModalOverlay as ModalOverlay2, OrderedList, Popover, PopoverArrow, PopoverBody, PopoverCloseButton, PopoverContent, PopoverFooter, PopoverHeader, PopoverTrigger, Radio, RadioGroup, Select, Skeleton, SkeletonCircle, SkeletonText, Slider, SliderFilledTrack, SliderThumb, SliderTrack, Spacer, Stat, StatArrow, StatGroup, StatHelpText, StatLabel, StatNumber, Switch, Tab, TabList, TabPanel, TabPanels, Tabs, Tag, TagCloseButton, TagLabel, TagLeftIcon, TagRightIcon, Tooltip, UnorderedList, chakra } from "@chakra-ui/react";
import { ThemeProvider as ThemeProvider$1, Global, css as css$1, ThemeContext } from "@emotion/react";
import { css } from "@emotion/react";
import { MantineProvider, UnstyledButton, Group, ThemeIcon, useMantineTheme, Box as Box$3, Menu as Menu2, Tabs as Tabs2, Transition, AppShell as AppShell$1, Navbar, ScrollArea, Header, Button as Button$2 } from "@mantine/core";
import { ThemeProvider } from "styled-components";
import { motion, AnimatePresence } from "framer-motion";
import { createPortal } from "react-dom";
import _styled from "@emotion/styled";
import { Navigation, FreeMode, Pagination, Scrollbar, A11y } from "swiper";
import { Swiper as Swiper$1 } from "swiper/react";
import { SwiperSlide, useSwiper, useSwiperSlide } from "swiper/react";
import { useHover, useDisclosure as useDisclosure$1, useDidUpdate } from "@mantine/hooks";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};

function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}

var lodash_mergewith = {
  exports: {}
};
lodash_mergewith.exports;

(function (module, exports) {
  var LARGE_ARRAY_SIZE = 200;
  var HASH_UNDEFINED = "__lodash_hash_undefined__";
  var HOT_COUNT = 800,
      HOT_SPAN = 16;
  var MAX_SAFE_INTEGER = 9007199254740991;
  var argsTag = "[object Arguments]",
      arrayTag = "[object Array]",
      asyncTag = "[object AsyncFunction]",
      boolTag = "[object Boolean]",
      dateTag = "[object Date]",
      errorTag = "[object Error]",
      funcTag = "[object Function]",
      genTag = "[object GeneratorFunction]",
      mapTag = "[object Map]",
      numberTag = "[object Number]",
      nullTag = "[object Null]",
      objectTag = "[object Object]",
      proxyTag = "[object Proxy]",
      regexpTag = "[object RegExp]",
      setTag = "[object Set]",
      stringTag = "[object String]",
      undefinedTag = "[object Undefined]",
      weakMapTag = "[object WeakMap]";
  var arrayBufferTag = "[object ArrayBuffer]",
      dataViewTag = "[object DataView]",
      float32Tag = "[object Float32Array]",
      float64Tag = "[object Float64Array]",
      int8Tag = "[object Int8Array]",
      int16Tag = "[object Int16Array]",
      int32Tag = "[object Int32Array]",
      uint8Tag = "[object Uint8Array]",
      uint8ClampedTag = "[object Uint8ClampedArray]",
      uint16Tag = "[object Uint16Array]",
      uint32Tag = "[object Uint32Array]";
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  var reIsHostCtor = /^\[object .+?Constructor\]$/;
  var reIsUint = /^(?:0|[1-9]\d*)$/;
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
  var freeGlobal = _typeof(commonjsGlobal) == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == "object" && self && self.Object === Object && self;
  var root = freeGlobal || freeSelf || Function("return this")();
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal.process;

  var nodeUtil = function () {
    try {
      var types = freeModule && freeModule.require && freeModule.require("util").types;

      if (types) {
        return types;
      }

      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
  }();

  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0:
        return func.call(thisArg);

      case 1:
        return func.call(thisArg, args[0]);

      case 2:
        return func.call(thisArg, args[0], args[1]);

      case 3:
        return func.call(thisArg, args[0], args[1], args[2]);
    }

    return func.apply(thisArg, args);
  }

  function baseTimes(n, iteratee) {
    var index2 = -1,
        result = Array(n);

    while (++index2 < n) {
      result[index2] = iteratee(index2);
    }

    return result;
  }

  function baseUnary(func) {
    return function (value) {
      return func(value);
    };
  }

  function getValue(object, key) {
    return object == null ? void 0 : object[key];
  }

  function overArg(func, transform10) {
    return function (arg) {
      return func(transform10(arg));
    };
  }

  var arrayProto = Array.prototype,
      funcProto = Function.prototype,
      objectProto = Object.prototype;
  var coreJsData = root["__core-js_shared__"];
  var funcToString = funcProto.toString;
  var hasOwnProperty = objectProto.hasOwnProperty;

  var maskSrcKey = function () {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
  }();

  var nativeObjectToString = objectProto.toString;
  var objectCtorString = funcToString.call(Object);
  var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
  var Buffer = moduleExports ? root.Buffer : void 0,
      Symbol2 = root.Symbol,
      Uint8Array = root.Uint8Array,
      allocUnsafe = Buffer ? Buffer.allocUnsafe : void 0,
      getPrototype = overArg(Object.getPrototypeOf, Object),
      objectCreate = Object.create,
      propertyIsEnumerable = objectProto.propertyIsEnumerable,
      splice = arrayProto.splice,
      symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;

  var defineProperty = function () {
    try {
      var func = getNative(Object, "defineProperty");
      func({}, "", {});
      return func;
    } catch (e) {}
  }();

  var nativeIsBuffer = Buffer ? Buffer.isBuffer : void 0,
      nativeMax = Math.max,
      nativeNow = Date.now;
  var Map2 = getNative(root, "Map"),
      nativeCreate = getNative(Object, "create");

  var baseCreate = function () {
    function object() {}

    return function (proto) {
      if (!isObject2(proto)) {
        return {};
      }

      if (objectCreate) {
        return objectCreate(proto);
      }

      object.prototype = proto;
      var result = new object();
      object.prototype = void 0;
      return result;
    };
  }();

  function Hash(entries) {
    var index2 = -1,
        length = entries == null ? 0 : entries.length;
    this.clear();

    while (++index2 < length) {
      var entry = entries[index2];
      this.set(entry[0], entry[1]);
    }
  }

  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
  }

  function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }

  function hashGet(key) {
    var data = this.__data__;

    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? void 0 : result;
    }

    return hasOwnProperty.call(data, key) ? data[key] : void 0;
  }

  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== void 0 : hasOwnProperty.call(data, key);
  }

  function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
    return this;
  }

  Hash.prototype.clear = hashClear;
  Hash.prototype["delete"] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;

  function ListCache(entries) {
    var index2 = -1,
        length = entries == null ? 0 : entries.length;
    this.clear();

    while (++index2 < length) {
      var entry = entries[index2];
      this.set(entry[0], entry[1]);
    }
  }

  function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
  }

  function listCacheDelete(key) {
    var data = this.__data__,
        index2 = assocIndexOf(data, key);

    if (index2 < 0) {
      return false;
    }

    var lastIndex = data.length - 1;

    if (index2 == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index2, 1);
    }

    --this.size;
    return true;
  }

  function listCacheGet(key) {
    var data = this.__data__,
        index2 = assocIndexOf(data, key);
    return index2 < 0 ? void 0 : data[index2][1];
  }

  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }

  function listCacheSet(key, value) {
    var data = this.__data__,
        index2 = assocIndexOf(data, key);

    if (index2 < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index2][1] = value;
    }

    return this;
  }

  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype["delete"] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;

  function MapCache(entries) {
    var index2 = -1,
        length = entries == null ? 0 : entries.length;
    this.clear();

    while (++index2 < length) {
      var entry = entries[index2];
      this.set(entry[0], entry[1]);
    }
  }

  function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
      "hash": new Hash(),
      "map": new (Map2 || ListCache)(),
      "string": new Hash()
    };
  }

  function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
  }

  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }

  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }

  function mapCacheSet(key, value) {
    var data = getMapData(this, key),
        size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
  }

  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype["delete"] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;

  function Stack2(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
  }

  function stackClear() {
    this.__data__ = new ListCache();
    this.size = 0;
  }

  function stackDelete(key) {
    var data = this.__data__,
        result = data["delete"](key);
    this.size = data.size;
    return result;
  }

  function stackGet(key) {
    return this.__data__.get(key);
  }

  function stackHas(key) {
    return this.__data__.has(key);
  }

  function stackSet(key, value) {
    var data = this.__data__;

    if (data instanceof ListCache) {
      var pairs = data.__data__;

      if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }

      data = this.__data__ = new MapCache(pairs);
    }

    data.set(key, value);
    this.size = data.size;
    return this;
  }

  Stack2.prototype.clear = stackClear;
  Stack2.prototype["delete"] = stackDelete;
  Stack2.prototype.get = stackGet;
  Stack2.prototype.has = stackHas;
  Stack2.prototype.set = stackSet;

  function arrayLikeKeys(value, inherited) {
    var isArr = isArray2(value),
        isArg = !isArr && isArguments(value),
        isBuff = !isArr && !isArg && isBuffer(value),
        isType = !isArr && !isArg && !isBuff && isTypedArray(value),
        skipIndexes = isArr || isArg || isBuff || isType,
        result = skipIndexes ? baseTimes(value.length, String) : [],
        length = result.length;

    for (var key in value) {
      if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
      key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
      isIndex(key, length)))) {
        result.push(key);
      }
    }

    return result;
  }

  function assignMergeValue(object, key, value) {
    if (value !== void 0 && !eq(object[key], value) || value === void 0 && !(key in object)) {
      baseAssignValue(object, key, value);
    }
  }

  function assignValue(object, key, value) {
    var objValue = object[key];

    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === void 0 && !(key in object)) {
      baseAssignValue(object, key, value);
    }
  }

  function assocIndexOf(array, key) {
    var length = array.length;

    while (length--) {
      if (eq(array[length][0], key)) {
        return length;
      }
    }

    return -1;
  }

  function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) {
      defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
      });
    } else {
      object[key] = value;
    }
  }

  var baseFor = createBaseFor();

  function baseGetTag(value) {
    if (value == null) {
      return value === void 0 ? undefinedTag : nullTag;
    }

    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
  }

  function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
  }

  function baseIsNative(value) {
    if (!isObject2(value) || isMasked(value)) {
      return false;
    }

    var pattern = isFunction2(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }

  function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
  }

  function baseKeysIn(object) {
    if (!isObject2(object)) {
      return nativeKeysIn(object);
    }

    var isProto = isPrototype(object),
        result = [];

    for (var key in object) {
      if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) {
        result.push(key);
      }
    }

    return result;
  }

  function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) {
      return;
    }

    baseFor(source, function (srcValue, key) {
      stack || (stack = new Stack2());

      if (isObject2(srcValue)) {
        baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
      } else {
        var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : void 0;

        if (newValue === void 0) {
          newValue = srcValue;
        }

        assignMergeValue(object, key, newValue);
      }
    }, keysIn);
  }

  function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key),
        srcValue = safeGet(source, key),
        stacked = stack.get(srcValue);

    if (stacked) {
      assignMergeValue(object, key, stacked);
      return;
    }

    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : void 0;
    var isCommon = newValue === void 0;

    if (isCommon) {
      var isArr = isArray2(srcValue),
          isBuff = !isArr && isBuffer(srcValue),
          isTyped = !isArr && !isBuff && isTypedArray(srcValue);
      newValue = srcValue;

      if (isArr || isBuff || isTyped) {
        if (isArray2(objValue)) {
          newValue = objValue;
        } else if (isArrayLikeObject(objValue)) {
          newValue = copyArray(objValue);
        } else if (isBuff) {
          isCommon = false;
          newValue = cloneBuffer(srcValue, true);
        } else if (isTyped) {
          isCommon = false;
          newValue = cloneTypedArray(srcValue, true);
        } else {
          newValue = [];
        }
      } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
        newValue = objValue;

        if (isArguments(objValue)) {
          newValue = toPlainObject(objValue);
        } else if (!isObject2(objValue) || isFunction2(objValue)) {
          newValue = initCloneObject(srcValue);
        }
      } else {
        isCommon = false;
      }
    }

    if (isCommon) {
      stack.set(srcValue, newValue);
      mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
      stack["delete"](srcValue);
    }

    assignMergeValue(object, key, newValue);
  }

  function baseRest(func, start2) {
    return setToString(overRest(func, start2, identity), func + "");
  }

  var baseSetToString = !defineProperty ? identity : function (func, string) {
    return defineProperty(func, "toString", {
      "configurable": true,
      "enumerable": false,
      "value": constant(string),
      "writable": true
    });
  };

  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }

    var length = buffer.length,
        result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
  }

  function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
  }

  function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
  }

  function copyArray(source, array) {
    var index2 = -1,
        length = source.length;
    array || (array = Array(length));

    while (++index2 < length) {
      array[index2] = source[index2];
    }

    return array;
  }

  function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index2 = -1,
        length = props.length;

    while (++index2 < length) {
      var key = props[index2];
      var newValue = customizer ? customizer(object[key], source[key], key, object, source) : void 0;

      if (newValue === void 0) {
        newValue = source[key];
      }

      if (isNew) {
        baseAssignValue(object, key, newValue);
      } else {
        assignValue(object, key, newValue);
      }
    }

    return object;
  }

  function createAssigner(assigner) {
    return baseRest(function (object, sources) {
      var index2 = -1,
          length = sources.length,
          customizer = length > 1 ? sources[length - 1] : void 0,
          guard = length > 2 ? sources[2] : void 0;
      customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : void 0;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        customizer = length < 3 ? void 0 : customizer;
        length = 1;
      }

      object = Object(object);

      while (++index2 < length) {
        var source = sources[index2];

        if (source) {
          assigner(object, source, index2, customizer);
        }
      }

      return object;
    });
  }

  function createBaseFor(fromRight) {
    return function (object, iteratee, keysFunc) {
      var index2 = -1,
          iterable = Object(object),
          props = keysFunc(object),
          length = props.length;

      while (length--) {
        var key = props[fromRight ? length : ++index2];

        if (iteratee(iterable[key], key, iterable) === false) {
          break;
        }
      }

      return object;
    };
  }

  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
  }

  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : void 0;
  }

  function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];

    try {
      value[symToStringTag] = void 0;
      var unmasked = true;
    } catch (e) {}

    var result = nativeObjectToString.call(value);

    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }

    return result;
  }

  function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
  }

  function isIndex(value, length) {
    var type = _typeof(value);

    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
  }

  function isIterateeCall(value, index2, object) {
    if (!isObject2(object)) {
      return false;
    }

    var type = _typeof(index2);

    if (type == "number" ? isArrayLike(object) && isIndex(index2, object.length) : type == "string" && index2 in object) {
      return eq(object[index2], value);
    }

    return false;
  }

  function isKeyable(value) {
    var type = _typeof(value);

    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
  }

  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }

  function isPrototype(value) {
    var Ctor = value && value.constructor,
        proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
  }

  function nativeKeysIn(object) {
    var result = [];

    if (object != null) {
      for (var key in Object(object)) {
        result.push(key);
      }
    }

    return result;
  }

  function objectToString(value) {
    return nativeObjectToString.call(value);
  }

  function overRest(func, start2, transform10) {
    start2 = nativeMax(start2 === void 0 ? func.length - 1 : start2, 0);
    return function () {
      var args = arguments,
          index2 = -1,
          length = nativeMax(args.length - start2, 0),
          array = Array(length);

      while (++index2 < length) {
        array[index2] = args[start2 + index2];
      }

      index2 = -1;
      var otherArgs = Array(start2 + 1);

      while (++index2 < start2) {
        otherArgs[index2] = args[index2];
      }

      otherArgs[start2] = transform10(array);
      return apply(func, this, otherArgs);
    };
  }

  function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") {
      return;
    }

    if (key == "__proto__") {
      return;
    }

    return object[key];
  }

  var setToString = shortOut(baseSetToString);

  function shortOut(func) {
    var count = 0,
        lastCalled = 0;
    return function () {
      var stamp = nativeNow(),
          remaining = HOT_SPAN - (stamp - lastCalled);
      lastCalled = stamp;

      if (remaining > 0) {
        if (++count >= HOT_COUNT) {
          return arguments[0];
        }
      } else {
        count = 0;
      }

      return func.apply(void 0, arguments);
    };
  }

  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {}

      try {
        return func + "";
      } catch (e) {}
    }

    return "";
  }

  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }

  var isArguments = baseIsArguments(function () {
    return arguments;
  }()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
  };
  var isArray2 = Array.isArray;

  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction2(value);
  }

  function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
  }

  var isBuffer = nativeIsBuffer || stubFalse;

  function isFunction2(value) {
    if (!isObject2(value)) {
      return false;
    }

    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
  }

  function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }

  function isObject2(value) {
    var type = _typeof(value);

    return value != null && (type == "object" || type == "function");
  }

  function isObjectLike(value) {
    return value != null && _typeof(value) == "object";
  }

  function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
      return false;
    }

    var proto = getPrototype(value);

    if (proto === null) {
      return true;
    }

    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
  }

  var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

  function toPlainObject(value) {
    return copyObject(value, keysIn(value));
  }

  function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
  }

  var mergeWith2 = createAssigner(function (object, source, srcIndex, customizer) {
    baseMerge(object, source, srcIndex, customizer);
  });

  function constant(value) {
    return function () {
      return value;
    };
  }

  function identity(value) {
    return value;
  }

  function stubFalse() {
    return false;
  }

  module.exports = mergeWith2;
})(lodash_mergewith, lodash_mergewith.exports);

var lodash_mergewithExports = lodash_mergewith.exports;
var mergeWith =
/* @__PURE__ */
getDefaultExportFromCjs(lodash_mergewithExports);

function isNumber(value) {
  return typeof value === "number";
}

function isArray(value) {
  return Array.isArray(value);
}

function isFunction(value) {
  return typeof value === "function";
}

function isObject(value) {
  var type = _typeof(value);

  return value != null && (type === "object" || type === "function") && !isArray(value);
}

function isNull(value) {
  return value == null;
}

function isString(value) {
  return Object.prototype.toString.call(value) === "[object String]";
}

function isCssVar(value) {
  return /^var\(--.+\)$/.test(value);
}

var __DEV__ = process.env.NODE_ENV !== "production";

process.env.NODE_ENV === "test";

function omit(object, keys) {
  var result = {};
  Object.keys(object).forEach(function (key) {
    if (keys.includes(key)) return;
    result[key] = object[key];
  });
  return result;
}

function pick(object, keys) {
  var result = {};
  keys.forEach(function (key) {
    if (key in object) {
      result[key] = object[key];
    }
  });
  return result;
}

function get(obj, path, fallback, index2) {
  var key = typeof path === "string" ? path.split(".") : [path];

  for (index2 = 0; index2 < key.length; index2 += 1) {
    if (!obj) break;
    obj = obj[key[index2]];
  }

  return obj === void 0 ? fallback : obj;
}

var memoize = function memoize2(fn6) {
  var cache =
  /* @__PURE__ */
  new WeakMap();

  var memoizedFn = function memoizedFn2(obj, path, fallback, index2) {
    if (typeof obj === "undefined") {
      return fn6(obj, path, fallback);
    }

    if (!cache.has(obj)) {
      cache.set(obj,
      /* @__PURE__ */
      new Map());
    }

    var map = cache.get(obj);

    if (map.has(path)) {
      return map.get(path);
    }

    var value = fn6(obj, path, fallback, index2);
    map.set(path, value);
    return value;
  };

  return memoizedFn;
};

var memoizedGet = memoize(get);

function objectFilter(object, fn6) {
  var result = {};
  Object.keys(object).forEach(function (key) {
    var value = object[key];
    var shouldPass = fn6(value, key, object);

    if (shouldPass) {
      result[key] = value;
    }
  });
  return result;
}

var filterUndefined = function filterUndefined2(object) {
  return objectFilter(object, function (val) {
    return val !== null && val !== void 0;
  });
};

var objectKeys = function objectKeys2(obj) {
  return Object.keys(obj);
};

var getCSSVar = function getCSSVar2(theme2, scale2, value) {
  var _theme$__cssMap$$varR, _theme$__cssMap$;

  return (_theme$__cssMap$$varR = (_theme$__cssMap$ = theme2.__cssMap[scale2 + "." + value]) == null ? void 0 : _theme$__cssMap$.varRef) != null ? _theme$__cssMap$$varR : value;
};

function analyzeCSSValue$1(value) {
  var num = parseFloat(value.toString());
  var unit = value.toString().replace(String(num), "");
  return {
    unitless: !unit,
    value: num,
    unit: unit
  };
}

function px(value) {
  if (value == null) return value;

  var _analyzeCSSValue = analyzeCSSValue$1(value),
      unitless = _analyzeCSSValue.unitless;

  return unitless || isNumber(value) ? value + "px" : value;
}

function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}

var isBrowser = canUseDOM();

var cx = function cx2() {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }

  return classNames.filter(Boolean).join(" ");
};

function runIfFn(valueOrFn) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return isFunction(valueOrFn) ? valueOrFn.apply(void 0, args) : valueOrFn;
}

function callAllHandlers() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  return function func(event) {
    fns.some(function (fn6) {
      fn6 == null ? void 0 : fn6(event);
      return event == null ? void 0 : event.defaultPrevented;
    });
  };
}

function once(fn6) {
  var result;
  return function func() {
    if (fn6) {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      result = fn6.apply(this, args);
      fn6 = null;
    }

    return result;
  };
}

var warn = once(function (options) {
  return function () {
    var condition = options.condition,
        message = options.message;

    if (condition && __DEV__) {
      console.warn(message);
    }
  };
});

function mapResponsive(prop2, mapper) {
  if (isArray(prop2)) {
    return prop2.map(function (item) {
      if (item === null) {
        return null;
      }

      return mapper(item);
    });
  }

  if (isObject(prop2)) {
    return objectKeys(prop2).reduce(function (result, key) {
      result[key] = mapper(prop2[key]);
      return result;
    }, {});
  }

  if (prop2 != null) {
    return mapper(prop2);
  }

  return null;
}

function _extends$8() {
  _extends$8 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$8.apply(this, arguments);
}

var createBreakpoints = function createBreakpoints2(config2) {
  warn({
    condition: true,
    message: ["[chakra-ui]: createBreakpoints(...) will be deprecated pretty soon", "simply pass the breakpoints as an object. Remove the createBreakpoint(..) call"].join("")
  });
  return _extends$8({
    base: "0em"
  }, config2);
};

function toRef(operand) {
  if (isObject(operand) && operand.reference) {
    return operand.reference;
  }

  return String(operand);
}

var toExpr = function toExpr2(operator) {
  for (var _len = arguments.length, operands = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    operands[_key - 1] = arguments[_key];
  }

  return operands.map(toRef).join(" " + operator + " ").replace(/calc/g, "");
};

var _add$1 = function add() {
  for (var _len2 = arguments.length, operands = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    operands[_key2] = arguments[_key2];
  }

  return "calc(" + toExpr.apply(void 0, ["+"].concat(operands)) + ")";
};

var _subtract$1 = function subtract() {
  for (var _len3 = arguments.length, operands = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    operands[_key3] = arguments[_key3];
  }

  return "calc(" + toExpr.apply(void 0, ["-"].concat(operands)) + ")";
};

var _multiply$1 = function multiply() {
  for (var _len4 = arguments.length, operands = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    operands[_key4] = arguments[_key4];
  }

  return "calc(" + toExpr.apply(void 0, ["*"].concat(operands)) + ")";
};

var _divide$1 = function divide() {
  for (var _len5 = arguments.length, operands = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    operands[_key5] = arguments[_key5];
  }

  return "calc(" + toExpr.apply(void 0, ["/"].concat(operands)) + ")";
};

var _negate$1 = function negate(x) {
  var value = toRef(x);

  if (value != null && !Number.isNaN(parseFloat(value))) {
    return String(value).startsWith("-") ? String(value).slice(1) : "-" + value;
  }

  return _multiply$1(value, -1);
};

var calc$1 = Object.assign(function (x) {
  return {
    add: function add3() {
      for (var _len6 = arguments.length, operands = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        operands[_key6] = arguments[_key6];
      }

      return calc$1(_add$1.apply(void 0, [x].concat(operands)));
    },
    subtract: function subtract3() {
      for (var _len7 = arguments.length, operands = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        operands[_key7] = arguments[_key7];
      }

      return calc$1(_subtract$1.apply(void 0, [x].concat(operands)));
    },
    multiply: function multiply3() {
      for (var _len8 = arguments.length, operands = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        operands[_key8] = arguments[_key8];
      }

      return calc$1(_multiply$1.apply(void 0, [x].concat(operands)));
    },
    divide: function divide3() {
      for (var _len9 = arguments.length, operands = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        operands[_key9] = arguments[_key9];
      }

      return calc$1(_divide$1.apply(void 0, [x].concat(operands)));
    },
    negate: function negate3() {
      return calc$1(_negate$1(x));
    },
    toString: function toString() {
      return x.toString();
    }
  };
}, {
  add: _add$1,
  subtract: _subtract$1,
  multiply: _multiply$1,
  divide: _divide$1,
  negate: _negate$1
});

var mapFontSizeToInputSize = function mapFontSizeToInputSize() {
  var isLabel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return {
    xs: isLabel ? "sm" : "xs",
    sm: isLabel ? "md" : "sm",
    md: isLabel ? "lg" : "md",
    lg: isLabel ? "lg" : "md"
  };
};

var FormHelperTextStyles = function FormHelperTextStyles(_ref8) {
  var _ref8$size = _ref8.size,
      size = _ref8$size === void 0 ? "md" : _ref8$size,
      _ref8$isDisabled = _ref8.isDisabled,
      isDisabled = _ref8$isDisabled === void 0 ? false : _ref8$isDisabled;
  return {
    helperText: _objectSpread({
      color: "gray.500",
      fontSize: mapFontSizeToInputSize()[size],
      fontWeight: "normal"
    }, !!isDisabled && {
      opacity: 0.5
    })
  };
};

var FormHelperText = forwardRef$1(function BaseFormHelperText(_ref9, ref) {
  var children = _ref9.children,
      rest = _objectWithoutProperties(_ref9, ["children"]);

  return React__default.createElement(FormHelperText$1, _objectSpread({
    ref: ref
  }, rest), children);
});
var FormControlStyles = {
  baseStyle: function baseStyle(props) {
    return _objectSpread({}, FormHelperTextStyles(props), {}, props);
  }
};
var FormLabelStyles = {
  baseStyle: function baseStyle(_ref10) {
    var _ref10$size = _ref10.size,
        size = _ref10$size === void 0 ? "md" : _ref10$size;
    return {
      color: "gray.700",
      fontSize: mapFontSizeToInputSize(true)[size],
      fontWeight: "medium"
    };
  }
};
var FormLabel = forwardRef$1(function BaseFormLabel(_ref11, ref) {
  var children = _ref11.children,
      rest = _objectWithoutProperties(_ref11, ["children"]);

  return React__default.createElement(FormLabel$1, _objectSpread({
    ref: ref
  }, rest), children);
});
var FormErrorMessageStyles = {
  baseStyle: function baseStyle(_ref12) {
    var _ref12$size = _ref12.size,
        size = _ref12$size === void 0 ? "md" : _ref12$size,
        rest = _objectWithoutProperties(_ref12, ["size"]);

    return _objectSpread({}, rest, {
      text: {
        color: "error.500",
        fontSize: mapFontSizeToInputSize()[size],
        fontWeight: "medium",
        _disabled: {
          opacity: 0.5
        }
      }
    });
  }
};
var FormErrorMessage = forwardRef$1(function BaseFormErrorMessage(_ref13, ref) {
  var children = _ref13.children,
      rest = _objectWithoutProperties(_ref13, ["children"]);

  return React__default.createElement(FormErrorMessage$1, _objectSpread({
    ref: ref
  }, rest), children);
});
var WeightedColors = ["success", "warning", "error", "brandHue", "blackAlpha", "whiteAlpha", "gray", "red", "blue", "purple", "teal", "green", "orange", "yellow", "cyan", "pink", "light_blue", "forest_green", "light_orange", "fuschia"];
var Colors = {
  transparent: "transparent",
  brand: "#f15d4b",
  info: "#63B3ED",
  black: "#444",
  trueBlack: "#000",
  white: "#fff",
  gradients: {
    fuschiaOrange: "linear-gradient(89.13deg, #FD65A8 1.21%, #FFA24D 98.74%)",
    fuschiaShades: "linear-gradient(93.34deg, #FD65A8 0.19%, #FD65A8 48.01%, #F295A8 100%)",
    orangeFuschia: "linear-gradient(89.69deg, #F47D6F 0.48%, #FD65A8 99.58%)",
    orangeShades: "linear-gradient(87.97deg, #F47D6F 2.65%, #FFA24D 97.3%)",
    sunset: "linear-gradient(93.16deg, #AD5BD6 0.18%, #FD65A8 51.58%, #FFA24D 99.73%)",
    tealBlue: "linear-gradient(89.41deg, #33B8A9 21.25%, #3399FF 99.16%)"
  },
  blackAlpha: {
    50: "rgba(0, 0, 0, 0.04)",
    100: "rgba(0, 0, 0, 0.06)",
    200: "rgba(0, 0, 0, 0.08)",
    300: "rgba(0, 0, 0, 0.16)",
    400: "rgba(0, 0, 0, 0.24)",
    500: "rgba(0, 0, 0, 0.36)",
    600: "rgba(0, 0, 0, 0.48)",
    700: "rgba(0, 0, 0, 0.64)",
    800: "rgba(0, 0, 0, 0.80)",
    900: "rgba(0, 0, 0, 0.92)"
  },
  whiteAlpha: {
    50: "rgba(255, 255, 255, 0.04)",
    100: "rgba(255, 255, 255, 0.06)",
    200: "rgba(255, 255, 255, 0.08)",
    300: "rgba(255, 255, 255, 0.16)",
    400: "rgba(255, 255, 255, 0.24)",
    500: "rgba(255, 255, 255, 0.36)",
    600: "rgba(255, 255, 255, 0.48)",
    700: "rgba(255, 255, 255, 0.64)",
    800: "rgba(255, 255, 255, 0.80)",
    900: "rgba(255, 255, 255, 0.92)"
  },
  pink: {
    50: "#FFF5F7",
    100: "#FED7E2",
    200: "#FBB6CE",
    300: "#F687B3",
    400: "#ED64A6",
    500: "#D53F8C",
    600: "#B83280",
    700: "#97266D",
    800: "#702459",
    900: "#521B41"
  },
  success: {
    50: "#eaf4ec",
    100: "#e6f6f0",
    200: "#b3e5d3",
    300: "#80d4b5",
    400: "#4dc297",
    500: "#00a86b",
    600: "#008656",
    700: "#006540",
    800: "#00432b",
    900: "#002215"
  },
  warning: {
    50: "#f8f4e6",
    100: "#fff6e6",
    200: "#ffe5b3",
    300: "#ffd380",
    400: "#ffc14d",
    500: "#ffa700",
    600: "#e69600",
    700: "#b37500",
    800: "#805400",
    900: "#4c3200"
  },
  error: {
    50: "#fcecea",
    100: "#ffe9e7",
    200: "#ffbeb8",
    300: "#ff9389",
    400: "#fe6859",
    500: "#fe2712",
    600: "#cb1f0e",
    700: "#98170b",
    800: "#661007",
    900: "#330804"
  },
  brandHue: {
    50: "#f7d1cc",
    100: "#fbb6ae",
    200: "#fda69c",
    300: "#f58173",
    400: "#f56b5a",
    500: "#f15d4b",
    600: "#d94231",
    700: "#df3925",
    800: "#b92210",
    900: "#8d1204"
  },
  gray: {
    50: "#f2f4f5",
    100: "#eeeff1",
    200: "#dde0e2",
    300: "#87919a",
    400: "#65727d",
    500: "#54626f",
    600: "#434e59",
    700: "#323b43",
    800: "#22272c",
    900: "#111416"
  },
  red: {
    50: "#FFECEE",
    100: "#fceaee",
    200: "#f7bfcb",
    300: "#f295a8",
    400: "#ed6b85",
    500: "#e52b50",
    600: "#ce2748",
    700: "#a01e38",
    800: "#731628",
    900: "#450d18"
  },
  blue: {
    50: "#f4f9ff",
    100: "#e6f2ff",
    200: "#99ccff",
    300: "#66b2ff",
    400: "#3399ff",
    500: "#0072e6",
    600: "#0059b3",
    700: "#004080",
    800: "#00264c",
    900: "#000d19"
  },
  yellow: {
    50: "#fffdf2",
    100: "#fffbe6",
    200: "#ffed99",
    300: "#ffe566",
    400: "#ffdc33",
    500: "#ffd300",
    600: "#e6be00",
    700: "#b39400",
    800: "#806a00",
    900: "#4c3f00"
  },
  light_blue: {
    50: "#dcf8ff",
    100: "#b2e5fe",
    200: "#85d2f6",
    300: "#59c0f1",
    400: "#2daeec",
    500: "#1395d2",
    600: "#0474a4",
    700: "#005377",
    800: "#00334a",
    900: "#00131d"
  },
  cyan: {
    50: "#e8fafa",
    100: "#e6f8fd",
    200: "#b3e9f9",
    300: "#80dbf5",
    400: "#4dcdf1",
    500: "#00b7eb",
    600: "#0092bc",
    700: "#006e8d",
    800: "#00495e",
    900: "#00252f"
  },
  purple: {
    50: "#faf3fe",
    100: "#f5ebfa",
    200: "#d6adeb",
    300: "#c284e0",
    400: "#ad5bd6",
    500: "#9932cc",
    600: "#7a28a3",
    700: "#5c1e7a",
    800: "#3d1452",
    900: "#1f0a29"
  },
  teal: {
    50: "#f0fbfb",
    100: "#e6f6f4",
    200: "#99dbd4",
    300: "#66cabe",
    400: "#33b8a9",
    500: "#00a693",
    600: "#009584",
    700: "#007467",
    800: "#00534a",
    900: "#00322c"
  },
  forest_green: {
    50: "#e2fbef",
    100: "#c1ecd6",
    200: "#9ddfbc",
    300: "#79d1a2",
    400: "#55c489",
    500: "#3baa6f",
    600: "#2c8455",
    700: "#1d5f3d",
    800: "#0d3a23",
    900: "#001506"
  },
  green: {
    50: "#f6faec",
    100: "#f0f7eb",
    200: "#d1e7c2",
    300: "#b3d899",
    400: "#94c870",
    500: "#66b032",
    600: "#528d28",
    700: "#3d6a1e",
    800: "#294614",
    900: "#14230a"
  },
  orange: {
    50: "#fbf2ea",
    100: "#fff2e6",
    200: "#ffd7b3",
    300: "#ffbd80",
    400: "#ffa24d",
    500: "#ff7a00",
    600: "#e66e00",
    700: "#b35500",
    800: "#803d00",
    900: "#4c2500"
  },
  light_orange: {
    50: "#fff3dc",
    100: "#fddfb1",
    200: "#faca83",
    300: "#f6b555",
    400: "#f3a025",
    500: "#da870c",
    600: "#a96906",
    700: "#7a4b02",
    800: "#4b2c00",
    900: "#1d0e00"
  },
  fuschia: {
    50: "#fff4f9",
    100: "#ffecf4",
    200: "#feb2d3",
    300: "#fe8cbe",
    400: "#fd65a8",
    500: "#fd3f92",
    600: "#ca3275",
    700: "#982658",
    800: "#65193a",
    900: "#330d1d"
  }
};
var hexCharacters = "a-f\\d";
var match3or4Hex = "#?[".concat(hexCharacters, "]{3}[").concat(hexCharacters, "]?");
var match6or8Hex = "#?[".concat(hexCharacters, "]{6}([").concat(hexCharacters, "]{2})?");
var nonHexChars = new RegExp("[^#".concat(hexCharacters, "]"), "gi");
var validHexSize = new RegExp("^".concat(match3or4Hex, "$|^").concat(match6or8Hex, "$"), "i");

var hexRgb = function hexRgb(hex) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof hex !== "string" || nonHexChars.test(hex) || !validHexSize.test(hex)) {
    throw new TypeError("Expected a valid hex string");
  }

  hex = hex.replace(/^#/, "");
  var alphaFromHex = 1;

  if (hex.length === 8) {
    alphaFromHex = Number.parseInt(hex.slice(6, 8), 16) / 255;
    hex = hex.slice(0, 6);
  }

  if (hex.length === 4) {
    alphaFromHex = Number.parseInt(hex.slice(3, 4).repeat(2), 16) / 255;
    hex = hex.slice(0, 3);
  }

  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }

  var number = Number.parseInt(hex, 16);
  var red = number >> 16;
  var green = number >> 8 & 255;
  var blue = number & 255;
  var alpha = typeof options.alpha === "number" ? options.alpha : alphaFromHex;

  if (options.format === "array") {
    return [red, green, blue, alpha];
  }

  if (options.format === "css") {
    var alphaString = alpha === 1 ? "" : " / ".concat(Number((alpha * 100).toFixed(2)), "%");
    return "rgb(".concat(red, " ").concat(green, " ").concat(blue).concat(alphaString, ")");
  }

  return {
    red: red,
    green: green,
    blue: blue,
    alpha: alpha
  };
};

var hexRgb$1 =
/* @__PURE__ */
getDefaultExportFromCjs(hexRgb);
var NewFontSizes = {
  xs: "0.75rem",
  sm: "0.875rem",
  md: "1rem",
  lg: "1.125rem",
  xl: "1.375rem",
  "2xl": "1.75rem",
  "3xl": "2rem",
  "4xl": "3rem",
  "5xl": "4rem",
  "6xl": "4.5rem",
  "7xl": "6rem",
  "8xl": "8rem"
};
var font = "Inter, system-ui, Roboto, Helvetica, Arial, sans-serif";
var TapTheme = {
  colors: Colors,
  fn: {
    rgba: function rgba(hex, alpha) {
      return hexRgb$1(hex, {
        alpha: alpha,
        format: "css"
      });
    },
    rgb_values: function rgb_values(hex) {
      return hexRgb$1(hex, {
        format: "array"
      }).slice(0, -1).join(", ");
    }
  },
  fonts: {
    primary: font,
    secondary: font,
    heading: font,
    body: font
  },
  fontSizes: {
    xs: "0.75rem",
    sm: "0.925rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem",
    "6xl": "3.75rem",
    "7xl": "4.5rem",
    "8xl": "6rem",
    "9xl": "8rem"
  },
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900
  },
  lineHeights: {
    normal: "normal",
    none: 1,
    shorter: 1.25,
    "short": 1.375,
    base: 1.5,
    tall: 1.625,
    taller: "2",
    "3": ".75rem",
    "4": "1rem",
    "5": "1.25rem",
    "6": "1.5rem",
    "7": "1.75rem",
    "8": "2rem",
    "9": "2.25rem",
    "10": "2.5rem"
  },
  letterSpacings: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em"
  },
  radii: {
    none: "0",
    sm: "0.125rem",
    base: "0.25rem",
    md: "0.375rem",
    lg: "0.5rem",
    xl: "0.75rem",
    "2xl": "1rem",
    "3xl": "1.5rem",
    full: "9999px"
  }
};
var mediaBreakpoints = {
  down: {
    sm: "600px",
    md: "900px",
    lg: "1200px",
    xl: "1500px"
  },
  up: {
    sm: "0px",
    md: "600px",
    lg: "900px",
    xl: "1200px"
  }
};
var respond = {
  down: function down(bp) {
    return "@media (max-width: ".concat(mediaBreakpoints.down[bp], ")");
  },
  up: function up(bp) {
    return "@media (min-width: ".concat(mediaBreakpoints.up[bp], ")");
  }
};
var MantineColors = WeightedColors.reduce(function (acc, colorKey) {
  return _objectSpread({}, acc, _defineProperty({}, colorKey, Object.values(TapTheme.colors[colorKey])));
}, {});
var MantineTheme = {
  focusRing: "auto",
  fontFamily: TapTheme.fonts.primary,
  fontSizes: NewFontSizes,
  colors: MantineColors,
  defaultRadius: "md",
  radius: {
    md: "0.325rem"
  },
  primaryColor: "blue",
  primaryShade: 5,
  components: {
    Button: {
      defaultProps: {
        size: "md"
      },
      styles: {
        root: {
          lineHeight: 1,
          "&:active": {
            transform: "none"
          }
        }
      },
      variants: {
        outline: function outline(theme2, params) {
          return {
            root: {
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              borderColor: theme2.colors[params.color || theme2.primaryColor][2]
            }
          };
        }
      }
    },
    UnstyledButton: {
      defaultProps: {
        size: "md"
      },
      styles: function styles(theme2) {
        return {
          root: {
            lineHeight: 1,
            transitionProperty: transitionProperty,
            transitionDuration: transitionDuration
          }
        };
      }
    }
  }
};
var transitionProperty = "background-color,border-color,color,fill,stroke,opacity,box-shadow,transform;";
var transitionDuration = "150ms";
var InputStyles = {
  variants: {
    outline: {
      field: {
        bg: "white"
      }
    }
  },
  defaultProps: {
    size: "md",
    variant: "outline"
  }
};
var Input = forwardRef$1(function BaseInput(_ref14, ref) {
  var _ref14$size = _ref14.size,
      size = _ref14$size === void 0 ? "md" : _ref14$size,
      _ref14$isInvalid = _ref14.isInvalid,
      isInvalid = _ref14$isInvalid === void 0 ? false : _ref14$isInvalid,
      _ref14$isDisabled = _ref14.isDisabled,
      isDisabled = _ref14$isDisabled === void 0 ? false : _ref14$isDisabled,
      _ref14$isRequired = _ref14.isRequired,
      isRequired = _ref14$isRequired === void 0 ? false : _ref14$isRequired,
      label = _ref14.label,
      labelProps = _ref14.labelProps,
      focusBorderColor = _ref14.focusBorderColor,
      formControlProps = _ref14.formControlProps,
      formErrorMessage = _ref14.formErrorMessage,
      formErrorMessageProps = _ref14.formErrorMessageProps,
      helperText = _ref14.helperText,
      helperTextProps = _ref14.helperTextProps,
      rest = _objectWithoutProperties(_ref14, ["size", "isInvalid", "isDisabled", "isRequired", "label", "labelProps", "focusBorderColor", "formControlProps", "formErrorMessage", "formErrorMessageProps", "helperText", "helperTextProps"]);

  var borderColor = focusBorderColor || (isInvalid ? TapTheme.colors.red["500"] : TapTheme.colors.blue["500"]);
  var renderFormLabel = typeof label === "string" ? React__default.createElement(FormLabel, _objectSpread({
    size: size
  }, labelProps), label) : label;
  var renderFormErrorMessage = formErrorMessage && React__default.createElement(FormErrorMessage, _objectSpread({
    disabled: isDisabled,
    size: size
  }, formErrorMessageProps), formErrorMessage);
  var renderFormHelperText = !isInvalid && helperText && React__default.createElement(FormHelperText, _objectSpread({}, helperTextProps), helperText);
  return React__default.createElement(FormControl, _objectSpread({
    isInvalid: isInvalid,
    isDisabled: isDisabled,
    isRequired: isRequired,
    size: size
  }, formControlProps), renderFormLabel, React__default.createElement(Input$1, _objectSpread({
    ref: ref,
    focusBorderColor: borderColor,
    size: size
  }, rest)), renderFormErrorMessage, renderFormHelperText);
});
var InputWithElements = forwardRef$1(function BaseInputWithElements(_ref15, ref) {
  var leftElement = _ref15.leftElement,
      _ref15$leftElementCol = _ref15.leftElementColor,
      leftElementColor = _ref15$leftElementCol === void 0 ? TapTheme.colors.gray["300"] : _ref15$leftElementCol,
      leftElementProps = _ref15.leftElementProps,
      rightElement = _ref15.rightElement,
      _ref15$rightElementCo = _ref15.rightElementColor,
      rightElementColor = _ref15$rightElementCo === void 0 ? TapTheme.colors.gray["300"] : _ref15$rightElementCo,
      rightElementProps = _ref15.rightElementProps,
      inputGroupProps = _ref15.inputGroupProps,
      formControlProps = _ref15.formControlProps,
      _ref15$size = _ref15.size,
      size = _ref15$size === void 0 ? "md" : _ref15$size,
      _ref15$isInvalid = _ref15.isInvalid,
      isInvalid = _ref15$isInvalid === void 0 ? false : _ref15$isInvalid,
      _ref15$isDisabled = _ref15.isDisabled,
      isDisabled = _ref15$isDisabled === void 0 ? false : _ref15$isDisabled,
      _ref15$isRequired = _ref15.isRequired,
      isRequired = _ref15$isRequired === void 0 ? false : _ref15$isRequired,
      label = _ref15.label,
      labelProps = _ref15.labelProps,
      focusBorderColor = _ref15.focusBorderColor,
      formErrorMessage = _ref15.formErrorMessage,
      formErrorMessageProps = _ref15.formErrorMessageProps,
      helperText = _ref15.helperText,
      helperTextProps = _ref15.helperTextProps,
      rest = _objectWithoutProperties(_ref15, ["leftElement", "leftElementColor", "leftElementProps", "rightElement", "rightElementColor", "rightElementProps", "inputGroupProps", "formControlProps", "size", "isInvalid", "isDisabled", "isRequired", "label", "labelProps", "focusBorderColor", "formErrorMessage", "formErrorMessageProps", "helperText", "helperTextProps"]);

  var borderColor = focusBorderColor || (isInvalid ? "red.500" : "blue.500");
  var renderFormLabel = typeof label === "string" ? React__default.createElement(FormLabel, _objectSpread({
    size: size
  }, labelProps), label) : label;
  var renderFormErrorMessage = formErrorMessage && React__default.createElement(FormErrorMessage, _objectSpread({
    disabled: isDisabled,
    size: size
  }, formErrorMessageProps), formErrorMessage);
  var renderFormHelperText = !isInvalid && helperText && React__default.createElement(FormHelperText, _objectSpread({}, helperTextProps), helperText);
  var LeftElementWrapper = leftElement ? React__default.createElement(Box$2, {
    display: "inline-flex",
    color: leftElementColor
  }, leftElement) : null;
  var RightElementWrapper = rightElement ? React__default.createElement(Box$2, {
    display: "inline-flex",
    color: rightElementColor
  }, rightElement) : null;
  var inputPaddingValues = {
    xs: 8,
    sm: 8,
    md: 10,
    lg: 12
  };
  var elementPaddingValues = {
    xs: 0,
    sm: 0,
    md: 2,
    lg: 2
  };
  return React__default.createElement(FormControl, _objectSpread({
    isInvalid: isInvalid,
    isDisabled: isDisabled,
    isRequired: isRequired,
    size: size
  }, formControlProps), renderFormLabel, React__default.createElement(InputGroup, _objectSpread({}, inputGroupProps), LeftElementWrapper && React__default.createElement(InputLeftElement, _objectSpread({
    pl: elementPaddingValues[size],
    h: "100%",
    pointerEvents: "none",
    children: LeftElementWrapper
  }, leftElementProps)), React__default.createElement(Input$1, _objectSpread({
    pl: LeftElementWrapper ? inputPaddingValues[size] : 2,
    pr: RightElementWrapper ? inputPaddingValues[size] : 2,
    size: size,
    focusBorderColor: borderColor,
    ref: ref
  }, rest)), RightElementWrapper && React__default.createElement(InputRightElement, _objectSpread({
    pr: elementPaddingValues[size],
    h: "100%",
    pointerEvents: "none",
    children: RightElementWrapper
  }, rightElementProps))), renderFormErrorMessage, renderFormHelperText);
});
var ButtonStyles = {
  baseStyle: {
    borderRadius: "md",
    boxShadow: "none",
    fontWeight: "medium",
    lineHeight: 1,
    _disabled: {
      opacity: 0.5
    }
  },
  sizes: {
    xs: {
      fontSize: "12px",
      height: "24px"
    },
    sm: {
      fontSize: "14px",
      height: "32px"
    },
    md: {
      fontSize: "16px",
      height: "40px"
    },
    lg: {
      fontSize: "18px",
      height: "48px"
    }
  },
  variants: {
    solid: function solid(props) {
      var c = props.colorScheme;
      return {
        bg: "".concat(c, ".500"),
        color: "white",
        _hover: {
          bg: "".concat(c, ".600")
        },
        _active: {
          bg: "".concat(c, ".700")
        }
      };
    },
    subtle: function subtle(props) {
      var c = props.colorScheme;
      return {
        bg: "".concat(c, ".100"),
        color: "".concat(c, ".600"),
        _hover: {
          bg: "".concat(c, ".50")
        },
        _active: {
          bg: "".concat(c, ".300")
        }
      };
    },
    outline: function outline(props) {
      var c = props.colorScheme;
      return {
        bg: "transparent",
        color: "".concat(c, ".500"),
        _hover: {
          bg: "".concat(c, ".100")
        },
        _active: {
          bg: "".concat(c, ".200")
        }
      };
    },
    ghost: function ghost(props) {
      var c = props.colorScheme;
      return {
        bg: "transparent",
        color: "".concat(c, ".500"),
        _hover: {
          bg: "".concat(c, ".100")
        },
        _active: {
          bg: "".concat(c, ".200")
        }
      };
    }
  },
  defaultProps: {
    size: "md",
    variant: "solid",
    colorScheme: "blue"
  }
};
var Button = forwardRef$1(function BaseButton(_ref16, ref) {
  var children = _ref16.children,
      rest = _objectWithoutProperties(_ref16, ["children"]);

  return React__default.createElement(Button$1, _objectSpread({
    ref: ref
  }, rest), children);
});

var Progress = function Progress(_ref17) {
  var props = _extends3({}, _ref17);

  return React__default.createElement(Progress$1, _objectSpread({}, props));
};

var ProgressStyles = {
  variants: {
    light: function light(props) {
      return {
        filledTrack: {
          backgroundColor: "".concat(props.colorScheme, ".300")
        }
      };
    }
  }
};
var breakpoints = createBreakpoints(mediaBreakpoints.down);
var config = {
  useSystemColorMode: false,
  initialColorMode: "light"
};
var theme = extendTheme(_objectSpread({}, TapTheme, {
  breakpoints: breakpoints,
  components: {
    Input: InputStyles,
    Button: ButtonStyles,
    IconButton: ButtonStyles,
    Progress: ProgressStyles,
    FormLabel: FormLabelStyles,
    FormError: FormErrorMessageStyles,
    Form: FormControlStyles
  },
  config: config,
  styles: {
    global: {
      body: {
        lineHeight: TapTheme.lineHeights.normal,
        fontWeight: TapTheme.fontWeights.normal,
        color: TapTheme.colors.black,
        WebkitFontSmoothing: "antialiased"
      }
    }
  }
}), theme$1);

var GlobalStyles = function GlobalStyles() {
  return React__default.createElement(Global, {
    styles: css$1(_templateObject())
  });
};

var LegacyThemeProvider = function LegacyThemeProvider(_ref18) {
  var children = _ref18.children;
  return React__default.createElement(ChakraProvider, {
    theme: theme,
    resetCSS: true
  }, React__default.createElement(GlobalStyles, null), React__default.createElement(ThemeProvider, {
    theme: TapTheme
  }, children));
};

var TapThemeProvider = function TapThemeProvider(_ref19) {
  var children = _ref19.children,
      _ref19$resetCSS = _ref19.resetCSS,
      resetCSS = _ref19$resetCSS === void 0 ? true : _ref19$resetCSS,
      _ref19$noGlobalStyles = _ref19.noGlobalStyles,
      noGlobalStyles = _ref19$noGlobalStyles === void 0 ? false : _ref19$noGlobalStyles;
  return React__default.createElement(MantineProvider, {
    withNormalizeCSS: resetCSS,
    withGlobalStyles: !noGlobalStyles,
    theme: MantineTheme
  }, React__default.createElement(ChakraProvider, {
    theme: theme,
    resetCSS: resetCSS
  }, !noGlobalStyles && React__default.createElement(GlobalStyles, null), React__default.createElement(ThemeProvider$1, {
    theme: TapTheme
  }, children)));
};

var TapGrid = forwardRef$1(function BaseGrid(_ref20, ref) {
  var children = _ref20.children,
      _ref20$noRespond = _ref20.noRespond,
      noRespond = _ref20$noRespond === void 0 ? false : _ref20$noRespond,
      _ref20$useMotion = _ref20.useMotion,
      useMotion = _ref20$useMotion === void 0 ? false : _ref20$useMotion,
      rest = _objectWithoutProperties(_ref20, ["children", "noRespond", "useMotion"]);

  var GridElement = useMotion ? motion(Grid$1) : Grid$1;
  return React__default.createElement(GridElement, _objectSpread({
    ref: ref,
    px: noRespond ? "6" : {
      base: "4",
      md: "6"
    },
    gap: noRespond ? "4" : {
      base: "2.5",
      md: "4"
    },
    templateColumns: noRespond ? "repeat(8, 1fr)" : {
      base: "repeat(4, 1fr)",
      md: "repeat(8, 1fr)"
    }
  }, rest), children);
});
var TapGridItem = forwardRef$1(function BaseGridItem(_ref21, ref) {
  var _ref21$noRespond = _ref21.noRespond,
      noRespond = _ref21$noRespond === void 0 ? false : _ref21$noRespond,
      props = _objectWithoutProperties(_ref21, ["noRespond"]);

  return React__default.createElement(GridItem, _objectSpread({
    ref: ref,
    colSpan: noRespond ? 8 : {
      base: 4,
      md: 8
    }
  }, props));
});
var DefaultContext = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
};
var IconContext = React__default.createContext && React__default.createContext(DefaultContext);

var __assign = globalThis && globalThis.__assign || function () {
  __assign = Object.assign || function (t2) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t2[p] = s[p];
      }
    }

    return t2;
  };

  return __assign.apply(this, arguments);
};

var __rest = globalThis && globalThis.__rest || function (s, e) {
  var t2 = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t2[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t2[p[i]] = s[p[i]];
  }
  return t2;
};

function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return React__default.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}

function GenIcon(data) {
  return function (props) {
    return React__default.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}

function IconBase(props) {
  var elem = function elem(conf) {
    var attr = props.attr,
        size = props.size,
        title = props.title,
        svgProps = __rest(props, ["attr", "size", "title"]);

    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + " " : "") + props.className;
    return React__default.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && React__default.createElement("title", null, title), props.children);
  };

  return IconContext !== void 0 ? React__default.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}

function AiOutlineApi(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 1024 1024"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 0 0-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 0 0 0 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4-186.8-186.8 59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7 35.3 0 68.4 13.7 93.4 38.7 24.9 24.9 38.7 58.1 38.7 93.4 0 35.3-13.8 68.4-38.7 93.4zm-190.2 105a8.03 8.03 0 0 0-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 0 0-11.3 0L363 475.3l-43-43a7.85 7.85 0 0 0-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 69-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 0 0 0 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 0 1-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7a131.32 131.32 0 0 1-38.7-93.4c0-35.3 13.7-68.4 38.7-93.4l59.4-59.4 186.8 186.8-59.4 59.4z"
      }
    }]
  })(props);
}

function AiOutlineCamera(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 1024 1024"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M864 248H728l-32.4-90.8a32.07 32.07 0 0 0-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80zm8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8v456zM512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"
      }
    }]
  })(props);
}

function AiOutlineEdit(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 1024 1024"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z"
      }
    }]
  })(props);
}

function AiOutlineMenu(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 1024 1024"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z"
      }
    }]
  })(props);
}

function AiOutlinePushpin(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 1024 1024"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3a33.23 33.23 0 0 0-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8zM666.2 549.3l-24.5 24.5 3.8 34.4a259.92 259.92 0 0 1-30.4 153.9L262 408.8c12.9-7.1 26.3-13.1 40.3-17.9 27.2-9.4 55.7-14.1 84.7-14.1 9.6 0 19.3.5 28.9 1.6l34.4 3.8 24.5-24.5L608.5 224 800 415.5 666.2 549.3z"
      }
    }]
  })(props);
}

function IoIosCash(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M466 355.9H46c-7.7 0-14 6.3-14 14s6.3 14 14 14h420c7.7 0 14-6.3 14-14s-6.3-14-14-14zM466 403.9H46c-7.7 0-14 6.3-14 14s6.3 14 14 14h420c7.7 0 14-6.3 14-14s-6.3-14-14-14zM444.9 80.1H67.1C47.8 80.1 32 95.9 32 115.2V293c0 19.3 15.8 35.1 35.1 35.1h377.8c19.3 0 35.1-15.8 35.1-35.1V115.2c0-19.3-15.8-35.1-35.1-35.1zM114 296.1H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm0-156H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm142 144c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm178 12h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm0-156h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "256",
        "cy": "206",
        "r": "53"
      }
    }]
  })(props);
}

function IoIosStats(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M184 448h48c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v368c0 4.4 3.6 8 8 8zM88 448h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8zM280.1 448h47.8c4.5 0 8.1-3.6 8.1-8.1V232.1c0-4.5-3.6-8.1-8.1-8.1h-47.8c-4.5 0-8.1 3.6-8.1 8.1v207.8c0 4.5 3.6 8.1 8.1 8.1zM368 136.1v303.8c0 4.5 3.6 8.1 8.1 8.1h47.8c4.5 0 8.1-3.6 8.1-8.1V136.1c0-4.5-3.6-8.1-8.1-8.1h-47.8c-4.5 0-8.1 3.6-8.1 8.1z"
      }
    }]
  })(props);
}

function IoMdGlobe(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M256 48C141.124 48 48 141.125 48 256s93.124 208 208 208c114.875 0 208-93.125 208-208S370.875 48 256 48zm-21.549 384.999c-39.464-4.726-75.978-22.392-104.519-50.932C96.258 348.393 77.714 303.622 77.714 256c0-42.87 15.036-83.424 42.601-115.659.71 8.517 2.463 17.648 2.014 24.175-1.64 23.795-3.988 38.687 9.94 58.762 5.426 7.819 6.759 19.028 9.4 28.078 2.583 8.854 12.902 13.498 20.019 18.953 14.359 11.009 28.096 23.805 43.322 33.494 10.049 6.395 16.326 9.576 13.383 21.839-2.367 9.862-3.028 15.937-8.13 24.723-1.557 2.681 5.877 19.918 8.351 22.392 7.498 7.497 14.938 14.375 23.111 21.125 12.671 10.469-1.231 24.072-7.274 39.117zm147.616-50.932c-25.633 25.633-57.699 42.486-92.556 49.081 4.94-12.216 13.736-23.07 21.895-29.362 7.097-5.476 15.986-16.009 19.693-24.352 3.704-8.332 8.611-15.555 13.577-23.217 7.065-10.899-17.419-27.336-25.353-30.781-17.854-7.751-31.294-18.21-47.161-29.375-11.305-7.954-34.257 4.154-47.02-1.417-17.481-7.633-31.883-20.896-47.078-32.339-15.68-11.809-14.922-25.576-14.922-42.997 12.282.453 29.754-3.399 37.908 6.478 2.573 3.117 11.42 17.042 17.342 12.094 4.838-4.043-3.585-20.249-5.212-24.059-5.005-11.715 11.404-16.284 19.803-24.228 10.96-10.364 34.47-26.618 32.612-34.047s-23.524-28.477-36.249-25.193c-1.907.492-18.697 18.097-21.941 20.859.086-5.746.172-11.491.26-17.237.055-3.628-6.768-7.352-6.451-9.692.8-5.914 17.262-16.647 21.357-21.357-2.869-1.793-12.659-10.202-15.622-8.968-7.174 2.99-15.276 5.05-22.45 8.039 0-2.488-.302-4.825-.662-7.133a176.585 176.585 0 0 1 45.31-13.152l14.084 5.66 9.944 11.801 9.924 10.233 8.675 2.795 13.779-12.995L282 87.929V79.59c27.25 3.958 52.984 14.124 75.522 29.8-4.032.361-8.463.954-13.462 1.59-2.065-1.22-4.714-1.774-6.965-2.623 6.531 14.042 13.343 27.89 20.264 41.746 7.393 14.801 23.793 30.677 26.673 46.301 3.394 18.416 1.039 35.144 2.896 56.811 1.788 20.865 23.524 44.572 23.524 44.572s10.037 3.419 18.384 2.228c-7.781 30.783-23.733 59.014-46.769 82.052z"
      }
    }]
  })(props);
}

function IoMdGrid(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M409.6 64H102.4C81.3 64 64 81.3 64 102.4v307.2c0 21.1 17.3 38.4 38.4 38.4h307.2c21.1 0 38.4-17.3 38.4-38.4V102.4c0-21.1-17.3-38.4-38.4-38.4zM179.2 409.6h-76.8v-76.8h76.8v76.8zm0-115.2h-76.8v-76.8h76.8v76.8zm0-115.2h-76.8v-76.8h76.8v76.8zm115.2 230.4h-76.8v-76.8h76.8v76.8zm0-115.2h-76.8v-76.8h76.8v76.8zm0-115.2h-76.8v-76.8h76.8v76.8zm115.2 230.4h-76.8v-76.8h76.8v76.8zm0-115.2h-76.8v-76.8h76.8v76.8zm0-115.2h-76.8v-76.8h76.8v76.8z"
      }
    }]
  })(props);
}

function IoMdInformationCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M256 48C141.2 48 48 141.2 48 256s93.2 208 208 208 208-93.2 208-208S370.8 48 256 48zm21 312h-42V235h42v125zm0-166h-42v-42h42v42z"
      }
    }]
  })(props);
}

function IoMdOpen(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M405.34 405.332H106.66V106.668H240V64H106.66C83.191 64 64 83.197 64 106.668v298.664C64 428.803 83.191 448 106.66 448h298.68c23.469 0 42.66-19.197 42.66-42.668V272h-42.66v133.332zM288 64v42.668h87.474L159.999 322.133l29.866 29.866 215.476-215.47V224H448V64H288z"
      }
    }]
  })(props);
}

function IoAlertCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm0 319.91a20 20 0 1120-20 20 20 0 01-20 20zm21.72-201.15l-5.74 122a16 16 0 01-32 0l-5.74-121.94v-.05a21.74 21.74 0 1143.44 0z"
      }
    }]
  })(props);
}

function IoApps(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M104 160a56 56 0 1156-56 56.06 56.06 0 01-56 56zm152 0a56 56 0 1156-56 56.06 56.06 0 01-56 56zm152 0a56 56 0 1156-56 56.06 56.06 0 01-56 56zM104 312a56 56 0 1156-56 56.06 56.06 0 01-56 56zm152 0a56 56 0 1156-56 56.06 56.06 0 01-56 56zm152 0a56 56 0 1156-56 56.06 56.06 0 01-56 56zM104 464a56 56 0 1156-56 56.06 56.06 0 01-56 56zm152 0a56 56 0 1156-56 56.06 56.06 0 01-56 56zm152 0a56 56 0 1156-56 56.06 56.06 0 01-56 56z"
      }
    }]
  })(props);
}

function IoBulb(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M288 464h-64a16 16 0 000 32h64a16 16 0 000-32zm16-48h-96a16 16 0 000 32h96a16 16 0 000-32zm65.42-353.31C339.35 32.58 299.07 16 256 16A159.62 159.62 0 0096 176c0 46.62 17.87 90.23 49 119.64l4.36 4.09C167.37 316.57 192 339.64 192 360v24a16 16 0 0016 16h24a8 8 0 008-8V274.82a8 8 0 00-5.13-7.47A130.73 130.73 0 01208.71 253a16 16 0 1118.58-26c7.4 5.24 21.65 13 28.71 13s21.31-7.78 28.73-13a16 16 0 0118.56 26 130.73 130.73 0 01-26.16 14.32 8 8 0 00-5.13 7.47V392a8 8 0 008 8h24a16 16 0 0016-16v-24c0-19.88 24.36-42.93 42.15-59.77l4.91-4.66C399.08 265 416 223.61 416 176a159.16 159.16 0 00-46.58-113.31z"
      }
    }]
  })(props);
}

function IoBusiness(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M432 176H320V64a48 48 0 00-48-48H80a48 48 0 00-48 48v416a16 16 0 0016 16h104a8 8 0 008-8v-71.55c0-8.61 6.62-16 15.23-16.43A16 16 0 01192 416v72a8 8 0 008 8h264a16 16 0 0016-16V224a48 48 0 00-48-48zM98.08 431.87a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm80 240a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm80 320a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zm0-80a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zM444 464H320V208h112a16 16 0 0116 16v236a4 4 0 01-4 4z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M400 400a16 16 0 1016 16 16 16 0 00-16-16zm0-80a16 16 0 1016 16 16 16 0 00-16-16zm0-80a16 16 0 1016 16 16 16 0 00-16-16zm-64 160a16 16 0 1016 16 16 16 0 00-16-16zm0-80a16 16 0 1016 16 16 16 0 00-16-16zm0-80a16 16 0 1016 16 16 16 0 00-16-16z"
      }
    }]
  })(props);
}

function IoCaretDownCircleOutline(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M342.43 238.23l-74.13 89.09a16 16 0 01-24.6 0l-74.13-89.09A16 16 0 01181.86 212h148.28a16 16 0 0112.29 26.23z"
      }
    }, {
      "tag": "path",
      "attr": {
        "fill": "none",
        "strokeMiterlimit": "10",
        "strokeWidth": "32",
        "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
      }
    }]
  })(props);
}

function IoCaretDownCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208zm-121.57-17.77l-74.13 89.09a16 16 0 01-24.6 0l-74.13-89.09A16 16 0 01181.86 212h148.28a16 16 0 0112.29 26.23z"
      }
    }]
  })(props);
}

function IoCaretDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M98 190.06l139.78 163.12a24 24 0 0036.44 0L414 190.06c13.34-15.57 2.28-39.62-18.22-39.62h-279.6c-20.5 0-31.56 24.05-18.18 39.62z"
      }
    }]
  })(props);
}

function IoCaretUpCircleOutline(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M342.43 273.77l-74.13-89.09a16 16 0 00-24.6 0l-74.13 89.09A16 16 0 00181.86 300h148.28a16 16 0 0012.29-26.23z"
      }
    }, {
      "tag": "path",
      "attr": {
        "fill": "none",
        "strokeMiterlimit": "10",
        "strokeWidth": "32",
        "d": "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
      }
    }]
  })(props);
}

function IoCaretUpCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M256 48C141.13 48 48 141.13 48 256s93.13 208 208 208 208-93.13 208-208S370.87 48 256 48zm74.14 252H181.86a16 16 0 01-12.29-26.23l74.13-89.09a16 16 0 0124.6 0l74.13 89.09A16 16 0 01330.14 300z"
      }
    }]
  })(props);
}

function IoCaretUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M414 321.94L274.22 158.82a24 24 0 00-36.44 0L98 321.94c-13.34 15.57-2.28 39.62 18.22 39.62h279.6c20.5 0 31.56-24.05 18.18-39.62z"
      }
    }]
  })(props);
}

function IoCheckmarkCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm108.25 138.29l-134.4 160a16 16 0 01-12 5.71h-.27a16 16 0 01-11.89-5.3l-57.6-64a16 16 0 1123.78-21.4l45.29 50.32 122.59-145.91a16 16 0 0124.5 20.58z"
      }
    }]
  })(props);
}

function IoCloseCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm75.31 260.69a16 16 0 11-22.62 22.62L256 278.63l-52.69 52.68a16 16 0 01-22.62-22.62L233.37 256l-52.68-52.69a16 16 0 0122.62-22.62L256 233.37l52.69-52.68a16 16 0 0122.62 22.62L278.63 256z"
      }
    }]
  })(props);
}

function IoClose(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"
      }
    }]
  })(props);
}

function IoCopyOutline(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "width": "336",
        "height": "336",
        "x": "128",
        "y": "128",
        "fill": "none",
        "strokeLinejoin": "round",
        "strokeWidth": "32",
        "rx": "57",
        "ry": "57"
      }
    }, {
      "tag": "path",
      "attr": {
        "fill": "none",
        "strokeLinecap": "round",
        "strokeLinejoin": "round",
        "strokeWidth": "32",
        "d": "M383.5 128l.5-24a56.16 56.16 0 00-56-56H112a64.19 64.19 0 00-64 64v216a56.16 56.16 0 0056 56h24"
      }
    }]
  })(props);
}

function IoCreateOutline(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "fill": "none",
        "strokeLinecap": "round",
        "strokeLinejoin": "round",
        "strokeWidth": "32",
        "d": "M384 224v184a40 40 0 01-40 40H104a40 40 0 01-40-40V168a40 40 0 0140-40h167.48"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M459.94 53.25a16.06 16.06 0 00-23.22-.56L424.35 65a8 8 0 000 11.31l11.34 11.32a8 8 0 0011.34 0l12.06-12c6.1-6.09 6.67-16.01.85-22.38zM399.34 90L218.82 270.2a9 9 0 00-2.31 3.93L208.16 299a3.91 3.91 0 004.86 4.86l24.85-8.35a9 9 0 003.93-2.31L422 112.66a9 9 0 000-12.66l-9.95-10a9 9 0 00-12.71 0z"
      }
    }]
  })(props);
}

function IoDiamondOutline(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "fill": "none",
        "strokeLinecap": "round",
        "strokeLinejoin": "round",
        "strokeWidth": "32",
        "d": "M35.42 188.21l207.75 269.46a16.17 16.17 0 0025.66 0l207.75-269.46a16.52 16.52 0 00.95-18.75L407.06 55.71A16.22 16.22 0 00393.27 48H118.73a16.22 16.22 0 00-13.79 7.71L34.47 169.46a16.52 16.52 0 00.95 18.75zM48 176h416"
      }
    }, {
      "tag": "path",
      "attr": {
        "fill": "none",
        "strokeLinecap": "round",
        "strokeLinejoin": "round",
        "strokeWidth": "32",
        "d": "M400 64l-48 112-96-128M112 64l48 112 96-128m0 400l-96-272m96 272l96-272"
      }
    }]
  })(props);
}

function IoEllipsisHorizontal(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "256",
        "cy": "256",
        "r": "48"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "416",
        "cy": "256",
        "r": "48"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "96",
        "cy": "256",
        "r": "48"
      }
    }]
  })(props);
}

function IoGrid(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M204 240H68a36 36 0 01-36-36V68a36 36 0 0136-36h136a36 36 0 0136 36v136a36 36 0 01-36 36zm240 0H308a36 36 0 01-36-36V68a36 36 0 0136-36h136a36 36 0 0136 36v136a36 36 0 01-36 36zM204 480H68a36 36 0 01-36-36V308a36 36 0 0136-36h136a36 36 0 0136 36v136a36 36 0 01-36 36zm240 0H308a36 36 0 01-36-36V308a36 36 0 0136-36h136a36 36 0 0136 36v136a36 36 0 01-36 36z"
      }
    }]
  })(props);
}

function IoInfinite(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "fill": "none",
        "strokeLinecap": "round",
        "strokeMiterlimit": "10",
        "strokeWidth": "48",
        "d": "M256 256s-48-96-126-96c-54.12 0-98 43-98 96s43.88 96 98 96c30 0 56.45-13.18 78-32m48-64s48 96 126 96c54.12 0 98-43 98-96s-43.88-96-98-96c-29.37 0-56.66 13.75-78 32"
      }
    }]
  })(props);
}

function IoPeople(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M336 256c-20.56 0-40.44-9.18-56-25.84-15.13-16.25-24.37-37.92-26-61-1.74-24.62 5.77-47.26 21.14-63.76S312 80 336 80c23.83 0 45.38 9.06 60.7 25.52 15.47 16.62 23 39.22 21.26 63.63-1.67 23.11-10.9 44.77-26 61C376.44 246.82 356.57 256 336 256zm66-88zm65.83 264H204.18a27.71 27.71 0 01-22-10.67 30.22 30.22 0 01-5.26-25.79c8.42-33.81 29.28-61.85 60.32-81.08C264.79 297.4 299.86 288 336 288c36.85 0 71 9 98.71 26.05 31.11 19.13 52 47.33 60.38 81.55a30.27 30.27 0 01-5.32 25.78A27.68 27.68 0 01467.83 432zM147 260c-35.19 0-66.13-32.72-69-72.93-1.42-20.6 5-39.65 18-53.62 12.86-13.83 31-21.45 51-21.45s38 7.66 50.93 21.57c13.1 14.08 19.5 33.09 18 53.52-2.87 40.2-33.8 72.91-68.93 72.91zm65.66 31.45c-17.59-8.6-40.42-12.9-65.65-12.9-29.46 0-58.07 7.68-80.57 21.62-25.51 15.83-42.67 38.88-49.6 66.71a27.39 27.39 0 004.79 23.36A25.32 25.32 0 0041.72 400h111a8 8 0 007.87-6.57c.11-.63.25-1.26.41-1.88 8.48-34.06 28.35-62.84 57.71-83.82a8 8 0 00-.63-13.39c-1.57-.92-3.37-1.89-5.42-2.89z"
      }
    }]
  })(props);
}

function IoPersonCircleOutline(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M258.9 48C141.92 46.42 46.42 141.92 48 258.9c1.56 112.19 92.91 203.54 205.1 205.1 117 1.6 212.48-93.9 210.88-210.88C462.44 140.91 371.09 49.56 258.9 48zm126.42 327.25a4 4 0 01-6.14-.32 124.27 124.27 0 00-32.35-29.59C321.37 329 289.11 320 256 320s-65.37 9-90.83 25.34a124.24 124.24 0 00-32.35 29.58 4 4 0 01-6.14.32A175.32 175.32 0 0180 259c-1.63-97.31 78.22-178.76 175.57-179S432 158.81 432 256a175.32 175.32 0 01-46.68 119.25z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M256 144c-19.72 0-37.55 7.39-50.22 20.82s-19 32-17.57 51.93C191.11 256 221.52 288 256 288s64.83-32 67.79-71.24c1.48-19.74-4.8-38.14-17.68-51.82C293.39 151.44 275.59 144 256 144z"
      }
    }]
  })(props);
}

function IoPersonCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm-50.22 116.82C218.45 151.39 236.28 144 256 144s37.39 7.44 50.11 20.94c12.89 13.68 19.16 32.06 17.68 51.82C320.83 256 290.43 288 256 288s-64.89-32-67.79-71.25c-1.47-19.92 4.79-38.36 17.57-51.93zM256 432a175.49 175.49 0 01-126-53.22 122.91 122.91 0 0135.14-33.44C190.63 329 222.89 320 256 320s65.37 9 90.83 25.34A122.87 122.87 0 01382 378.78 175.45 175.45 0 01256 432z"
      }
    }]
  })(props);
}

function IoPerson(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M332.64 64.58C313.18 43.57 286 32 256 32c-30.16 0-57.43 11.5-76.8 32.38-19.58 21.11-29.12 49.8-26.88 80.78C156.76 206.28 203.27 256 256 256s99.16-49.71 103.67-110.82c2.27-30.7-7.33-59.33-27.03-80.6zM432 480H80a31 31 0 01-24.2-11.13c-6.5-7.77-9.12-18.38-7.18-29.11C57.06 392.94 83.4 353.61 124.8 326c36.78-24.51 83.37-38 131.2-38s94.42 13.5 131.2 38c41.4 27.6 67.74 66.93 76.18 113.75 1.94 10.73-.68 21.34-7.18 29.11A31 31 0 01432 480z"
      }
    }]
  })(props);
}

function IoPulse(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M432 272a48.09 48.09 0 00-45.25 32h-39.22l-28.35-85.06a16 16 0 00-30.56.66l-44.51 155.76-52.33-314a16 16 0 00-31.3-1.25L99.51 304H48a16 16 0 000 32h64a16 16 0 0015.52-12.12l45.34-181.37 51.36 308.12A16 16 0 00239.1 464h.91a16 16 0 0015.37-11.6l49.8-174.28 15.64 46.94A16 16 0 00336 336h50.75A48 48 0 10432 272z"
      }
    }]
  })(props);
}

function IoReaderOutline(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "width": "320",
        "height": "416",
        "x": "96",
        "y": "48",
        "fill": "none",
        "strokeLinejoin": "round",
        "strokeWidth": "32",
        "rx": "48",
        "ry": "48"
      }
    }, {
      "tag": "path",
      "attr": {
        "fill": "none",
        "strokeLinecap": "round",
        "strokeLinejoin": "round",
        "strokeWidth": "32",
        "d": "M176 128h160m-160 80h160m-160 80h80"
      }
    }]
  })(props);
}

function IoSettingsOutline(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "fill": "none",
        "strokeLinecap": "round",
        "strokeLinejoin": "round",
        "strokeWidth": "32",
        "d": "M262.29 192.31a64 64 0 1057.4 57.4 64.13 64.13 0 00-57.4-57.4zM416.39 256a154.34 154.34 0 01-1.53 20.79l45.21 35.46a10.81 10.81 0 012.45 13.75l-42.77 74a10.81 10.81 0 01-13.14 4.59l-44.9-18.08a16.11 16.11 0 00-15.17 1.75A164.48 164.48 0 01325 400.8a15.94 15.94 0 00-8.82 12.14l-6.73 47.89a11.08 11.08 0 01-10.68 9.17h-85.54a11.11 11.11 0 01-10.69-8.87l-6.72-47.82a16.07 16.07 0 00-9-12.22 155.3 155.3 0 01-21.46-12.57 16 16 0 00-15.11-1.71l-44.89 18.07a10.81 10.81 0 01-13.14-4.58l-42.77-74a10.8 10.8 0 012.45-13.75l38.21-30a16.05 16.05 0 006-14.08c-.36-4.17-.58-8.33-.58-12.5s.21-8.27.58-12.35a16 16 0 00-6.07-13.94l-38.19-30A10.81 10.81 0 0149.48 186l42.77-74a10.81 10.81 0 0113.14-4.59l44.9 18.08a16.11 16.11 0 0015.17-1.75A164.48 164.48 0 01187 111.2a15.94 15.94 0 008.82-12.14l6.73-47.89A11.08 11.08 0 01213.23 42h85.54a11.11 11.11 0 0110.69 8.87l6.72 47.82a16.07 16.07 0 009 12.22 155.3 155.3 0 0121.46 12.57 16 16 0 0015.11 1.71l44.89-18.07a10.81 10.81 0 0113.14 4.58l42.77 74a10.8 10.8 0 01-2.45 13.75l-38.21 30a16.05 16.05 0 00-6.05 14.08c.33 4.14.55 8.3.55 12.47z"
      }
    }]
  })(props);
}

function IoShareSocialSharp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M378 324a69.78 69.78 0 00-48.83 19.91L202 272.41a69.68 69.68 0 000-32.82l127.13-71.5A69.76 69.76 0 10308.87 129l-130.13 73.2a70 70 0 100 107.56L308.87 383A70 70 0 10378 324z"
      }
    }]
  })(props);
}

function IoShieldCheckmarkOutline(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "fill": "none",
        "strokeLinecap": "round",
        "strokeLinejoin": "round",
        "strokeWidth": "32",
        "d": "M336 176L225.2 304 176 255.8"
      }
    }, {
      "tag": "path",
      "attr": {
        "fill": "none",
        "strokeLinecap": "round",
        "strokeLinejoin": "round",
        "strokeWidth": "32",
        "d": "M463.1 112.37C373.68 96.33 336.71 84.45 256 48c-80.71 36.45-117.68 48.33-207.1 64.37C32.7 369.13 240.58 457.79 256 464c15.42-6.21 223.3-94.87 207.1-351.63z"
      }
    }]
  })(props);
}

function IoStarHalf(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "fill": "none",
        "strokeLinejoin": "round",
        "strokeWidth": "32",
        "d": "M480 208H308L256 48l-52 160H32l140 96-54 160 138-100 138 100-54-160z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M256 48v316L118 464l54-160-140-96h172l52-160z"
      }
    }]
  })(props);
}

function IoSwapVerticalOutline(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "fill": "none",
        "strokeLinecap": "round",
        "strokeLinejoin": "round",
        "strokeWidth": "32",
        "d": "M464 208L352 96 240 208m112-94.87V416M48 304l112 112 112-112m-112 94V96"
      }
    }]
  })(props);
}

function IoTimeOutline(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "fill": "none",
        "strokeMiterlimit": "10",
        "strokeWidth": "32",
        "d": "M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z"
      }
    }, {
      "tag": "path",
      "attr": {
        "fill": "none",
        "strokeLinecap": "round",
        "strokeLinejoin": "round",
        "strokeWidth": "32",
        "d": "M256 128v144h96"
      }
    }]
  })(props);
}

function IoTimer(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M256 48C141.12 48 48 141.12 48 256s93.12 208 208 208 208-93.12 208-208S370.88 48 256 48zm-82.33 114.34l105 71a32.5 32.5 0 01-37.25 53.26 33.21 33.21 0 01-8-8l-71-105a8.13 8.13 0 0111.32-11.32zM256 432c-97 0-176-78.95-176-176a174.55 174.55 0 0153.87-126.72 14.15 14.15 0 1119.64 20.37A146.53 146.53 0 00108.3 256c0 81.44 66.26 147.7 147.7 147.7S403.7 337.44 403.7 256c0-76.67-58.72-139.88-133.55-147v55a14.15 14.15 0 11-28.3 0V94.15A14.15 14.15 0 01256 80c97.05 0 176 79 176 176s-78.95 176-176 176z"
      }
    }]
  })(props);
}

function IoWalletOutline(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "width": "416",
        "height": "288",
        "x": "48",
        "y": "144",
        "fill": "none",
        "strokeLinejoin": "round",
        "strokeWidth": "32",
        "rx": "48",
        "ry": "48"
      }
    }, {
      "tag": "path",
      "attr": {
        "fill": "none",
        "strokeLinejoin": "round",
        "strokeWidth": "32",
        "d": "M411.36 144v-30A50 50 0 00352 64.9L88.64 109.85A50 50 0 0048 159v49"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M368 320a32 32 0 1132-32 32 32 0 01-32 32z"
      }
    }]
  })(props);
}

function IoWallet(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M95.5 104h320a87.73 87.73 0 0111.18.71 66 66 0 00-77.51-55.56L86 94.08h-.3a66 66 0 00-41.07 26.13A87.57 87.57 0 0195.5 104zm320 24h-320a64.07 64.07 0 00-64 64v192a64.07 64.07 0 0064 64h320a64.07 64.07 0 0064-64V192a64.07 64.07 0 00-64-64zM368 320a32 32 0 1132-32 32 32 0 01-32 32z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M32 259.5V160c0-21.67 12-58 53.65-65.87C121 87.5 156 87.5 156 87.5s23 16 4 16-18.5 24.5 0 24.5 0 23.5 0 23.5L85.5 236z"
      }
    }]
  })(props);
}

function FiActivity(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "22 12 18 12 15 21 9 3 6 12 2 12"
      }
    }]
  })(props);
}

function FiAlertCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "12",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "16",
        "x2": "12.01",
        "y2": "16"
      }
    }]
  })(props);
}

function FiAlertOctagon(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polygon",
      "attr": {
        "points": "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "12",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "16",
        "x2": "12.01",
        "y2": "16"
      }
    }]
  })(props);
}

function FiAlertTriangle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "9",
        "x2": "12",
        "y2": "13"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "17",
        "x2": "12.01",
        "y2": "17"
      }
    }]
  })(props);
}

function FiBarChart2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "20",
        "x2": "18",
        "y2": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "20",
        "x2": "12",
        "y2": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "20",
        "x2": "6",
        "y2": "14"
      }
    }]
  })(props);
}

function FiBook(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M4 19.5A2.5 2.5 0 0 1 6.5 17H20"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
      }
    }]
  })(props);
}

function FiCalendar(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "4",
        "width": "18",
        "height": "18",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "2",
        "x2": "16",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "2",
        "x2": "8",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "10",
        "x2": "21",
        "y2": "10"
      }
    }]
  })(props);
}

function FiCheckCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M22 11.08V12a10 10 0 1 1-5.93-9.14"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "22 4 12 14.01 9 11.01"
      }
    }]
  })(props);
}

function FiCheckSquare(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "9 11 12 14 22 4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"
      }
    }]
  })(props);
}

function FiCheck(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "20 6 9 17 4 12"
      }
    }]
  })(props);
}

function FiChevronDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "6 9 12 15 18 9"
      }
    }]
  })(props);
}

function FiChevronLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "15 18 9 12 15 6"
      }
    }]
  })(props);
}

function FiChevronRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "9 18 15 12 9 6"
      }
    }]
  })(props);
}

function FiChevronUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "18 15 12 9 6 15"
      }
    }]
  })(props);
}

function FiClipboard(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "8",
        "y": "2",
        "width": "8",
        "height": "4",
        "rx": "1",
        "ry": "1"
      }
    }]
  })(props);
}

function FiClock(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "12 6 12 12 16 14"
      }
    }]
  })(props);
}

function FiCopy(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "9",
        "y": "9",
        "width": "13",
        "height": "13",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
      }
    }]
  })(props);
}

function FiCornerDownLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "9 10 4 15 9 20"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 4v7a4 4 0 0 1-4 4H4"
      }
    }]
  })(props);
}

function FiCornerDownRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "15 10 20 15 15 20"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 4v7a4 4 0 0 0 4 4h12"
      }
    }]
  })(props);
}

function FiCornerLeftDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "14 15 9 20 4 15"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20 4h-7a4 4 0 0 0-4 4v12"
      }
    }]
  })(props);
}

function FiCornerRightDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "10 15 15 20 20 15"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M4 4h7a4 4 0 0 1 4 4v12"
      }
    }]
  })(props);
}

function FiDownloadCloud(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "8 17 12 21 16 17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "12",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"
      }
    }]
  })(props);
}

function FiDownload(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "7 10 12 15 17 10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "15",
        "x2": "12",
        "y2": "3"
      }
    }]
  })(props);
}

function FiEdit(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
      }
    }]
  })(props);
}

function FiEyeOff(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "1",
        "y1": "1",
        "x2": "23",
        "y2": "23"
      }
    }]
  })(props);
}

function FiFileText(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "14 2 14 8 20 8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "13",
        "x2": "8",
        "y2": "13"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "17",
        "x2": "8",
        "y2": "17"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "10 9 9 9 8 9"
      }
    }]
  })(props);
}

function FiFilter(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polygon",
      "attr": {
        "points": "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
      }
    }]
  })(props);
}

function FiGitBranch(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "3",
        "x2": "6",
        "y2": "15"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "18",
        "cy": "6",
        "r": "3"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6",
        "cy": "18",
        "r": "3"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M18 9a9 9 0 0 1-9 9"
      }
    }]
  })(props);
}

function FiGrid(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "3",
        "width": "7",
        "height": "7"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "14",
        "y": "3",
        "width": "7",
        "height": "7"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "14",
        "y": "14",
        "width": "7",
        "height": "7"
      }
    }, {
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "14",
        "width": "7",
        "height": "7"
      }
    }]
  })(props);
}

function FiHash(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "9",
        "x2": "20",
        "y2": "9"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "15",
        "x2": "20",
        "y2": "15"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "3",
        "x2": "8",
        "y2": "21"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "16",
        "y1": "3",
        "x2": "14",
        "y2": "21"
      }
    }]
  })(props);
}

function FiHelpCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "17",
        "x2": "12.01",
        "y2": "17"
      }
    }]
  })(props);
}

function FiImage(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "rect",
      "attr": {
        "x": "3",
        "y": "3",
        "width": "18",
        "height": "18",
        "rx": "2",
        "ry": "2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8.5",
        "cy": "8.5",
        "r": "1.5"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "21 15 16 10 5 21"
      }
    }]
  })(props);
}

function FiLifeBuoy(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "4"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4.93",
        "y1": "4.93",
        "x2": "9.17",
        "y2": "9.17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14.83",
        "y1": "14.83",
        "x2": "19.07",
        "y2": "19.07"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14.83",
        "y1": "9.17",
        "x2": "19.07",
        "y2": "4.93"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14.83",
        "y1": "9.17",
        "x2": "18.36",
        "y2": "5.64"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4.93",
        "y1": "19.07",
        "x2": "9.17",
        "y2": "14.83"
      }
    }]
  })(props);
}

function FiLink(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
      }
    }]
  })(props);
}

function FiList(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "6",
        "x2": "21",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "12",
        "x2": "21",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "8",
        "y1": "18",
        "x2": "21",
        "y2": "18"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "6",
        "x2": "3.01",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "12",
        "x2": "3.01",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "18",
        "x2": "3.01",
        "y2": "18"
      }
    }]
  })(props);
}

function FiLogIn(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "10 17 15 12 10 7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "15",
        "y1": "12",
        "x2": "3",
        "y2": "12"
      }
    }]
  })(props);
}

function FiLogOut(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "16 17 21 12 16 7"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "12",
        "x2": "9",
        "y2": "12"
      }
    }]
  })(props);
}

function FiMail(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "22,6 12,13 2,6"
      }
    }]
  })(props);
}

function FiMenu(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "12",
        "x2": "21",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "6",
        "x2": "21",
        "y2": "6"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "3",
        "y1": "18",
        "x2": "21",
        "y2": "18"
      }
    }]
  })(props);
}

function FiMessageSquare(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
      }
    }]
  })(props);
}

function FiMinus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "12",
        "x2": "19",
        "y2": "12"
      }
    }]
  })(props);
}

function FiMoreVertical(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "5",
        "r": "1"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "19",
        "r": "1"
      }
    }]
  })(props);
}

function FiPercent(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "19",
        "y1": "5",
        "x2": "5",
        "y2": "19"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "6.5",
        "cy": "6.5",
        "r": "2.5"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "17.5",
        "cy": "17.5",
        "r": "2.5"
      }
    }]
  })(props);
}

function FiPieChart(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M21.21 15.89A10 10 0 1 1 8 2.83"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M22 12A10 10 0 0 0 12 2v10z"
      }
    }]
  })(props);
}

function FiPlus(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "5",
        "x2": "12",
        "y2": "19"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "5",
        "y1": "12",
        "x2": "19",
        "y2": "12"
      }
    }]
  })(props);
}

function FiRefreshCw(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "23 4 23 10 17 10"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "1 20 1 14 7 14"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
      }
    }]
  })(props);
}

function FiRepeat(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "17 1 21 5 17 9"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 11V9a4 4 0 0 1 4-4h14"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "7 23 3 19 7 15"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M21 13v2a4 4 0 0 1-4 4H3"
      }
    }]
  })(props);
}

function FiSearch(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "11",
        "cy": "11",
        "r": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "21",
        "y1": "21",
        "x2": "16.65",
        "y2": "16.65"
      }
    }]
  })(props);
}

function FiSend(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "22",
        "y1": "2",
        "x2": "11",
        "y2": "13"
      }
    }, {
      "tag": "polygon",
      "attr": {
        "points": "22 2 15 22 11 13 2 9 22 2"
      }
    }]
  })(props);
}

function FiSlash(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4.93",
        "y1": "4.93",
        "x2": "19.07",
        "y2": "19.07"
      }
    }]
  })(props);
}

function FiSliders(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "21",
        "x2": "4",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "4",
        "y1": "10",
        "x2": "4",
        "y2": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "21",
        "x2": "12",
        "y2": "12"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "8",
        "x2": "12",
        "y2": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "21",
        "x2": "20",
        "y2": "16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "20",
        "y1": "12",
        "x2": "20",
        "y2": "3"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "1",
        "y1": "14",
        "x2": "7",
        "y2": "14"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "9",
        "y1": "8",
        "x2": "15",
        "y2": "8"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "17",
        "y1": "16",
        "x2": "23",
        "y2": "16"
      }
    }]
  })(props);
}

function FiStar(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polygon",
      "attr": {
        "points": "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
      }
    }]
  })(props);
}

function FiTarget(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "10"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "6"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "12",
        "r": "2"
      }
    }]
  })(props);
}

function FiTool(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"
      }
    }]
  })(props);
}

function FiTrash2(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "3 6 5 6 21 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "10",
        "y1": "11",
        "x2": "10",
        "y2": "17"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "14",
        "y1": "11",
        "x2": "14",
        "y2": "17"
      }
    }]
  })(props);
}

function FiTrash(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "3 6 5 6 21 6"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
      }
    }]
  })(props);
}

function FiTrendingDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "23 18 13.5 8.5 8.5 13.5 1 6"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "17 18 23 18 23 12"
      }
    }]
  })(props);
}

function FiTrendingUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "23 6 13.5 15.5 8.5 10.5 1 18"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "17 6 23 6 23 12"
      }
    }]
  })(props);
}

function FiUploadCloud(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "points": "16 16 12 12 8 16"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "12",
        "y1": "12",
        "x2": "12",
        "y2": "21"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "16 16 12 12 8 16"
      }
    }]
  })(props);
}

function FiUserCheck(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "8.5",
        "cy": "7",
        "r": "4"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "17 11 19 13 23 9"
      }
    }]
  })(props);
}

function FiUser(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "12",
        "cy": "7",
        "r": "4"
      }
    }]
  })(props);
}

function FiUsers(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "9",
        "cy": "7",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M23 21v-2a4 4 0 0 0-3-3.87"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M16 3.13a4 4 0 0 1 0 7.75"
      }
    }]
  })(props);
}

function FiX(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "6",
        "x2": "6",
        "y2": "18"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "6",
        "x2": "18",
        "y2": "18"
      }
    }]
  })(props);
}

function FaCcAmex(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 576 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M325.1 167.8c0-16.4-14.1-18.4-27.4-18.4l-39.1-.3v69.3H275v-25.1h18c18.4 0 14.5 10.3 14.8 25.1h16.6v-13.5c0-9.2-1.5-15.1-11-18.4 7.4-3 11.8-10.7 11.7-18.7zm-29.4 11.3H275v-15.3h21c5.1 0 10.7 1 10.7 7.4 0 6.6-5.3 7.9-11 7.9zM279 268.6h-52.7l-21 22.8-20.5-22.8h-66.5l-.1 69.3h65.4l21.3-23 20.4 23h32.2l.1-23.3c18.9 0 49.3 4.6 49.3-23.3 0-17.3-12.3-22.7-27.9-22.7zm-103.8 54.7h-40.6v-13.8h36.3v-14.1h-36.3v-12.5h41.7l17.9 20.2zm65.8 8.2l-25.3-28.1L241 276zm37.8-31h-21.2v-17.6h21.5c5.6 0 10.2 2.3 10.2 8.4 0 6.4-4.6 9.2-10.5 9.2zm-31.6-136.7v-14.6h-55.5v69.3h55.5v-14.3h-38.9v-13.8h37.8v-14.1h-37.8v-12.5zM576 255.4h-.2zm-194.6 31.9c0-16.4-14.1-18.7-27.1-18.7h-39.4l-.1 69.3h16.6l.1-25.3h17.6c11 0 14.8 2 14.8 13.8l-.1 11.5h16.6l.1-13.8c0-8.9-1.8-15.1-11-18.4 7.7-3.1 11.8-10.8 11.9-18.4zm-29.2 11.2h-20.7v-15.6h21c5.1 0 10.7 1 10.7 7.4 0 6.9-5.4 8.2-11 8.2zm-172.8-80v-69.3h-27.6l-19.7 47-21.7-47H83.3v65.7l-28.1-65.7H30.7L1 218.5h17.9l6.4-15.3h34.5l6.4 15.3H100v-54.2l24 54.2h14.6l24-54.2v54.2zM31.2 188.8l11.2-27.6 11.5 27.6zm477.4 158.9v-4.5c-10.8 5.6-3.9 4.5-156.7 4.5 0-25.2.1-23.9 0-25.2-1.7-.1-3.2-.1-9.4-.1 0 17.9-.1 6.8-.1 25.3h-39.6c0-12.1.1-15.3.1-29.2-10 6-22.8 6.4-34.3 6.2 0 14.7-.1 8.3-.1 23h-48.9c-5.1-5.7-2.7-3.1-15.4-17.4-3.2 3.5-12.8 13.9-16.1 17.4h-82v-92.3h83.1c5 5.6 2.8 3.1 15.5 17.2 3.2-3.5 12.2-13.4 15.7-17.2h58c9.8 0 18 1.9 24.3 5.6v-5.6c54.3 0 64.3-1.4 75.7 5.1v-5.1h78.2v5.2c11.4-6.9 19.6-5.2 64.9-5.2v5c10.3-5.9 16.6-5.2 54.3-5V80c0-26.5-21.5-48-48-48h-480c-26.5 0-48 21.5-48 48v109.8c9.4-21.9 19.7-46 23.1-53.9h39.7c4.3 10.1 1.6 3.7 9 21.1v-21.1h46c2.9 6.2 11.1 24 13.9 30 5.8-13.6 10.1-23.9 12.6-30h103c0-.1 11.5 0 11.6 0 43.7.2 53.6-.8 64.4 5.3v-5.3H363v9.3c7.6-6.1 17.9-9.3 30.7-9.3h27.6c0 .5 1.9.3 2.3.3H456c4.2 9.8 2.6 6 8.8 20.6v-20.6h43.3c4.9 8-1-1.8 11.2 18.4v-18.4h39.9v92h-41.6c-5.4-9-1.4-2.2-13.2-21.9v21.9h-52.8c-6.4-14.8-.1-.3-6.6-15.3h-19c-4.2 10-2.2 5.2-6.4 15.3h-26.8c-12.3 0-22.3-3-29.7-8.9v8.9h-66.5c-.3-13.9-.1-24.8-.1-24.8-1.8-.3-3.4-.2-9.8-.2v25.1H151.2v-11.4c-2.5 5.6-2.7 5.9-5.1 11.4h-29.5c-4-8.9-2.9-6.4-5.1-11.4v11.4H58.6c-4.2-10.1-2.2-5.3-6.4-15.3H33c-4.2 10-2.2 5.2-6.4 15.3H0V432c0 26.5 21.5 48 48 48h480.1c26.5 0 48-21.5 48-48v-90.4c-12.7 8.3-32.7 6.1-67.5 6.1zm36.3-64.5H575v-14.6h-32.9c-12.8 0-23.8 6.6-23.8 20.7 0 33 42.7 12.8 42.7 27.4 0 5.1-4.3 6.4-8.4 6.4h-32l-.1 14.8h32c8.4 0 17.6-1.8 22.5-8.9v-25.8c-10.5-13.8-39.3-1.3-39.3-13.5 0-5.8 4.6-6.5 9.2-6.5zm-57 39.8h-32.2l-.1 14.8h32.2c14.8 0 26.2-5.6 26.2-22 0-33.2-42.9-11.2-42.9-26.3 0-5.6 4.9-6.4 9.2-6.4h30.4v-14.6h-33.2c-12.8 0-23.5 6.6-23.5 20.7 0 33 42.7 12.5 42.7 27.4-.1 5.4-4.7 6.4-8.8 6.4zm-42.2-40.1v-14.3h-55.2l-.1 69.3h55.2l.1-14.3-38.6-.3v-13.8H445v-14.1h-37.8v-12.5zm-56.3-108.1c-.3.2-1.4 2.2-1.4 7.6 0 6 .9 7.7 1.1 7.9.2.1 1.1.5 3.4.5l7.3-16.9c-1.1 0-2.1-.1-3.1-.1-5.6 0-7 .7-7.3 1zm20.4-10.5h-.1zm-16.2-15.2c-23.5 0-34 12-34 35.3 0 22.2 10.2 34 33 34h19.2l6.4-15.3h34.3l6.6 15.3h33.7v-51.9l31.2 51.9h23.6v-69h-16.9v48.1l-29.1-48.1h-25.3v65.4l-27.9-65.4h-24.8l-23.5 54.5h-7.4c-13.3 0-16.1-8.1-16.1-19.9 0-23.8 15.7-20 33.1-19.7v-15.2zm42.1 12.1l11.2 27.6h-22.8zm-101.1-12v69.3h16.9v-69.3z"
      }
    }]
  })(props);
}

function FaCcDiscover(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 576 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M520.4 196.1c0-7.9-5.5-12.1-15.6-12.1h-4.9v24.9h4.7c10.3 0 15.8-4.4 15.8-12.8zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-44.1 138.9c22.6 0 52.9-4.1 52.9 24.4 0 12.6-6.6 20.7-18.7 23.2l25.8 34.4h-19.6l-22.2-32.8h-2.2v32.8h-16zm-55.9.1h45.3v14H444v18.2h28.3V217H444v22.2h29.3V253H428zm-68.7 0l21.9 55.2 22.2-55.2h17.5l-35.5 84.2h-8.6l-35-84.2zm-55.9-3c24.7 0 44.6 20 44.6 44.6 0 24.7-20 44.6-44.6 44.6-24.7 0-44.6-20-44.6-44.6 0-24.7 20-44.6 44.6-44.6zm-49.3 6.1v19c-20.1-20.1-46.8-4.7-46.8 19 0 25 27.5 38.5 46.8 19.2v19c-29.7 14.3-63.3-5.7-63.3-38.2 0-31.2 33.1-53 63.3-38zm-97.2 66.3c11.4 0 22.4-15.3-3.3-24.4-15-5.5-20.2-11.4-20.2-22.7 0-23.2 30.6-31.4 49.7-14.3l-8.4 10.8c-10.4-11.6-24.9-6.2-24.9 2.5 0 4.4 2.7 6.9 12.3 10.3 18.2 6.6 23.6 12.5 23.6 25.6 0 29.5-38.8 37.4-56.6 11.3l10.3-9.9c3.7 7.1 9.9 10.8 17.5 10.8zM55.4 253H32v-82h23.4c26.1 0 44.1 17 44.1 41.1 0 18.5-13.2 40.9-44.1 40.9zm67.5 0h-16v-82h16zM544 433c0 8.2-6.8 15-15 15H128c189.6-35.6 382.7-139.2 416-160zM74.1 191.6c-5.2-4.9-11.6-6.6-21.9-6.6H48v54.2h4.2c10.3 0 17-2 21.9-6.4 5.7-5.2 8.9-12.8 8.9-20.7s-3.2-15.5-8.9-20.5z"
      }
    }]
  })(props);
}

function FaCcMastercard(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 576 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M482.9 410.3c0 6.8-4.6 11.7-11.2 11.7-6.8 0-11.2-5.2-11.2-11.7 0-6.5 4.4-11.7 11.2-11.7 6.6 0 11.2 5.2 11.2 11.7zm-310.8-11.7c-7.1 0-11.2 5.2-11.2 11.7 0 6.5 4.1 11.7 11.2 11.7 6.5 0 10.9-4.9 10.9-11.7-.1-6.5-4.4-11.7-10.9-11.7zm117.5-.3c-5.4 0-8.7 3.5-9.5 8.7h19.1c-.9-5.7-4.4-8.7-9.6-8.7zm107.8.3c-6.8 0-10.9 5.2-10.9 11.7 0 6.5 4.1 11.7 10.9 11.7 6.8 0 11.2-4.9 11.2-11.7 0-6.5-4.4-11.7-11.2-11.7zm105.9 26.1c0 .3.3.5.3 1.1 0 .3-.3.5-.3 1.1-.3.3-.3.5-.5.8-.3.3-.5.5-1.1.5-.3.3-.5.3-1.1.3-.3 0-.5 0-1.1-.3-.3 0-.5-.3-.8-.5-.3-.3-.5-.5-.5-.8-.3-.5-.3-.8-.3-1.1 0-.5 0-.8.3-1.1 0-.5.3-.8.5-1.1.3-.3.5-.3.8-.5.5-.3.8-.3 1.1-.3.5 0 .8 0 1.1.3.5.3.8.3 1.1.5s.2.6.5 1.1zm-2.2 1.4c.5 0 .5-.3.8-.3.3-.3.3-.5.3-.8 0-.3 0-.5-.3-.8-.3 0-.5-.3-1.1-.3h-1.6v3.5h.8V426h.3l1.1 1.4h.8l-1.1-1.3zM576 81v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V81c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM64 220.6c0 76.5 62.1 138.5 138.5 138.5 27.2 0 53.9-8.2 76.5-23.1-72.9-59.3-72.4-171.2 0-230.5-22.6-15-49.3-23.1-76.5-23.1-76.4-.1-138.5 62-138.5 138.2zm224 108.8c70.5-55 70.2-162.2 0-217.5-70.2 55.3-70.5 162.6 0 217.5zm-142.3 76.3c0-8.7-5.7-14.4-14.7-14.7-4.6 0-9.5 1.4-12.8 6.5-2.4-4.1-6.5-6.5-12.2-6.5-3.8 0-7.6 1.4-10.6 5.4V392h-8.2v36.7h8.2c0-18.9-2.5-30.2 9-30.2 10.2 0 8.2 10.2 8.2 30.2h7.9c0-18.3-2.5-30.2 9-30.2 10.2 0 8.2 10 8.2 30.2h8.2v-23zm44.9-13.7h-7.9v4.4c-2.7-3.3-6.5-5.4-11.7-5.4-10.3 0-18.2 8.2-18.2 19.3 0 11.2 7.9 19.3 18.2 19.3 5.2 0 9-1.9 11.7-5.4v4.6h7.9V392zm40.5 25.6c0-15-22.9-8.2-22.9-15.2 0-5.7 11.9-4.8 18.5-1.1l3.3-6.5c-9.4-6.1-30.2-6-30.2 8.2 0 14.3 22.9 8.3 22.9 15 0 6.3-13.5 5.8-20.7.8l-3.5 6.3c11.2 7.6 32.6 6 32.6-7.5zm35.4 9.3l-2.2-6.8c-3.8 2.1-12.2 4.4-12.2-4.1v-16.6h13.1V392h-13.1v-11.2h-8.2V392h-7.6v7.3h7.6V416c0 17.6 17.3 14.4 22.6 10.9zm13.3-13.4h27.5c0-16.2-7.4-22.6-17.4-22.6-10.6 0-18.2 7.9-18.2 19.3 0 20.5 22.6 23.9 33.8 14.2l-3.8-6c-7.8 6.4-19.6 5.8-21.9-4.9zm59.1-21.5c-4.6-2-11.6-1.8-15.2 4.4V392h-8.2v36.7h8.2V408c0-11.6 9.5-10.1 12.8-8.4l2.4-7.6zm10.6 18.3c0-11.4 11.6-15.1 20.7-8.4l3.8-6.5c-11.6-9.1-32.7-4.1-32.7 15 0 19.8 22.4 23.8 32.7 15l-3.8-6.5c-9.2 6.5-20.7 2.6-20.7-8.6zm66.7-18.3H408v4.4c-8.3-11-29.9-4.8-29.9 13.9 0 19.2 22.4 24.7 29.9 13.9v4.6h8.2V392zm33.7 0c-2.4-1.2-11-2.9-15.2 4.4V392h-7.9v36.7h7.9V408c0-11 9-10.3 12.8-8.4l2.4-7.6zm40.3-14.9h-7.9v19.3c-8.2-10.9-29.9-5.1-29.9 13.9 0 19.4 22.5 24.6 29.9 13.9v4.6h7.9v-51.7zm7.6-75.1v4.6h.8V302h1.9v-.8h-4.6v.8h1.9zm6.6 123.8c0-.5 0-1.1-.3-1.6-.3-.3-.5-.8-.8-1.1-.3-.3-.8-.5-1.1-.8-.5 0-1.1-.3-1.6-.3-.3 0-.8.3-1.4.3-.5.3-.8.5-1.1.8-.5.3-.8.8-.8 1.1-.3.5-.3 1.1-.3 1.6 0 .3 0 .8.3 1.4 0 .3.3.8.8 1.1.3.3.5.5 1.1.8.5.3 1.1.3 1.4.3.5 0 1.1 0 1.6-.3.3-.3.8-.5 1.1-.8.3-.3.5-.8.8-1.1.3-.6.3-1.1.3-1.4zm3.2-124.7h-1.4l-1.6 3.5-1.6-3.5h-1.4v5.4h.8v-4.1l1.6 3.5h1.1l1.4-3.5v4.1h1.1v-5.4zm4.4-80.5c0-76.2-62.1-138.3-138.5-138.3-27.2 0-53.9 8.2-76.5 23.1 72.1 59.3 73.2 171.5 0 230.5 22.6 15 49.5 23.1 76.5 23.1 76.4.1 138.5-61.9 138.5-138.4z"
      }
    }]
  })(props);
}

function FaCcVisa(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 576 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9l2.8 13.4zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2L215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53zM528 331.4L495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3H528z"
      }
    }]
  })(props);
}

function FaChartPie(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 544 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M527.79 288H290.5l158.03 158.03c6.04 6.04 15.98 6.53 22.19.68 38.7-36.46 65.32-85.61 73.13-140.86 1.34-9.46-6.51-17.85-16.06-17.85zm-15.83-64.8C503.72 103.74 408.26 8.28 288.8.04 279.68-.59 272 7.1 272 16.24V240h223.77c9.14 0 16.82-7.68 16.19-16.8zM224 288V50.71c0-9.55-8.39-17.4-17.84-16.06C86.99 51.49-4.1 155.6.14 280.37 4.5 408.51 114.83 513.59 243.03 511.98c50.4-.63 96.97-16.87 135.26-44.03 7.9-5.6 8.42-17.23 1.57-24.08L224 288z"
      }
    }]
  })(props);
}

function FaInfoCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
      }
    }]
  })(props);
}

function FaLongArrowAltDown(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 256 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M168 345.941V44c0-6.627-5.373-12-12-12h-56c-6.627 0-12 5.373-12 12v301.941H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.569 9.373 33.941 0l86.059-86.059c15.119-15.119 4.411-40.971-16.971-40.971H168z"
      }
    }]
  })(props);
}

function FaLongArrowAltLeft(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 448 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z"
      }
    }]
  })(props);
}

function FaLongArrowAltRight(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 448 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z"
      }
    }]
  })(props);
}

function FaLongArrowAltUp(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 256 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M88 166.059V468c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12V166.059h46.059c21.382 0 32.09-25.851 16.971-40.971l-86.059-86.059c-9.373-9.373-24.569-9.373-33.941 0l-86.059 86.059c-15.119 15.119-4.411 40.971 16.971 40.971H88z"
      }
    }]
  })(props);
}

function FaShare(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z"
      }
    }]
  })(props);
}

function FaUser(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 448 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
      }
    }]
  })(props);
}

function FaRegChartBar(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M396.8 352h22.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-192 0h22.4c6.4 0 12.8-6.4 12.8-12.8V140.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h22.4c6.4 0 12.8-6.4 12.8-12.8V204.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zM496 400H48V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-387.2-48h22.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8z"
      }
    }]
  })(props);
}

function MdDashboard(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "fill": "none",
        "d": "M0 0h24v24H0z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"
      }
    }]
  })(props);
}

function MdInfoOutline(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "fill": "none",
        "d": "M0 0h24v24H0V0z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11 7h2v2h-2V7zm0 4h2v6h-2v-6zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
      }
    }]
  })(props);
}

function MdPersonSearch(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "fill": "none",
        "d": "M0 0h24v24H0z"
      }
    }, {
      "tag": "circle",
      "attr": {
        "cx": "10",
        "cy": "8",
        "r": "4"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10.35 14.01C7.62 13.91 2 15.27 2 18v2h9.54c-2.47-2.76-1.23-5.89-1.19-5.99zM19.43 18.02c.36-.59.57-1.28.57-2.02 0-2.21-1.79-4-4-4s-4 1.79-4 4 1.79 4 4 4c.74 0 1.43-.22 2.02-.57L20.59 22 22 20.59l-2.57-2.57zM16 18c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
      }
    }]
  })(props);
}

function MdFlag(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "fill": "none",
        "d": "M0 0h24v24H0z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"
      }
    }]
  })(props);
}

function MdGpsFixed(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "fill": "none",
        "d": "M0 0h24v24H0z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
      }
    }]
  })(props);
}

function MdLayers(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "fill": "none",
        "d": "M0 0h24v24H0z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z"
      }
    }]
  })(props);
}

function MdOutlineFilterList(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "fill": "none",
        "d": "M0 0h24v24H0V0z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
      }
    }]
  })(props);
}

function MdOutlineAttachMoney(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "fill": "none",
        "d": "M0 0h24v24H0V0z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"
      }
    }]
  })(props);
}

var DashboardIcon = createIcon({
  displayName: "DashboardIcon",
  viewBox: "0 0 24 24",
  path: React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.192 2H3.716C2.77 2 2 2.85 2 3.875v3.041c0 1.025.77 1.873 1.716 1.873h5.476c.946 0 1.716-.848 1.716-1.873V3.874c0-1.025-.77-1.873-1.716-1.873Zm.868 4.915c0 .565-.388 1.025-.868 1.025H3.716c-.477 0-.868-.46-.868-1.025V3.874c0-.565.39-1.025.868-1.025h5.476c.48 0 .868.46.868 1.025v3.041ZM9.192 10.97H3.716A1.697 1.697 0 0 0 2 12.626v7.717a1.697 1.697 0 0 0 1.716 1.656h5.476a1.697 1.697 0 0 0 1.716-1.656v-7.717a1.697 1.697 0 0 0-1.716-1.656Zm.868 9.373a.848.848 0 0 1-.868.808H3.716a.848.848 0 0 1-.868-.808v-7.717a.848.848 0 0 1 .868-.808h5.476a.848.848 0 0 1 .868.808v7.717ZM20.283 13.516h-5.477a1.775 1.775 0 0 0-1.715 1.826v4.832A1.775 1.775 0 0 0 14.806 22h5.476a1.776 1.776 0 0 0 1.716-1.826v-4.832a1.775 1.775 0 0 0-1.716-1.826Zm.867 6.658a.928.928 0 0 1-.867.977h-5.477a.929.929 0 0 1-.867-.977v-4.832a.928.928 0 0 1 .867-.978h5.477a.929.929 0 0 1 .867.978v4.832ZM20.283 2h-5.476a1.674 1.674 0 0 0-1.716 1.625V9.71a1.673 1.673 0 0 0 1.716 1.624h5.476A1.674 1.674 0 0 0 22 9.71V3.625a1.673 1.673 0 0 0-1.716-1.624Zm.868 7.709a.827.827 0 0 1-.868.776h-5.476a.825.825 0 0 1-.868-.776V3.625a.825.825 0 0 1 .868-.776h5.476a.828.828 0 0 1 .868.776V9.71Z",
    stroke: "currentColor",
    strokeWidth: ".75"
  })
});
var NewMessageIcon = createIcon({
  displayName: "NewMessageIcon",
  viewBox: "0 0 24 24",
  path: [React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 4c-.26522 0-.51957.10536-.70711.29289C4.10536 4.48043 4 4.73478 4 5v13.5858l2.29289-2.2929C6.48043 16.1054 6.73478 16 7 16h12c.2652 0 .5196-.1054.7071-.2929S20 15.2652 20 15V5c0-.26522-.1054-.51957-.2929-.70711C19.5196 4.10536 19.2652 4 19 4H5ZM2.87868 2.87868C3.44129 2.31607 4.20435 2 5 2h14c.7957 0 1.5587.31607 2.1213.87868C21.6839 3.44129 22 4.20435 22 5v10c0 .7957-.3161 1.5587-.8787 2.1213C20.5587 17.6839 19.7957 18 19 18H7.41421l-3.7071 3.7071c-.286.286-.71612.3716-1.08979.2168C2.24364 21.7691 2 21.4045 2 21V5c0-.79565.31607-1.55871.87868-2.12132Z",
    clipRule: "evenodd",
    key: "new-message-icon-path-1"
  }), React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 6c.2761 0 .5.22386.5.5v7c0 .2761-.2239.5-.5.5s-.5-.2239-.5-.5v-7c0-.27614.2239-.5.5-.5Z",
    clipRule: "evenodd",
    key: "new-message-icon-path-2"
  }), React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 10c0-.27614.22386-.5.5-.5h7c.2761 0 .5.22386.5.5 0 .2761-.2239.5-.5.5h-7c-.27614 0-.5-.2239-.5-.5Z",
    clipRule: "evenodd",
    key: "new-message-icon-path-3"
  })]
});
var SupportCircleIcon = createIcon({
  displayName: "SupportCircleIcon",
  viewBox: "0 0 40 33",
  path: [React__default.createElement("circle", {
    cx: "20.4548",
    cy: "17.4546",
    r: "14.9546",
    fill: "#fff",
    stroke: "currentColor",
    key: "support-circle-icon-path-1"
  }), React__default.createElement("path", {
    fill: "currentColor",
    d: "M40 16.3637v3.6364c-.0025.6624-.1863 1.3113-.5317 1.8766-.3454.5653-.8389 1.0252-1.4269 1.33-.3288 2.1401-1.4111 4.0926-3.0524 5.5048-1.6413 1.4123-3.733 2.1917-5.8982 2.1977-.6498 0-1.25-.3466-1.5747-.9091s-.3247-1.2557 0-1.8182.9249-.9091 1.5747-.9091c1.2309-.0029 2.4245-.4217 3.3872-1.1887.9627-.767 1.6381-1.8373 1.9157-3.0362-1.037-.6672-1.6645-1.8149-1.6664-3.0479v-3.6364c.0012-.9882.4062-1.9334 1.1217-2.6153-1.2597-3.94034-4.138-7.15709-7.9144-8.84583-3.7764-1.68832-8.093-1.68832-11.8692 0C10.289 6.59121 7.41075 9.80796 6.151 13.7483c.7155.6819 1.12053 1.6271 1.12177 2.6153V20c0 1.2991-.69319 2.4997-1.81819 3.1493-1.12499.6494-2.51139.6494-3.63639 0C.693199 22.4996 0 21.299 0 20v-3.6364c.00284095-.782.258121-1.5426.728087-2.168.469963-.625 1.129463-1.082 1.879903-1.3019C3.74109 9.16359 6.04344 5.89645 9.175 3.57509 12.307 1.2532 16.102 0 20 0c3.898 0 7.6932 1.2532 10.825 3.57509 3.1316 2.32147 5.4339 5.5885 6.567 9.31861.7504.22 1.4099.6769 1.8799 1.3019.47.6254.7253 1.386.7281 2.168v.0001Z",
    key: "support-circle-icon-path-2"
  }), React__default.createElement("path", {
    fill: "currentColor",
    d: "M21.4887 14.878s-.5066.3526-.7643.5277c-.2564.1751-.5128.0159-.6336-.0673-.7167-.491-1.6056-.7481-2.5567-.6636-1.8375.1628-3.3331 1.6259-3.5346 3.4647-.2588 2.3666 1.5824 4.3695 3.8899 4.3695.696 0 1.3479-.1824 1.9145-.502.4969-.2816.6434.0845.6605.1384.0708.2118.271.3636.5054.3636h.4115c.2332 0 .4237-.1898.4237-.4248v-7.0397c0-.1628-.1832-.2583-.3163-.1665Zm-1.0512 3.8859c-.0964 1.3908-1.3052 2.4804-2.7373 2.3751-1.2112-.0881-2.2123-1.0504-2.3466-2.26-.1722-1.5426 1.0329-2.8538 2.5371-2.8538 1.3479 0 2.4552 1.0529 2.5468 2.3824v.3563Zm-6.2302-5.4749h-1.6385c-.1111 0-.2015-.0906-.2015-.2021v-1.8584c0-.1837-.2063-.2926-.3577-.1873l-.912.6342c-.0611.0428-.0977.1126-.0977.1873v8.3594h.0036c0 1.1875.9072 2.1657 2.0622 2.2771.1172.011.2198-.0832.2198-.202v-.9757c0-.0955-.0709-.1727-.1649-.1898-.4297-.0784-.7557-.4554-.7557-.9084h.0036v-5.3611c0-.1115.0904-.2021.2015-.2021h.9743c.0659 0 .1282-.033.166-.0869l.6642-.9672c.0916-.1346-.0048-.317-.1672-.317Zm16.785 5.0476c-.1233-2.0066-1.7887-3.6165-3.7922-3.674-.8852-.0257-1.7069.2448-2.3747.7186-.0989.071-.3553.1775-.6093.0025l-.7301-.5044c-.1343-.0931-.3162.0036-.3162.1665v8.9935c0 .0747.0366.1445.0977.1861l.9157.6367c.1501.104.354-.0037.354-.1861v-2.6996c0-.1616.1807-.2595.3126-.1677.6337.4432 1.4041.7027 2.2343.7027 2.2453-.0012 4.0486-1.8952 3.9082-4.1748ZM27.277 21.139c-1.4334.1053-2.6421-.9843-2.7385-2.3751v-.3587c.0915-1.3283 1.1989-2.3825 2.5468-2.3825 1.5042 0 2.7093 1.3112 2.5371 2.8538-.1331 1.2109-1.1342 2.1731-2.3454 2.2625Z",
    key: "support-circle-icon-path-3"
  })]
});
var TapCircleIcon = createIcon({
  displayName: "TapCircleIcon",
  viewBox: "0 0 40 40",
  path: [React__default.createElement("circle", {
    cx: "20",
    cy: "20",
    r: "20",
    fill: "currentColor",
    key: "tap-circle-icon-path-1"
  }), React__default.createElement("path", {
    fill: "#fff",
    d: "M20.5854 16.4638s-.6082.4059-.9165.6076c-.3083.2016-.6157.0181-.7605-.0769-.8611-.5642-1.9261-.8616-3.0673-.764-2.2053.1881-3.9989 1.8716-4.2405 3.9883-.3112 2.7242 1.8988 5.0298 4.6682 5.0298.8347 0 1.6178-.2098 2.2965-.5769.5969-.3246.7718.0968.7934.1583.0855.2432.3253.4186.6073.4186h.4925c.2802 0 .5077-.2188.5077-.4883v-8.1039c-.001-.1881-.22-.2984-.3808-.1926Zm-1.2615 4.4729c-.1156 1.6012-1.5651 2.8544-3.2854 2.7332-1.4533-.1021-2.6547-1.2097-2.8164-2.6021-.2068-1.7758 1.2399-3.2858 3.0448-3.2858 1.6178 0 2.9461 1.2125 3.0561 2.7415v.4132h.0009Zm-7.4754-6.3021H9.88196c-.13349 0-.24159-.1039-.24159-.2323V12.263c0-.2115-.24723-.3363-.42866-.2161l-1.09421.7297c-.07332.0488-.1175.1293-.1175.2161v9.622h.00376c0 1.3662 1.08762 2.4937 2.47414 2.6212.141.0127.2633-.0967.2633-.2324v-1.1238c0-.1103-.0856-.199-.1984-.2188-.5151-.0905-.90713-.5245-.90713-1.0462h.00376v-6.1699c0-.1284.1081-.2324.24158-.2324h1.16939c.0799 0 .1542-.038.1993-.1004l.7972-1.113c.1109-.1546-.0038-.3644-.1984-.3644Zm20.1423 5.8093c-.1475-2.3092-2.1461-4.1627-4.5497-4.2296-1.0632-.029-2.0484.2821-2.8493.8273-.1194.0813-.4268.2043-.7304.0027l-.8761-.5814c-.1608-.1067-.3789.0045-.3789.1917v10.3517c0 .0859.0433.1655.1166.2143l1.0989.7323c.1796.1203.4258-.0036.4258-.2142v-3.1076c0-.1854.2172-.2993.3751-.1935.7605.5099 1.6846.8092 2.681.8092 2.6913.0009 4.8544-2.1781 4.687-4.8029ZM27.5322 23.67c-1.7202.1211-3.1698-1.1321-3.2854-2.7333v-.4123c.1109-1.5299 1.4383-2.7414 3.0561-2.7414 1.8058 0 3.2516 1.509 3.0448 3.2848-.1617 1.3924-1.3631 2.5-2.8155 2.6022Z",
    key: "tap-circle-icon-path-2"
  })]
});
var LightningBolt = createIcon({
  displayName: "LightningBolt",
  viewBox: "0 0 10 20",
  path: React__default.createElement("path", {
    fill: "currentColor",
    d: "M0 11.6772h2.97841L1.89134 20 10 7.84005H7.24047L8.42846 0 0 11.6772Z"
  })
});
var Star = createIcon({
  displayName: "Star",
  viewBox: "0 0 12 12",
  path: React__default.createElement("path", {
    fill: "currentColor",
    d: "m6 0 1.34708 4.1459h4.35922L8.17963 6.7082l1.34708 4.1459L6 8.2918l-3.52671 2.5623 1.34708-4.1459L.293661 4.1459H4.65292L6 0Z"
  })
});
var TrIcons = {
  DashboardIcon: DashboardIcon,
  NewMessageIcon: NewMessageIcon,
  SupportCircleIcon: SupportCircleIcon,
  TapCircleIcon: TapCircleIcon,
  LightningBolt: LightningBolt,
  Star: Star
};

var SvgHornStyle2Big = function SvgHornStyle2Big(props) {
  return (
    /* @__PURE__ */
    React.createElement("svg", _objectSpread({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props),
    /* @__PURE__ */
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.5 6H13.5V15H6.5C4.567 15 3 13.433 3 11.5V9.5C3 7.567 4.567 6 6.5 6Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M13.5 5.99999L17.5264 3.75593C18.1458 3.41072 18.9016 3.4193 19.5131 3.77848C20.1245 4.13767 20.5 4.79375 20.5 5.50286V15.4971C20.5 16.2063 20.1245 16.8624 19.5131 17.2216C18.9016 17.5808 18.1457 17.5894 17.5263 17.2441L13.5 15",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M6 14.9651L7.86634 19.631C8.19707 20.4578 8.99787 21 9.88839 21V21C10.611 21 11.2866 20.6415 11.6918 20.0431C12.0969 19.4447 12.1788 18.6843 11.9104 18.0134L10.7051 15",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))
  );
};

var SvgMessageChatCheckmark = function SvgMessageChatCheckmark(props) {
  return (
    /* @__PURE__ */
    React.createElement("svg", _objectSpread({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props),
    /* @__PURE__ */
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.5006 19.0029V20.5025C13.5006 20.6956 13.6117 20.8714 13.7861 20.9543C13.9605 21.0372 14.167 21.0123 14.3167 20.8904L16.6345 19.0029H19.0029C20.1079 19.0029 21.0037 18.1071 21.0037 17.0021V13.0004C21.0037 11.8954 20.1079 10.9996 19.0029 10.9996H12C10.8949 10.9996 9.99915 11.8954 9.99915 13.0004V17.0021C9.99915 18.1071 10.8949 19.0029 12 19.0029H13.5006Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M9.95834 7.74738L8.08356 9.62316L6.95709 8.49769",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M13.8959 7.99833C13.6647 5.24147 11.4078 3.09339 8.6429 2.9985C5.87799 2.90361 3.47917 4.89191 3.05945 7.62643C2.63974 10.361 4.33183 12.9772 6.99793 13.7159",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))
  );
};

var SvgCursorSelectHandCheckmark = function SvgCursorSelectHandCheckmark(props) {
  return (
    /* @__PURE__ */
    React.createElement("svg", _objectSpread({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M7.554 11H4C2.895 11 2 10.105 2 9V4C2 2.895 2.895 2 4 2H20C21.105 2 22 2.895 22 4V9C22 10.105 21.105 11 20 11H10.554",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.554 13V8.5C10.554 7.672 9.88201 7 9.05401 7V7C8.22601 7 7.55401 7.672 7.55401 8.5V11V16L6.65301 15.099C6.04601 14.492 5.06201 14.492 4.45501 15.099V15.099C3.93101 15.623 3.85001 16.444 4.26101 17.06L6.96001 21.109C7.33101 21.666 7.95601 22 8.62501 22H13.913C14.922 22 15.772 21.249 15.898 20.248L16.44 15.911C16.573 14.844 15.839 13.862 14.778 13.689L10.554 13Z",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M18.5 5.5L16 8L14.5 6.5",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))
  );
};

var Svg3DSphere = function Svg3DSphere(props) {
  return (
    /* @__PURE__ */
    React.createElement("svg", _objectSpread({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props),
    /* @__PURE__ */
    React.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 9.00375,
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M15.3324 12C15.3324 16.732 13.8408 20.5686 12 20.5686C10.5854 20.5686 9.38091 18.2996 8.89871 15.1033",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M8.66762 12C8.66762 7.26803 10.1592 3.43143 12 3.43143C13.4146 3.43143 14.6191 5.70038 15.1013 8.89671",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M12 8.66762C16.732 8.66762 20.5686 10.1592 20.5686 12C20.5686 13.4146 18.2996 14.6191 15.1033 15.1013",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M12 15.3324C7.26803 15.3324 3.43143 13.8408 3.43143 12C3.43143 10.5854 5.70038 9.38091 8.89671 8.89871",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))
  );
};

var SvgCheckmarkDone = function SvgCheckmarkDone(props) {
  return (
    /* @__PURE__ */
    React.createElement("svg", _objectSpread({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M19.561 7.44397L12.005 15L8.228 11.222",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M21 12C21 16.971 16.971 21 12 21C7.029 21 3 16.971 3 12C3 7.029 7.029 3 12 3C13.453 3 14.821 3.353 16.036 3.964",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))
  );
};

var SvgAbstractSquare = function SvgAbstractSquare(props) {
  return (
    /* @__PURE__ */
    React.createElement("svg", _objectSpread({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props),
    /* @__PURE__ */
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 7.765L12 12.529L4 7.765L12 3L20 7.765Z",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M4 12L12 16.765L20 12",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M4 16.235L12 21L20 16.235",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))
  );
};

var SvgPencilEdit = function SvgPencilEdit(props) {
  return (
    /* @__PURE__ */
    React.createElement("svg", _objectSpread({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M19.021 12.045V5.045C19.021 3.94 18.126 3.045 17.021 3.045H5.021C3.916 3.045 3.021 3.94 3.021 5.045V17.045C3.021 18.15 3.916 19.045 5.021 19.045H12.021",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.652 19.262L19.238 20.676C18.847 21.067 18.214 21.067 17.824 20.676L10.293 13.145C10.105 12.958 10 12.703 10 12.438V10.024H12.414C12.679 10.024 12.934 10.129 13.121 10.317L20.652 17.848C21.043 18.238 21.043 18.871 20.652 19.262V19.262Z",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M18.86 16.06L16.03 18.88",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))
  );
};

var SvgRewardsFavorite = function SvgRewardsFavorite(props) {
  return (
    /* @__PURE__ */
    React.createElement("svg", _objectSpread({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props),
    /* @__PURE__ */
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.999 17.768L16.01 19.876C16.791 20.286 17.703 19.623 17.554 18.754L16.788 14.288L20.034 11.127C20.666 10.511 20.318 9.438 19.444 9.311L14.96 8.659L12.955 4.594C12.565 3.803 11.436 3.803 11.046 4.594L9.04 8.659L4.556 9.311C3.683 9.438 3.334 10.511 3.966 11.127L7.212 14.288L6.446 18.754C6.297 19.623 7.209 20.287 7.99 19.876L12.001 17.768H11.999Z",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))
  );
};

var SvgSettingsSwitchesSquare = function SvgSettingsSwitchesSquare(props) {
  return (
    /* @__PURE__ */
    React.createElement("svg", _objectSpread({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M13.5006 9.74859C13.9148 9.74859 14.2506 9.41281 14.2506 8.99859C14.2506 8.58438 13.9148 8.24859 13.5006 8.24859V9.74859ZM6.99791 8.24859C6.5837 8.24859 6.24791 8.58438 6.24791 8.99859C6.24791 9.41281 6.5837 9.74859 6.99791 9.74859V8.24859ZM10.4994 14.2511C10.0852 14.2511 9.74937 14.5869 9.74937 15.0011C9.74937 15.4153 10.0852 15.7511 10.4994 15.7511V14.2511ZM17.0021 15.7511C17.4163 15.7511 17.7521 15.4153 17.7521 15.0011C17.7521 14.5869 17.4163 14.2511 17.0021 14.2511V15.7511ZM16.0017 20.2536H7.99833V21.7536H16.0017V20.2536ZM7.99833 20.2536C5.64997 20.2536 3.74625 18.3499 3.74625 16.0015H2.24625C2.24625 19.1783 4.82154 21.7536 7.99833 21.7536V20.2536ZM3.74625 16.0015V7.99818H2.24625V16.0015H3.74625ZM3.74625 7.99818C3.74625 5.64982 5.64997 3.74609 7.99833 3.74609V2.24609C4.82154 2.24609 2.24625 4.82139 2.24625 7.99818H3.74625ZM7.99833 3.74609H16.0017V2.24609H7.99833V3.74609ZM16.0017 3.74609C18.35 3.74609 20.2537 5.64982 20.2537 7.99818H21.7537C21.7537 4.82139 19.1785 2.24609 16.0017 2.24609V3.74609ZM20.2537 7.99818V16.0015H21.7537V7.99818H20.2537ZM20.2537 16.0015C20.2537 18.3499 18.35 20.2536 16.0017 20.2536V21.7536C19.1785 21.7536 21.7537 19.1783 21.7537 16.0015H20.2537ZM13.5006 8.24859H6.99791V9.74859H13.5006V8.24859ZM16.0017 9.99932H14.501V11.4993H16.0017V9.99932ZM14.501 9.99932C14.3627 9.99932 14.2506 9.88721 14.2506 9.74891H12.7506C12.7506 10.7156 13.5343 11.4993 14.501 11.4993V9.99932ZM14.2506 9.74891V8.24828H12.7506V9.74891H14.2506ZM14.2506 8.24828C14.2506 8.10998 14.3627 7.99786 14.501 7.99786V6.49786C13.5343 6.49786 12.7506 7.28155 12.7506 8.24828H14.2506ZM14.501 7.99786H16.0017V6.49786H14.501V7.99786ZM16.0017 7.99786C16.14 7.99786 16.2521 8.10998 16.2521 8.24828H17.7521C17.7521 7.28155 16.9684 6.49786 16.0017 6.49786V7.99786ZM16.2521 8.24828V9.74891H17.7521V8.24828H16.2521ZM16.2521 9.74891C16.2521 9.88721 16.14 9.99932 16.0017 9.99932V11.4993C16.9684 11.4993 17.7521 10.7156 17.7521 9.74891H16.2521ZM10.4994 15.7511H17.0021V14.2511H10.4994V15.7511ZM7.99833 14.0004H9.49895V12.5004H7.99833V14.0004ZM9.49895 14.0004C9.63726 14.0004 9.74937 14.1125 9.74937 14.2508H11.2494C11.2494 13.2841 10.4657 12.5004 9.49895 12.5004V14.0004ZM9.74937 14.2508V15.7514H11.2494V14.2508H9.74937ZM9.74937 15.7514C9.74937 15.8897 9.63726 16.0018 9.49895 16.0018V17.5018C10.4657 17.5018 11.2494 16.7181 11.2494 15.7514H9.74937ZM9.49895 16.0018H7.99833V17.5018H9.49895V16.0018ZM7.99833 16.0018C7.86003 16.0018 7.74791 15.8897 7.74791 15.7514H6.24791C6.24791 16.7181 7.0316 17.5018 7.99833 17.5018V16.0018ZM7.74791 15.7514V14.2508H6.24791V15.7514H7.74791ZM7.74791 14.2508C7.74791 14.1125 7.86003 14.0004 7.99833 14.0004V12.5004C7.0316 12.5004 6.24791 13.2841 6.24791 14.2508H7.74791Z",
      fill: "currentcolor"
    }))
  );
};

var SvgTargetGoal = function SvgTargetGoal(props) {
  return (
    /* @__PURE__ */
    React.createElement("svg", _objectSpread({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M14.0409 9.95915L11.5298 12.4702",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.0008 5.9975V9.99917H18.0025L22.0042 5.9975L19.3361 4.66395L18.0025 1.99583L14.0008 5.9975Z",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M10.9996 3.97166C6.43608 4.25175 2.9064 8.08253 2.99998 12.6537C3.09356 17.2248 6.77708 20.9079 11.3482 21.001C15.9194 21.0941 19.7498 17.5639 20.0293 13.0004",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M16.2118 13.0004C15.9428 15.4635 13.8175 17.301 11.3414 17.2111C8.86525 17.1213 6.87867 15.1348 6.78886 12.6586C6.69904 10.1825 8.53647 8.05722 10.9996 7.78825",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))
  );
};

var SvgTextInputSquare = function SvgTextInputSquare(props) {
  return (
    /* @__PURE__ */
    React.createElement("svg", _objectSpread({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M8 10H12",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("rect", {
      x: 3,
      y: 3,
      width: 18,
      height: 18,
      rx: 5,
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M16 8V16",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M10 10V14",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))
  );
};

var SvgUserProfileLoadingCircle = function SvgUserProfileLoadingCircle(props) {
  return (
    /* @__PURE__ */
    React.createElement("svg", _objectSpread({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M11.928 2.99625C16.9006 2.99625 20.9317 7.02736 20.9317 12C20.9317 16.9726 16.9006 21.0037 11.928 21.0037",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M8.85169 20.4525C7.86476 20.0952 6.94791 19.568 6.14256 18.8949",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M6.14256 5.10512C6.94742 4.43126 7.8644 3.90404 8.85169 3.54747",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M3.06827 10.4373C3.24904 9.40261 3.61036 8.40772 4.13571 7.49812",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M3.06827 13.5616C3.24893 14.5967 3.61025 15.592 4.13571 16.5019",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M16.0017 16.0017C15.8853 15.7089 15.7048 15.4461 15.4734 15.2323V15.2323C15.0836 14.87 14.5711 14.6684 14.0388 14.6681H9.96214C9.42958 14.6684 8.91681 14.87 8.52654 15.2323V15.2323C8.29569 15.4465 8.11527 15.7093 7.99832 16.0017",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("circle", {
      cx: 12,
      cy: 10.2493,
      r: 2.25094,
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))
  );
};

var SvgSecurityLock = function SvgSecurityLock(props) {
  return (
    /* @__PURE__ */
    React.createElement("svg", _objectSpread({
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props),
    /* @__PURE__ */
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17 21H7C5.895 21 5 20.105 5 19V11C5 9.895 5.895 9 7 9H17C18.105 9 19 9.895 19 11V19C19 20.105 18.105 21 17 21Z",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M12 17.09V14.5",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M12.5303 13.2197C12.8232 13.5126 12.8232 13.9875 12.5303 14.2804C12.2374 14.5733 11.7625 14.5733 11.4696 14.2804C11.1767 13.9875 11.1767 13.5126 11.4696 13.2197C11.7625 12.9268 12.2374 12.9268 12.5303 13.2197",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M8 9V7V7C8 4.791 9.791 3 12 3V3C14.209 3 16 4.791 16 7V7V9",
      stroke: "currentcolor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))
  );
};

var MyIcons = {
  HornStyle2Big: SvgHornStyle2Big,
  MessageChatCheckmark: SvgMessageChatCheckmark,
  CursorSelectHandCheckmark: SvgCursorSelectHandCheckmark,
  Sphere3d: Svg3DSphere,
  CheckmarkDone: SvgCheckmarkDone,
  AbstractSquare: SvgAbstractSquare,
  PencilEdit: SvgPencilEdit,
  RewardsFavorite: SvgRewardsFavorite,
  SettingsSwitchesSquare: SvgSettingsSwitchesSquare,
  TargetGoal: SvgTargetGoal,
  TextInputSquare: SvgTextInputSquare,
  UserProfileLoadingCircle: SvgUserProfileLoadingCircle,
  SecurityLock: SvgSecurityLock
};
var AntIcons = {
  OutlineApi: AiOutlineApi,
  OutlineCamera: AiOutlineCamera,
  OutlineEdit: AiOutlineEdit,
  OutlineMenu: AiOutlineMenu,
  OutlinePushpin: AiOutlinePushpin
};
var Ionicons4 = {
  IosCash: IoIosCash,
  IosStats: IoIosStats,
  MdGlobe: IoMdGlobe,
  MdGrid: IoMdGrid,
  MdInformationCircle: IoMdInformationCircle,
  MdOpen: IoMdOpen
};
var Ionicons5 = {
  AlertCircle: IoAlertCircle,
  Apps: IoApps,
  Bulb: IoBulb,
  Business: IoBusiness,
  CaretDown: IoCaretDown,
  CaretDownCircle: IoCaretDownCircle,
  CaretDownCircleOutline: IoCaretDownCircleOutline,
  CheckmarkCircle: IoCheckmarkCircle,
  CaretUp: IoCaretUp,
  CaretUpCircle: IoCaretUpCircle,
  CaretUpCircleOutline: IoCaretUpCircleOutline,
  Close: IoClose,
  CloseCircle: IoCloseCircle,
  CopyOutline: IoCopyOutline,
  CreateOutline: IoCreateOutline,
  DiamondOutline: IoDiamondOutline,
  EllipsisHorizontal: IoEllipsisHorizontal,
  Grid: IoGrid,
  Infinite: IoInfinite,
  People: IoPeople,
  Person: IoPerson,
  PersonCircle: IoPersonCircle,
  PersonCircleOutline: IoPersonCircleOutline,
  Pulse: IoPulse,
  ReaderOutline: IoReaderOutline,
  SettingsOutline: IoSettingsOutline,
  ShareSocialSharp: IoShareSocialSharp,
  ShieldCheckmarkOutline: IoShieldCheckmarkOutline,
  StarHalf: IoStarHalf,
  SwapVerticalOutline: IoSwapVerticalOutline,
  TimeOutline: IoTimeOutline,
  Timer: IoTimer,
  Wallet: IoWallet,
  WalletOutline: IoWalletOutline
};
var FeatherIcons = {
  Activity: FiActivity,
  AlertCircle: FiAlertCircle,
  AlertOctagon: FiAlertOctagon,
  AlertTriangle: FiAlertTriangle,
  BarChart2: FiBarChart2,
  Book: FiBook,
  Calendar: FiCalendar,
  Check: FiCheck,
  CheckCircle: FiCheckCircle,
  CheckSquare: FiCheckSquare,
  ChevronDown: FiChevronDown,
  ChevronLeft: FiChevronLeft,
  ChevronRight: FiChevronRight,
  ChevronUp: FiChevronUp,
  Clipboard: FiClipboard,
  Clock: FiClock,
  Copy: FiCopy,
  CornerDownLeft: FiCornerDownLeft,
  CornerDownRight: FiCornerDownRight,
  CornerLeftDown: FiCornerLeftDown,
  CornerRightDown: FiCornerRightDown,
  Download: FiDownload,
  DownloadCloud: FiDownloadCloud,
  Edit: FiEdit,
  EyeOff: FiEyeOff,
  FileText: FiFileText,
  Filter: FiFilter,
  GitBranch: FiGitBranch,
  Grid: FiGrid,
  Hash: FiHash,
  HelpCircle: FiHelpCircle,
  Image: FiImage,
  LifeBuoy: FiLifeBuoy,
  Link: FiLink,
  List: FiList,
  LogIn: FiLogIn,
  LogOut: FiLogOut,
  Mail: FiMail,
  Menu: FiMenu,
  MessageSquare: FiMessageSquare,
  Minus: FiMinus,
  MoreVertical: FiMoreVertical,
  Percent: FiPercent,
  PieChart: FiPieChart,
  Plus: FiPlus,
  RefreshCw: FiRefreshCw,
  Repeat: FiRepeat,
  Search: FiSearch,
  Send: FiSend,
  Slash: FiSlash,
  Star: FiStar,
  Sliders: FiSliders,
  Target: FiTarget,
  Tool: FiTool,
  Trash: FiTrash,
  Trash2: FiTrash2,
  TrendingDown: FiTrendingDown,
  TrendingUp: FiTrendingUp,
  UploadCloud: FiUploadCloud,
  User: FiUser,
  Users: FiUsers,
  UserCheck: FiUserCheck,
  X: FiX
};
var FontAwesomeIcons = {
  CcAmex: FaCcAmex,
  CcDiscover: FaCcDiscover,
  CcMastercard: FaCcMastercard,
  CcVisa: FaCcVisa,
  ChartPie: FaChartPie,
  InfoCircle: FaInfoCircle,
  LongArrowAltDown: FaLongArrowAltDown,
  LongArrowAltLeft: FaLongArrowAltLeft,
  LongArrowAltRight: FaLongArrowAltRight,
  LongArrowAltUp: FaLongArrowAltUp,
  RegChartBar: FaRegChartBar,
  Share: FaShare,
  User: FaUser
};
var MaterialIcons = {
  Dashboard: MdDashboard,
  Flag: MdFlag,
  GpsFixed: MdGpsFixed,
  InfoOutline: MdInfoOutline,
  Layers: MdLayers,
  OutlineAttachMoney: MdOutlineAttachMoney,
  OutlineFilterList: MdOutlineFilterList,
  PersonSearch: MdPersonSearch
};
var icons = {
  ai: AntIcons,
  fi: FeatherIcons,
  md: MaterialIcons,
  fa: FontAwesomeIcons,
  io4: Ionicons4,
  io5: Ionicons5,
  tr: TrIcons,
  my: MyIcons
};

function Icon$1(_ref22) {
  var icon = _ref22.icon,
      wrapAs = _ref22.wrapAs,
      wrapProps = _ref22.wrapProps,
      rest = _objectWithoutProperties(_ref22, ["icon", "wrapAs", "wrapProps"]);

  return wrapAs ? React__default.createElement(Box$2, _objectSpread({
    as: wrapAs
  }, wrapProps), React__default.createElement(Icon$2, _objectSpread({
    "data-testid": "icon-".concat(icon == null ? void 0 : icon.name)
  }, rest, {
    as: icon
  }))) : React__default.createElement(Icon$2, _objectSpread({
    "data-testid": "icon-".concat(icon == null ? void 0 : icon.name)
  }, rest, {
    as: icon
  }));
}

function wrapInChakraIcon(IconComponent, displayName) {
  var WrappedIcon = function WrappedIcon(props) {
    return React__default.createElement(Icon$2, _objectSpread({}, props, {
      as: IconComponent
    }));
  };

  WrappedIcon.displayName = displayName;
  return WrappedIcon;
}

var InfoIcon = wrapInChakraIcon(icons.fa.InfoCircle, "InfoIcon");

var Heading$1 = function Heading$1(_ref23) {
  var _ref23$fontWeight = _ref23.fontWeight,
      fontWeight = _ref23$fontWeight === void 0 ? "bold" : _ref23$fontWeight,
      children = _ref23.children,
      rest = _objectWithoutProperties(_ref23, ["fontWeight", "children"]);

  return React__default.createElement(Heading$2, _objectSpread({
    fontWeight: fontWeight,
    display: "flex",
    alignItems: "center"
  }, rest), children);
};

var Text$1 = function Text$1(_ref24) {
  var children = _ref24.children,
      rest = _objectWithoutProperties(_ref24, ["children"]);

  return React__default.createElement(Text$2, _objectSpread({
    as: "span"
  }, rest), children);
};

var InputLabel = function InputLabel(_ref25) {
  var children = _ref25.children,
      rest = _objectWithoutProperties(_ref25, ["children"]);

  return React__default.createElement(InputLabelStyle, _objectSpread({}, rest), children);
};

var InputLabelStyle = chakra$1(FormLabel$1, {
  baseStyle: {
    textTransform: "uppercase",
    color: "gray.500",
    fontWeight: "bold",
    fontSize: "sm",
    letterSpacing: "wide",
    display: "block",
    margin: "5px"
  }
});
var Box$1 = forwardRef$1(function BaseBox(_ref26, ref) {
  var children = _ref26.children,
      rest = _objectWithoutProperties(_ref26, ["children"]);

  return React__default.createElement(Box$2, _objectSpread({
    ref: ref
  }, rest), children);
});

var Accordion = function Accordion(_ref27) {
  var children = _ref27.children,
      rest = _objectWithoutProperties(_ref27, ["children"]);

  return React__default.createElement(Accordion$1, _objectSpread({
    allowMultiple: true,
    allowToggle: true
  }, rest), children);
};

var AccordionItem = function AccordionItem(_ref28) {
  var itemTitle = _ref28.itemTitle,
      children = _ref28.children,
      _buttonStyle = _ref28._buttonStyle,
      _panelStyle = _ref28._panelStyle,
      _ref28$_buttonStyleEx = _ref28._buttonStyleExpanded,
      _buttonStyleExpanded = _ref28$_buttonStyleEx === void 0 ? void 0 : _ref28$_buttonStyleEx,
      _ref28$icons = _ref28.icons,
      icons2 = _ref28$icons === void 0 ? [] : _ref28$icons,
      rest = _objectWithoutProperties(_ref28, ["itemTitle", "children", "_buttonStyle", "_panelStyle", "_buttonStyleExpanded", "icons"]);

  var _icons = _slicedToArray(icons2, 2),
      openIcon = _icons[0],
      closedIcon = _icons[1];

  return React__default.createElement(AccordionItem$1, _objectSpread({
    border: "none"
  }, rest), function (_ref29) {
    var isExpanded = _ref29.isExpanded;
    return React__default.createElement("section", null, React__default.createElement(AccordionButton, _objectSpread({}, _buttonStyle, {
      _expanded: _buttonStyleExpanded
    }), React__default.createElement(Box$1, {
      display: "flex",
      flex: "1",
      textAlign: "left"
    }, itemTitle), !!icons2.length ? React__default.createElement(React__default.Fragment, null, isExpanded ? openIcon : closedIcon) : React__default.createElement(AccordionIcon, null)), React__default.createElement(AccordionPanel, _objectSpread({
      m: 0
    }, _panelStyle), children));
  });
};

var Center$1 = function Center$1(_ref30) {
  var _ref30$variant = _ref30.variant,
      variant = _ref30$variant === void 0 ? "center" : _ref30$variant,
      _ref30$display = _ref30.display,
      display = _ref30$display === void 0 ? "inline-flex" : _ref30$display,
      _ref30$borderRadius = _ref30.borderRadius,
      borderRadius = _ref30$borderRadius === void 0 ? "base" : _ref30$borderRadius,
      children = _ref30.children,
      rest = _objectWithoutProperties(_ref30, ["variant", "display", "borderRadius", "children"]);

  var defaultBg = variant === "center" ? "white" : "brand";
  var color2 = variant === "center" ? "#444" : "white";

  if (variant === "square") {
    return React__default.createElement(Square$1, _objectSpread({
      display: display,
      borderRadius: borderRadius,
      bg: defaultBg,
      color: color2
    }, rest), children);
  }

  if (variant === "circle") {
    return React__default.createElement(Circle$1, _objectSpread({
      display: display,
      bg: defaultBg,
      color: color2
    }, rest), children);
  }

  return React__default.createElement(Center$2, _objectSpread({
    display: display,
    color: color2
  }, rest), children);
};

var Stack$1 = function Stack$1(_ref31) {
  var children = _ref31.children,
      rest = _objectWithoutProperties(_ref31, ["children"]);

  return React__default.createElement(Stack$2, _objectSpread({}, rest), children);
};

var Badge$1 = forwardRef$1(function BaseBadge(_ref32, ref) {
  var _ref32$borderRadius = _ref32.borderRadius,
      borderRadius = _ref32$borderRadius === void 0 ? "base" : _ref32$borderRadius,
      _ref32$fontWeight = _ref32.fontWeight,
      fontWeight = _ref32$fontWeight === void 0 ? "medium" : _ref32$fontWeight,
      children = _ref32.children,
      rest = _objectWithoutProperties(_ref32, ["borderRadius", "fontWeight", "children"]);

  return React__default.createElement(Badge$2, _objectSpread({
    fontWeight: fontWeight,
    borderRadius: borderRadius,
    ref: ref
  }, rest), children);
});

var SimpleGrid$1 = function SimpleGrid$1(_ref33) {
  var children = _ref33.children,
      rest = _objectWithoutProperties(_ref33, ["children"]);

  return React__default.createElement(SimpleGrid$2, _objectSpread({}, rest), children);
};

var CircularProgress = function CircularProgress(_ref34) {
  var _ref34$label = _ref34.label,
      label = _ref34$label === void 0 ? null : _ref34$label,
      rest = _objectWithoutProperties(_ref34, ["label"]);

  if (label) {
    return React__default.createElement(CircularProgress$1, _objectSpread({}, rest), React__default.createElement(CircularProgressLabel, null, label));
  }

  return React__default.createElement(CircularProgress$1, _objectSpread({}, rest));
};

var TABLE_VARIANTS = ["simple", "striped", "unstyled"];

var Table = function Table(_ref35) {
  var _ref35$variant = _ref35.variant,
      variant = _ref35$variant === void 0 ? "simple" : _ref35$variant,
      children = _ref35.children,
      rest = _objectWithoutProperties(_ref35, ["variant", "children"]);

  return React__default.createElement(Table$1, _objectSpread({
    variant: variant
  }, rest), children);
};

var Thead = function Thead(_ref36) {
  var children = _ref36.children,
      rest = _objectWithoutProperties(_ref36, ["children"]);

  return React__default.createElement(Thead$1, _objectSpread({}, rest), children);
};

var Tbody = function Tbody(_ref37) {
  var children = _ref37.children,
      rest = _objectWithoutProperties(_ref37, ["children"]);

  return React__default.createElement(Tbody$1, _objectSpread({}, rest), children);
};

var TableCaption = function TableCaption(_ref38) {
  var children = _ref38.children,
      rest = _objectWithoutProperties(_ref38, ["children"]);

  return React__default.createElement(TableCaption$1, _objectSpread({}, rest), children);
};

var Tfoot = function Tfoot(_ref39) {
  var children = _ref39.children,
      rest = _objectWithoutProperties(_ref39, ["children"]);

  return React__default.createElement(Tfoot$1, _objectSpread({}, rest), children);
};

var Th = function Th(_ref40) {
  var children = _ref40.children,
      rest = _objectWithoutProperties(_ref40, ["children"]);

  return React__default.createElement(Th$1, _objectSpread({}, rest), children);
};

var Tr = function Tr(_ref41) {
  var children = _ref41.children,
      rest = _objectWithoutProperties(_ref41, ["children"]);

  return React__default.createElement(Tr$1, _objectSpread({}, rest), children);
};

var Td = function Td(_ref42) {
  var children = _ref42.children,
      rest = _objectWithoutProperties(_ref42, ["children"]);

  return React__default.createElement(Td$1, _objectSpread({}, rest), children);
};

function assignRef(ref, value) {
  if (ref == null) return;

  if (isFunction(ref)) {
    ref(value);
    return;
  }

  try {
    ref.current = value;
  } catch (error) {
    throw new Error("Cannot assign value '" + value + "' to ref '" + ref + "'");
  }
}

function mergeRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return function (node) {
    refs.forEach(function (ref) {
      return assignRef(ref, node);
    });
  };
}

function createContext(options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$strict = _options.strict,
      strict = _options$strict === void 0 ? true : _options$strict,
      _options$errorMessage = _options.errorMessage,
      errorMessage = _options$errorMessage === void 0 ? "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider" : _options$errorMessage,
      name = _options.name;
  var Context =
  /* @__PURE__ */
  React.createContext(void 0);
  Context.displayName = name;

  function useContext() {
    var context = React.useContext(Context);

    if (!context && strict) {
      var error = new Error(errorMessage);
      error.name = "ContextError";
      Error.captureStackTrace == null ? void 0 : Error.captureStackTrace(error, useContext);
      throw error;
    }

    return context;
  }

  return [Context.Provider, useContext, Context];
}

function getValidChildren(children) {
  return React.Children.toArray(children).filter(function (child) {
    return (
      /* @__PURE__ */
      React.isValidElement(child)
    );
  });
}

var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [top, bottom, right, left];
var start = "start";
var end = "end";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements =
/* @__PURE__ */
basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements =
/* @__PURE__ */
[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []);
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead";
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain";
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || "").toLowerCase() : null;
}

function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== "[object Window]") {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

function applyStyles(_ref) {
  var state2 = _ref.state;
  Object.keys(state2.elements).forEach(function (name) {
    var style = state2.styles[name] || {};
    var attributes = state2.attributes[name] || {};
    var element = state2.elements[name];

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    }

    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name2) {
      var value = attributes[name2];

      if (value === false) {
        element.removeAttribute(name2);
      } else {
        element.setAttribute(name2, value === true ? "" : value);
      }
    });
  });
}

function effect$3(_ref2) {
  var state2 = _ref2.state;
  var initialStyles = {
    popper: {
      position: state2.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  Object.assign(state2.elements.popper.style, initialStyles.popper);
  state2.styles = initialStyles;

  if (state2.elements.arrow) {
    Object.assign(state2.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state2.elements).forEach(function (name) {
      var element = state2.elements[name];
      var attributes = state2.attributes[name] || {};
      var styleProperties = Object.keys(state2.styles.hasOwnProperty(name) ? state2.styles[name] : initialStyles[name]);
      var style = styleProperties.reduce(function (style2, property) {
        style2[property] = "";
        return style2;
      }, {});

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
}

var applyStyles$1 = {
  name: "applyStyles",
  enabled: true,
  phase: "write",
  fn: applyStyles,
  effect: effect$3,
  requires: ["computeStyles"]
};

function getBasePlacement(placement) {
  return placement.split("-")[0];
}

var max = Math.max;
var min = Math.min;
var round = Math.round;

function getBoundingClientRect(element, includeScale) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  var rect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (isHTMLElement(element) && includeScale) {
    var offsetHeight = element.offsetHeight;
    var offsetWidth = element.offsetWidth;

    if (offsetWidth > 0) {
      scaleX = round(rect.width) / offsetWidth || 1;
    }

    if (offsetHeight > 0) {
      scaleY = round(rect.height) / offsetHeight || 1;
    }
  }

  return {
    width: rect.width / scaleX,
    height: rect.height / scaleY,
    top: rect.top / scaleY,
    right: rect.right / scaleX,
    bottom: rect.bottom / scaleY,
    left: rect.left / scaleX,
    x: rect.left / scaleX,
    y: rect.top / scaleY
  };
}

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element);
  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode();

  if (parent.contains(child)) {
    return true;
  } else if (rootNode && isShadowRoot(rootNode)) {
    var next = child;

    do {
      if (next && parent.isSameNode(next)) {
        return true;
      }

      next = next.parentNode || next.host;
    } while (next);
  }

  return false;
}

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ["table", "td", "th"].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === "html") {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element)
  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === "fixed") {
    return null;
  }

  return element.offsetParent;
}

function getContainingBlock(element) {
  var isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1;
  var isIE = navigator.userAgent.indexOf("Trident") !== -1;

  if (isIE && isHTMLElement(element)) {
    var elementCss = getComputedStyle(element);

    if (elementCss.position === "fixed") {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  while (isHTMLElement(currentNode) && ["html", "body"].indexOf(getNodeName(currentNode)) < 0) {
    var css4 = getComputedStyle(currentNode);

    if (css4.transform !== "none" || css4.perspective !== "none" || css4.contain === "paint" || ["transform", "perspective"].indexOf(css4.willChange) !== -1 || isFirefox && css4.willChange === "filter" || isFirefox && css4.filter && css4.filter !== "none") {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
}

function getOffsetParent(element) {
  var window2 = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle(offsetParent).position === "static")) {
    return window2;
  }

  return offsetParent || getContainingBlock(element) || window2;
}

function getMainAxisFromPlacement(placement) {
  return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
}

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}

function withinMaxClamp(min2, value, max2) {
  var v = within(min2, value, max2);
  return v > max2 ? max2 : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject2(padding, state2) {
  padding = typeof padding === "function" ? padding(Object.assign({}, state2.rects, {
    placement: state2.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state2 = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state2.elements.arrow;
  var popperOffsets2 = state2.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state2.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? "height" : "width";

  if (!arrowElement || !popperOffsets2) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state2);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === "y" ? top : left;
  var maxProp = axis === "y" ? bottom : right;
  var endDiff = state2.rects.reference[len] + state2.rects.reference[axis] - popperOffsets2[axis] - state2.rects.popper[len];
  var startDiff = popperOffsets2[axis] - state2.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2;
  var min2 = paddingObject[minProp];
  var max2 = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset2 = within(min2, center, max2);
  var axisProp = axis;
  state2.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset2, _state$modifiersData$.centerOffset = offset2 - center, _state$modifiersData$);
}

function effect$2(_ref2) {
  var state2 = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;

  if (arrowElement == null) {
    return;
  }

  if (typeof arrowElement === "string") {
    arrowElement = state2.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (process.env.NODE_ENV !== "production") {
    if (!isHTMLElement(arrowElement)) {
      console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', "To use an SVG arrow, wrap it in an HTMLElement that will be used as", "the arrow."].join(" "));
    }
  }

  if (!contains(state2.elements.popper, arrowElement)) {
    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', "element."].join(" "));
    }

    return;
  }

  state2.elements.arrow = arrowElement;
}

var arrow$1 = {
  name: "arrow",
  enabled: true,
  phase: "main",
  fn: arrow,
  effect: effect$2,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};

function getVariation(placement) {
  return placement.split("-")[1];
}

var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper2 = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position2 = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;

  var _ref3 = roundOffsets === true ? roundOffsetsByDPR(offsets) : typeof roundOffsets === "function" ? roundOffsets(offsets) : offsets,
      _ref3$x = _ref3.x,
      x = _ref3$x === void 0 ? 0 : _ref3$x,
      _ref3$y = _ref3.y,
      y = _ref3$y === void 0 ? 0 : _ref3$y;

  var hasX = offsets.hasOwnProperty("x");
  var hasY = offsets.hasOwnProperty("y");
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper2);
    var heightProp = "clientHeight";
    var widthProp = "clientWidth";

    if (offsetParent === getWindow(popper2)) {
      offsetParent = getDocumentElement(popper2);

      if (getComputedStyle(offsetParent).position !== "static" && position2 === "absolute") {
        heightProp = "scrollHeight";
        widthProp = "scrollWidth";
      }
    }

    offsetParent = offsetParent;

    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position2
  }, adaptive && unsetSides);

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}

function computeStyles(_ref4) {
  var state2 = _ref4.state,
      options = _ref4.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  if (process.env.NODE_ENV !== "production") {
    var transitionProperty2 = getComputedStyle(state2.elements.popper).transitionProperty || "";

    if (adaptive && ["transform", "top", "right", "bottom", "left"].some(function (property) {
      return transitionProperty2.indexOf(property) >= 0;
    })) {
      console.warn(["Popper: Detected CSS transitions on at least one of the following", 'CSS properties: "transform", "top", "right", "bottom", "left".', "\n\n", 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', "for smooth transitions, or remove these properties from the CSS", "transition declaration on the popper element if only transitioning", "opacity or background-color for example.", "\n\n", "We recommend using the popper element as a wrapper around an inner", "element that can have any CSS property transitioned for animations."].join(" "));
    }
  }

  var commonStyles = {
    placement: getBasePlacement(state2.placement),
    variation: getVariation(state2.placement),
    popper: state2.elements.popper,
    popperRect: state2.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state2.options.strategy === "fixed"
  };

  if (state2.modifiersData.popperOffsets != null) {
    state2.styles.popper = Object.assign({}, state2.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state2.modifiersData.popperOffsets,
      position: state2.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state2.modifiersData.arrow != null) {
    state2.styles.arrow = Object.assign({}, state2.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state2.modifiersData.arrow,
      position: "absolute",
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state2.attributes.popper = Object.assign({}, state2.attributes.popper, {
    "data-popper-placement": state2.placement
  });
}

var computeStyles$1 = {
  name: "computeStyles",
  enabled: true,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: true
};

function effect$1(_ref) {
  var state2 = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll2 = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window2 = getWindow(state2.elements.popper);
  var scrollParents = [].concat(state2.scrollParents.reference, state2.scrollParents.popper);

  if (scroll2) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener("scroll", instance.update, passive);
    });
  }

  if (resize) {
    window2.addEventListener("resize", instance.update, passive);
  }

  return function () {
    if (scroll2) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener("scroll", instance.update, passive);
      });
    }

    if (resize) {
      window2.removeEventListener("resize", instance.update, passive);
    }
  };
}

var eventListeners = {
  name: "eventListeners",
  enabled: true,
  phase: "write",
  fn: function fn() {},
  effect: effect$1,
  data: {}
};
var hash$1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};

function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: "end",
  end: "start"
};

function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;

    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle(body || html).direction === "rtl") {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (["html", "body", "#document"].indexOf(getNodeName(node)) >= 0) {
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

function listScrollParents(element, list2) {
  var _element$ownerDocumen;

  if (list2 === void 0) {
    list2 = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list2.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element) {
  var rect = getBoundingClientRect(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
}

function getClippingParents(element) {
  var clippingParents2 = listScrollParents(getParentNode(element));
  var canEscapeClipping = ["absolute", "fixed"].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  }

  return clippingParents2.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== "body" && (canEscapeClipping ? getComputedStyle(clippingParent).position !== "static" : true);
  });
}

function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
  var clippingParents2 = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents2[0];
  var clippingRect = clippingParents2.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference2 = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference2.x + reference2.width / 2 - element.width / 2;
  var commonY = reference2.y + reference2.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference2.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference2.y + reference2.height
      };
      break;

    case right:
      offsets = {
        x: reference2.x + reference2.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference2.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference2.x,
        y: reference2.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === "y" ? "height" : "width";

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference2[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference2[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state2, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state2.placement : _options$placement,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state2.rects.popper;
  var element = state2.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state2.elements.popper), boundary, rootBoundary);
  var referenceClientRect = getBoundingClientRect(state2.elements.reference);
  var popperOffsets2 = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: "absolute",
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets2));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect;
  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state2.modifiersData.offset;

  if (elementContext === popper && offsetData) {
    var offset2 = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply3 = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? "y" : "x";
      overflowOffsets[key] += offset2[axis] * multiply3;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state2, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement2) {
    return getVariation(placement2) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement2) {
    return allowedAutoPlacements.indexOf(placement2) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;

    if (process.env.NODE_ENV !== "production") {
      console.error(["Popper: The `allowedAutoPlacements` option did not allow any", "placements. Ensure the `placement` option matches the variation", "of the allowed placements.", 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(" "));
    }
  }

  var overflows = allowedPlacements.reduce(function (acc, placement2) {
    acc[placement2] = detectOverflow(state2, {
      placement: placement2,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement2)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state2 = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state2.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state2.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements2 = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement2) {
    return acc.concat(getBasePlacement(placement2) === auto ? computeAutoPlacement(state2, {
      placement: placement2,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement2);
  }, []);
  var referenceRect = state2.rects.reference;
  var popperRect = state2.rects.popper;
  var checksMap =
  /* @__PURE__ */
  new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements2[0];

  for (var i = 0; i < placements2.length; i++) {
    var placement = placements2[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? "width" : "height";
    var overflow = detectOverflow(state2, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop2(_i2) {
      var fittingPlacement = placements2.find(function (placement2) {
        var checks2 = checksMap.get(placement2);

        if (checks2) {
          return checks2.slice(0, _i2).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state2.placement !== firstFittingPlacement) {
    state2.modifiersData[name]._skip = true;
    state2.placement = firstFittingPlacement;
    state2.reset = true;
  }
}

var flip$1 = {
  name: "flip",
  enabled: true,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state2 = _ref.state,
      name = _ref.name;
  var referenceRect = state2.rects.reference;
  var popperRect = state2.rects.popper;
  var preventedOffsets = state2.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state2, {
    elementContext: "reference"
  });
  var popperAltOverflow = detectOverflow(state2, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state2.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state2.attributes.popper = Object.assign({}, state2.attributes.popper, {
    "data-popper-reference-hidden": isReferenceHidden,
    "data-popper-escaped": hasPopperEscaped
  });
}

var hide$1 = {
  name: "hide",
  enabled: true,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset2) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset2 === "function" ? offset2(Object.assign({}, rects, {
    placement: placement
  })) : offset2,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state2 = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset2 = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state2.rects, offset2);
    return acc;
  }, {});
  var _data$state$placement = data[state2.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state2.modifiersData.popperOffsets != null) {
    state2.modifiersData.popperOffsets.x += x;
    state2.modifiersData.popperOffsets.y += y;
  }

  state2.modifiersData[name] = data;
}

var offset$1 = {
  name: "offset",
  enabled: true,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};

function popperOffsets(_ref) {
  var state2 = _ref.state,
      name = _ref.name;
  state2.modifiersData[name] = computeOffsets({
    reference: state2.rects.reference,
    element: state2.rects.popper,
    strategy: "absolute",
    placement: state2.placement
  });
}

var popperOffsets$1 = {
  name: "popperOffsets",
  enabled: true,
  phase: "read",
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === "x" ? "y" : "x";
}

function preventOverflow(_ref) {
  var state2 = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state2, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state2.placement);
  var variation = getVariation(state2.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets2 = state2.modifiersData.popperOffsets;
  var referenceRect = state2.rects.reference;
  var popperRect = state2.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state2.rects, {
    placement: state2.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state2.modifiersData.offset ? state2.modifiersData.offset[state2.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets2) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === "y" ? top : left;
    var altSide = mainAxis === "y" ? bottom : right;
    var len = mainAxis === "y" ? "height" : "width";
    var offset2 = popperOffsets2[mainAxis];
    var min$1 = offset2 + overflow[mainSide];
    var max$1 = offset2 - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len];
    var arrowElement = state2.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state2.modifiersData["arrow#persistent"] ? state2.modifiersData["arrow#persistent"].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide];
    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state2.elements.arrow && getOffsetParent(state2.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset2 + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset2 + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset2, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets2[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset2;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === "x" ? top : left;

    var _altSide = mainAxis === "x" ? bottom : right;

    var _offset = popperOffsets2[altAxis];

    var _len = altAxis === "y" ? "height" : "width";

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets2[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state2.modifiersData[name] = data;
}

var preventOverflow$1 = {
  name: "preventOverflow",
  enabled: true,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
}

function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled);
  var scroll2 = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll2 = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll2.scrollLeft - offsets.x,
    y: rect.top + scroll2.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map =
  /* @__PURE__ */
  new Map();
  var visited =
  /* @__PURE__ */
  new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  });

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  var orderedModifiers = order(modifiers);
  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn6) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = void 0;
          resolve(fn6());
        });
      });
    }

    return pending;
  };
}

function format(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return [].concat(args).reduce(function (p, c) {
    return p.replace(/%s/, c);
  }, str);
}

var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ["name", "enabled", "phase", "fn", "effect", "requires", "options"];

function validateModifiers(modifiers) {
  modifiers.forEach(function (modifier) {
    [].concat(Object.keys(modifier), VALID_PROPERTIES).filter(function (value, index2, self2) {
      return self2.indexOf(value) === index2;
    }).forEach(function (key) {
      switch (key) {
        case "name":
          if (typeof modifier.name !== "string") {
            console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', '"' + String(modifier.name) + '"'));
          }

          break;

        case "enabled":
          if (typeof modifier.enabled !== "boolean") {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', '"' + String(modifier.enabled) + '"'));
          }

          break;

        case "phase":
          if (modifierPhases.indexOf(modifier.phase) < 0) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(", "), '"' + String(modifier.phase) + '"'));
          }

          break;

        case "fn":
          if (typeof modifier.fn !== "function") {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', '"' + String(modifier.fn) + '"'));
          }

          break;

        case "effect":
          if (modifier.effect != null && typeof modifier.effect !== "function") {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', '"' + String(modifier.fn) + '"'));
          }

          break;

        case "requires":
          if (modifier.requires != null && !Array.isArray(modifier.requires)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', '"' + String(modifier.requires) + '"'));
          }

          break;

        case "requiresIfExists":
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', '"' + String(modifier.requiresIfExists) + '"'));
          }

          break;

        case "options":
        case "data":
          break;

        default:
          console.error('PopperJS: an invalid property has been provided to the "' + modifier.name + '" modifier, valid properties are ' + VALID_PROPERTIES.map(function (s) {
            return '"' + s + '"';
          }).join(", ") + '; but "' + key + '" was provided.');
      }

      modifier.requires && modifier.requires.forEach(function (requirement) {
        if (modifiers.find(function (mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}

function uniqueBy(arr, fn6) {
  var identifiers =
  /* @__PURE__ */
  new Set();
  return arr.filter(function (item) {
    var identifier = fn6(item);

    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged2, current) {
    var existing = merged2[current.name];
    merged2[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged2;
  }, {});
  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var INVALID_ELEMENT_ERROR = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.";
var INFINITE_LOOP_ERROR = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.";
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === "function");
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper2(reference2, popper2, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state2 = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference2,
        popper: popper2
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state2,
      setOptions: function setOptions(setOptionsAction) {
        var options2 = typeof setOptionsAction === "function" ? setOptionsAction(state2.options) : setOptionsAction;
        cleanupModifierEffects();
        state2.options = Object.assign({}, defaultOptions, state2.options, options2);
        state2.scrollParents = {
          reference: isElement(reference2) ? listScrollParents(reference2) : reference2.contextElement ? listScrollParents(reference2.contextElement) : [],
          popper: listScrollParents(popper2)
        };
        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers2, state2.options.modifiers)));
        state2.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });

        if (process.env.NODE_ENV !== "production") {
          var modifiers = uniqueBy([].concat(orderedModifiers, state2.options.modifiers), function (_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);

          if (getBasePlacement(state2.options.placement) === auto) {
            var flipModifier = state2.orderedModifiers.find(function (_ref2) {
              var name = _ref2.name;
              return name === "flip";
            });

            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', "present and enabled to work."].join(" "));
            }
          }

          var _getComputedStyle = getComputedStyle(popper2),
              marginTop = _getComputedStyle.marginTop,
              marginRight = _getComputedStyle.marginRight,
              marginBottom = _getComputedStyle.marginBottom,
              marginLeft = _getComputedStyle.marginLeft;

          if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', "between the popper and its reference element or boundary.", "To replicate margin, use the `offset` modifier, as well as", "the `padding` option in the `preventOverflow` and `flip`", "modifiers."].join(" "));
          }
        }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state2.elements,
            reference3 = _state$elements.reference,
            popper3 = _state$elements.popper;

        if (!areValidElements(reference3, popper3)) {
          if (process.env.NODE_ENV !== "production") {
            console.error(INVALID_ELEMENT_ERROR);
          }

          return;
        }

        state2.rects = {
          reference: getCompositeRect(reference3, getOffsetParent(popper3), state2.options.strategy === "fixed"),
          popper: getLayoutRect(popper3)
        };
        state2.reset = false;
        state2.placement = state2.options.placement;
        state2.orderedModifiers.forEach(function (modifier) {
          return state2.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index2 = 0; index2 < state2.orderedModifiers.length; index2++) {
          if (process.env.NODE_ENV !== "production") {
            __debug_loops__ += 1;

            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }

          if (state2.reset === true) {
            state2.reset = false;
            index2 = -1;
            continue;
          }

          var _state$orderedModifie = state2.orderedModifiers[index2],
              fn6 = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn6 === "function") {
            state2 = fn6({
              state: state2,
              options: _options,
              name: name,
              instance: instance
            }) || state2;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state2);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference2, popper2)) {
      if (process.env.NODE_ENV !== "production") {
        console.error(INVALID_ELEMENT_ERROR);
      }

      return instance;
    }

    instance.setOptions(options).then(function (state3) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state3);
      }
    });

    function runModifierEffects() {
      state2.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options2 = _ref3$options === void 0 ? {} : _ref3$options,
            effect5 = _ref3.effect;

        if (typeof effect5 === "function") {
          var cleanupFn = effect5({
            state: state2,
            name: name,
            instance: instance,
            options: options2
          });

          var noopFn = function noopFn2() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn6) {
        return fn6();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper =
/* @__PURE__ */
popperGenerator({
  defaultModifiers: defaultModifiers
});

function _objectWithoutPropertiesLoose$5(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _extends$7() {
  _extends$7 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$7.apply(this, arguments);
}

var toVar = function toVar2(value, fallback) {
  return {
    "var": value,
    varRef: fallback ? "var(" + value + ", " + fallback + ")" : "var(" + value + ")"
  };
};

var cssVars = {
  arrowShadowColor: toVar("--popper-arrow-shadow-color"),
  arrowSize: toVar("--popper-arrow-size", "8px"),
  arrowSizeHalf: toVar("--popper-arrow-size-half"),
  arrowBg: toVar("--popper-arrow-bg"),
  transformOrigin: toVar("--popper-transform-origin"),
  arrowOffset: toVar("--popper-arrow-offset")
};

function getBoxShadow(placement) {
  if (placement.includes("top")) return "1px 1px 1px 0 var(--popper-arrow-shadow-color)";
  if (placement.includes("bottom")) return "-1px -1px 1px 0 var(--popper-arrow-shadow-color)";
  if (placement.includes("right")) return "-1px 1px 1px 0 var(--popper-arrow-shadow-color)";
  if (placement.includes("left")) return "1px -1px 1px 0 var(--popper-arrow-shadow-color)";
}

var transforms = {
  top: "bottom center",
  "top-start": "bottom left",
  "top-end": "bottom right",
  bottom: "top center",
  "bottom-start": "top left",
  "bottom-end": "top right",
  left: "right center",
  "left-start": "right top",
  "left-end": "right bottom",
  right: "left center",
  "right-start": "left top",
  "right-end": "left bottom"
};

var toTransformOrigin = function toTransformOrigin2(placement) {
  return transforms[placement];
};

var defaultEventListeners = {
  scroll: true,
  resize: true
};

function getEventListenerOptions(value) {
  var eventListeners2;

  if (_typeof(value) === "object") {
    eventListeners2 = {
      enabled: true,
      options: _extends$7({}, defaultEventListeners, value)
    };
  } else {
    eventListeners2 = {
      enabled: value,
      options: defaultEventListeners
    };
  }

  return eventListeners2;
}

var matchWidth = {
  name: "matchWidth",
  enabled: true,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: function fn2(_ref) {
    var state2 = _ref.state;
    state2.styles.popper.width = state2.rects.reference.width + "px";
  },
  effect: function effect(_ref2) {
    var state2 = _ref2.state;
    return function () {
      var reference2 = state2.elements.reference;
      state2.elements.popper.style.width = reference2.offsetWidth + "px";
    };
  }
};
var transformOrigin = {
  name: "transformOrigin",
  enabled: true,
  phase: "write",
  fn: function fn3(_ref3) {
    var state2 = _ref3.state;
    setTransformOrigin(state2);
  },
  effect: function effect2(_ref4) {
    var state2 = _ref4.state;
    return function () {
      setTransformOrigin(state2);
    };
  }
};

var setTransformOrigin = function setTransformOrigin2(state2) {
  state2.elements.popper.style.setProperty(cssVars.transformOrigin["var"], toTransformOrigin(state2.placement));
};

var positionArrow = {
  name: "positionArrow",
  enabled: true,
  phase: "afterWrite",
  fn: function fn4(_ref5) {
    var state2 = _ref5.state;
    setArrowStyles(state2);
  }
};

var setArrowStyles = function setArrowStyles2(state2) {
  var _state$elements;

  if (!state2.placement) return;
  var overrides = getArrowStyle$1(state2.placement);

  if ((_state$elements = state2.elements) != null && _state$elements.arrow && overrides) {
    var _Object$assign, _vars;

    Object.assign(state2.elements.arrow.style, (_Object$assign = {}, _Object$assign[overrides.property] = overrides.value, _Object$assign.width = cssVars.arrowSize.varRef, _Object$assign.height = cssVars.arrowSize.varRef, _Object$assign.zIndex = -1, _Object$assign));
    var vars = (_vars = {}, _vars[cssVars.arrowSizeHalf["var"]] = "calc(" + cssVars.arrowSize.varRef + " / 2)", _vars[cssVars.arrowOffset["var"]] = "calc(" + cssVars.arrowSizeHalf.varRef + " * -1)", _vars);

    for (var property in vars) {
      state2.elements.arrow.style.setProperty(property, vars[property]);
    }
  }
};

var getArrowStyle$1 = function getArrowStyle(placement) {
  if (placement.startsWith("top")) {
    return {
      property: "bottom",
      value: cssVars.arrowOffset.varRef
    };
  }

  if (placement.startsWith("bottom")) {
    return {
      property: "top",
      value: cssVars.arrowOffset.varRef
    };
  }

  if (placement.startsWith("left")) {
    return {
      property: "right",
      value: cssVars.arrowOffset.varRef
    };
  }

  if (placement.startsWith("right")) {
    return {
      property: "left",
      value: cssVars.arrowOffset.varRef
    };
  }
};

var innerArrow = {
  name: "innerArrow",
  enabled: true,
  phase: "main",
  requires: ["arrow"],
  fn: function fn5(_ref6) {
    var state2 = _ref6.state;
    setInnerArrowStyles(state2);
  },
  effect: function effect3(_ref7) {
    var state2 = _ref7.state;
    return function () {
      setInnerArrowStyles(state2);
    };
  }
};

var setInnerArrowStyles = function setInnerArrowStyles2(state2) {
  if (!state2.elements.arrow) return;
  var inner = state2.elements.arrow.querySelector("[data-popper-arrow-inner]");
  if (!inner) return;
  Object.assign(inner.style, {
    transform: "rotate(45deg)",
    background: cssVars.arrowBg.varRef,
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    position: "absolute",
    zIndex: "inherit",
    boxShadow: getBoxShadow(state2.placement)
  });
};

var logicals = {
  "start-start": {
    ltr: "left-start",
    rtl: "right-start"
  },
  "start-end": {
    ltr: "left-end",
    rtl: "right-end"
  },
  "end-start": {
    ltr: "right-start",
    rtl: "left-start"
  },
  "end-end": {
    ltr: "right-end",
    rtl: "left-end"
  },
  start: {
    ltr: "left",
    rtl: "right"
  },
  end: {
    ltr: "right",
    rtl: "left"
  }
};
var opposites = {
  "auto-start": "auto-end",
  "auto-end": "auto-start",
  "top-start": "top-end",
  "top-end": "top-start",
  "bottom-start": "bottom-end",
  "bottom-end": "bottom-start"
};

function getPopperPlacement(placement, dir) {
  var _logicals$placement, _opposites$placement;

  if (dir === void 0) {
    dir = "ltr";
  }

  var value = ((_logicals$placement = logicals[placement]) == null ? void 0 : _logicals$placement[dir]) || placement;
  if (dir === "ltr") return value;
  return (_opposites$placement = opposites[placement]) != null ? _opposites$placement : value;
}

var _excluded$k = ["size", "shadowColor", "bg", "style"];

function usePopper(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      _props$enabled = _props.enabled,
      enabled = _props$enabled === void 0 ? true : _props$enabled,
      modifiers = _props.modifiers,
      _props$placement = _props.placement,
      placementProp = _props$placement === void 0 ? "bottom" : _props$placement,
      _props$strategy = _props.strategy,
      strategy = _props$strategy === void 0 ? "absolute" : _props$strategy,
      _props$arrowPadding = _props.arrowPadding,
      arrowPadding = _props$arrowPadding === void 0 ? 8 : _props$arrowPadding,
      _props$eventListeners = _props.eventListeners,
      eventListeners2 = _props$eventListeners === void 0 ? true : _props$eventListeners,
      offset2 = _props.offset,
      _props$gutter = _props.gutter,
      gutter = _props$gutter === void 0 ? 8 : _props$gutter,
      _props$flip = _props.flip,
      flip2 = _props$flip === void 0 ? true : _props$flip,
      _props$boundary = _props.boundary,
      boundary = _props$boundary === void 0 ? "clippingParents" : _props$boundary,
      _props$preventOverflo = _props.preventOverflow,
      preventOverflow2 = _props$preventOverflo === void 0 ? true : _props$preventOverflo,
      matchWidth$1 = _props.matchWidth,
      _props$direction = _props.direction,
      direction = _props$direction === void 0 ? "ltr" : _props$direction;
  var reference2 = useRef(null);
  var popper2 = useRef(null);
  var instance = useRef(null);
  var placement = getPopperPlacement(placementProp, direction);
  var cleanup = useRef(function () {});
  var setupPopper = useCallback(function () {
    if (!enabled || !reference2.current || !popper2.current) return;
    cleanup.current == null ? void 0 : cleanup.current();
    instance.current = createPopper(reference2.current, popper2.current, {
      placement: placement,
      modifiers: [innerArrow, positionArrow, transformOrigin, _extends$7({}, matchWidth, {
        enabled: !!matchWidth$1
      }), _extends$7({
        name: "eventListeners"
      }, getEventListenerOptions(eventListeners2)), {
        name: "arrow",
        options: {
          padding: arrowPadding
        }
      }, {
        name: "offset",
        options: {
          offset: offset2 != null ? offset2 : [0, gutter]
        }
      }, {
        name: "flip",
        enabled: !!flip2,
        options: {
          padding: 8
        }
      }, {
        name: "preventOverflow",
        enabled: !!preventOverflow2,
        options: {
          boundary: boundary
        }
      }].concat(modifiers != null ? modifiers : []),
      strategy: strategy
    });
    instance.current.forceUpdate();
    cleanup.current = instance.current.destroy;
  }, [placement, enabled, modifiers, matchWidth$1, eventListeners2, arrowPadding, offset2, gutter, flip2, preventOverflow2, boundary, strategy]);
  useEffect(function () {
    return function () {
      if (!reference2.current && !popper2.current) {
        var _instance$current;

        (_instance$current = instance.current) == null ? void 0 : _instance$current.destroy();
        instance.current = null;
      }
    };
  }, []);
  var referenceRef = useCallback(function (node) {
    reference2.current = node;
    setupPopper();
  }, [setupPopper]);
  var getReferenceProps = useCallback(function (props2, ref) {
    if (props2 === void 0) {
      props2 = {};
    }

    if (ref === void 0) {
      ref = null;
    }

    return _extends$7({}, props2, {
      ref: mergeRefs(referenceRef, ref)
    });
  }, [referenceRef]);
  var popperRef = useCallback(function (node) {
    popper2.current = node;
    setupPopper();
  }, [setupPopper]);
  var getPopperProps = useCallback(function (props2, ref) {
    if (props2 === void 0) {
      props2 = {};
    }

    if (ref === void 0) {
      ref = null;
    }

    return _extends$7({}, props2, {
      ref: mergeRefs(popperRef, ref),
      style: _extends$7({}, props2.style, {
        position: strategy,
        minWidth: "max-content",
        inset: "0 auto auto 0"
      })
    });
  }, [strategy, popperRef]);
  var getArrowProps = useCallback(function (props2, ref) {
    if (props2 === void 0) {
      props2 = {};
    }

    if (ref === void 0) {
      ref = null;
    }

    var _props2 = props2;
    _props2.size;
    _props2.shadowColor;
    _props2.bg;
    _props2.style;

    var rest = _objectWithoutPropertiesLoose$5(_props2, _excluded$k);

    return _extends$7({}, rest, {
      ref: ref,
      "data-popper-arrow": "",
      style: getArrowStyle2(props2)
    });
  }, []);
  var getArrowInnerProps = useCallback(function (props2, ref) {
    if (props2 === void 0) {
      props2 = {};
    }

    if (ref === void 0) {
      ref = null;
    }

    return _extends$7({}, props2, {
      ref: ref,
      "data-popper-arrow-inner": ""
    });
  }, []);
  return {
    update: function update() {
      var _instance$current2;

      (_instance$current2 = instance.current) == null ? void 0 : _instance$current2.update();
    },
    forceUpdate: function forceUpdate() {
      var _instance$current3;

      (_instance$current3 = instance.current) == null ? void 0 : _instance$current3.forceUpdate();
    },
    transformOrigin: cssVars.transformOrigin.varRef,
    referenceRef: referenceRef,
    popperRef: popperRef,
    getPopperProps: getPopperProps,
    getArrowProps: getArrowProps,
    getArrowInnerProps: getArrowInnerProps,
    getReferenceProps: getReferenceProps
  };
}

function getArrowStyle2(props) {
  var size = props.size,
      shadowColor = props.shadowColor,
      bg = props.bg,
      style = props.style;

  var computedStyle = _extends$7({}, style, {
    position: "absolute"
  });

  if (size) {
    computedStyle["--popper-arrow-size"] = size;
  }

  if (shadowColor) {
    computedStyle["--popper-arrow-shadow-color"] = shadowColor;
  }

  if (bg) {
    computedStyle["--popper-arrow-bg"] = bg;
  }

  return computedStyle;
}

var useSafeLayoutEffect = isBrowser ? React.useLayoutEffect : React.useEffect;

function useCallbackRef(fn6, deps) {
  if (deps === void 0) {
    deps = [];
  }

  var ref = React.useRef(fn6);
  useSafeLayoutEffect(function () {
    ref.current = fn6;
  });
  return React.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return ref.current == null ? void 0 : ref.current.apply(ref, args);
  }, deps);
}

function useEventListener(event, handler, env, options) {
  var listener = useCallbackRef(handler);
  React.useEffect(function () {
    var _runIfFn;

    var node = (_runIfFn = runIfFn(env)) != null ? _runIfFn : document;

    if (!handler) {
      return;
    }

    node.addEventListener(event, listener, options);
    return function () {
      node.removeEventListener(event, listener, options);
    };
  }, [event, env, options, listener, handler]);
  return function () {
    var _runIfFn2;

    var node = (_runIfFn2 = runIfFn(env)) != null ? _runIfFn2 : document;
    node.removeEventListener(event, listener, options);
  };
}

function useControllableProp(prop2, state2) {
  var isControlled = prop2 !== void 0;
  var value = isControlled && typeof prop2 !== "undefined" ? prop2 : state2;
  return [isControlled, value];
}

function _extends$6() {
  _extends$6 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$6.apply(this, arguments);
}

var defaultIdContext = {
  current: 1
};
var IdContext =
/* @__PURE__ */
React.createContext(defaultIdContext);

var genId = function genId2(context) {
  return context.current++;
};

function useId(idProp, prefix) {
  var context = React.useContext(IdContext);

  var _React$useState = React.useState(context.current),
      id = _React$useState[0],
      setId = _React$useState[1];

  React.useEffect(function () {
    setId(genId(context));
  }, [context]);
  return React.useMemo(function () {
    return idProp || [prefix, id].filter(Boolean).join("-");
  }, [idProp, prefix, id]);
}

function useDisclosure(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      onCloseProp = _props.onClose,
      onOpenProp = _props.onOpen,
      isOpenProp = _props.isOpen,
      idProp = _props.id;
  var onOpenPropCallbackRef = useCallbackRef(onOpenProp);
  var onClosePropCallbackRef = useCallbackRef(onCloseProp);

  var _React$useState = React.useState(props.defaultIsOpen || false),
      isOpenState = _React$useState[0],
      setIsOpen = _React$useState[1];

  var _useControllableProp = useControllableProp(isOpenProp, isOpenState),
      isControlled = _useControllableProp[0],
      isOpen = _useControllableProp[1];

  var id = useId(idProp, "disclosure");
  var onClose = React.useCallback(function () {
    if (!isControlled) {
      setIsOpen(false);
    }

    onClosePropCallbackRef == null ? void 0 : onClosePropCallbackRef();
  }, [isControlled, onClosePropCallbackRef]);
  var onOpen = React.useCallback(function () {
    if (!isControlled) {
      setIsOpen(true);
    }

    onOpenPropCallbackRef == null ? void 0 : onOpenPropCallbackRef();
  }, [isControlled, onOpenPropCallbackRef]);
  var onToggle = React.useCallback(function () {
    var action = isOpen ? onClose : onOpen;
    action();
  }, [isOpen, onOpen, onClose]);
  return {
    isOpen: !!isOpen,
    onOpen: onOpen,
    onClose: onClose,
    onToggle: onToggle,
    isControlled: isControlled,
    getButtonProps: function getButtonProps(props2) {
      if (props2 === void 0) {
        props2 = {};
      }

      return _extends$6({}, props2, {
        "aria-expanded": "true",
        "aria-controls": id,
        onClick: callAllHandlers(props2.onClick, onToggle)
      });
    },
    getDisclosureProps: function getDisclosureProps(props2) {
      if (props2 === void 0) {
        props2 = {};
      }

      return _extends$6({}, props2, {
        hidden: !isOpen,
        id: id
      });
    }
  };
}

function useUnmountEffect(fn6, deps) {
  if (deps === void 0) {
    deps = [];
  }

  return React.useEffect(function () {
    return function () {
      return fn6();
    };
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  deps);
}

function useForceUpdate() {
  var unloadingRef = React.useRef(false);

  var _React$useState = React.useState(0),
      count = _React$useState[0],
      setCount = _React$useState[1];

  useUnmountEffect(function () {
    unloadingRef.current = true;
  });
  return React.useCallback(function () {
    if (!unloadingRef.current) {
      setCount(count + 1);
    }
  }, [count]);
}

var _createContext$1 = createContext({
  strict: false,
  name: "PortalManagerContext"
}),
    usePortalManager = _createContext$1[1];

function _extends$5() {
  _extends$5 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$5.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$4(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded$j = ["containerRef"];

var _createContext$2 = createContext({
  strict: false,
  name: "PortalContext"
}),
    PortalContextProvider = _createContext$2[0],
    usePortalContext = _createContext$2[1];

var PORTAL_CLASSNAME = "chakra-portal";
var PORTAL_SELECTOR = ".chakra-portal";

var Container$1 = function Container(props) {
  return (
    /* @__PURE__ */
    React.createElement("div", {
      className: "chakra-portal-zIndex",
      style: {
        position: "absolute",
        zIndex: props.zIndex,
        top: 0,
        left: 0,
        right: 0 // NB: Don't add `bottom: 0`, it makes the entire app unusable
        // @see https://github.com/chakra-ui/chakra-ui/issues/3201

      }
    }, props.children)
  );
};

var DefaultPortal = function DefaultPortal2(props) {
  var appendToParentPortal = props.appendToParentPortal,
      children = props.children;
  var tempNode = React.useRef(null);
  var portal = React.useRef(null);
  var forceUpdate = useForceUpdate();
  var parentPortal = usePortalContext();
  var manager = usePortalManager();
  useSafeLayoutEffect(function () {
    if (!tempNode.current) return;
    var doc = tempNode.current.ownerDocument;
    var host = appendToParentPortal ? parentPortal != null ? parentPortal : doc.body : doc.body;
    if (!host) return;
    portal.current = doc.createElement("div");
    portal.current.className = PORTAL_CLASSNAME;
    host.appendChild(portal.current);
    forceUpdate();
    var portalNode = portal.current;
    return function () {
      if (host.contains(portalNode)) {
        host.removeChild(portalNode);
      }
    };
  }, []);

  var _children = manager != null && manager.zIndex ?
  /* @__PURE__ */
  React.createElement(Container$1, {
    zIndex: manager == null ? void 0 : manager.zIndex
  }, children) : children;

  return portal.current ?
  /* @__PURE__ */
  createPortal(
  /* @__PURE__ */
  React.createElement(PortalContextProvider, {
    value: portal.current
  }, _children), portal.current) :
  /* @__PURE__ */
  React.createElement("span", {
    ref: tempNode
  });
};

var ContainerPortal = function ContainerPortal2(props) {
  var children = props.children,
      containerRef = props.containerRef,
      appendToParentPortal = props.appendToParentPortal;
  var containerEl = containerRef.current;
  var host = containerEl != null ? containerEl : isBrowser ? document.body : void 0;
  var portal = React.useMemo(function () {
    var node = containerEl == null ? void 0 : containerEl.ownerDocument.createElement("div");
    if (node) node.className = PORTAL_CLASSNAME;
    return node;
  }, [containerEl]);
  var forceUpdate = useForceUpdate();
  useSafeLayoutEffect(function () {
    forceUpdate();
  }, []);
  useSafeLayoutEffect(function () {
    if (!portal || !host) return;
    host.appendChild(portal);
    return function () {
      host.removeChild(portal);
    };
  }, [portal, host]);

  if (host && portal) {
    return (
      /* @__PURE__ */
      createPortal(
      /* @__PURE__ */
      React.createElement(PortalContextProvider, {
        value: appendToParentPortal ? portal : null
      }, children), portal)
    );
  }

  return null;
};

function Portal(props) {
  var containerRef = props.containerRef,
      rest = _objectWithoutPropertiesLoose$4(props, _excluded$j);

  return containerRef ?
  /* @__PURE__ */
  React.createElement(ContainerPortal, _extends$5({
    containerRef: containerRef
  }, rest)) :
  /* @__PURE__ */
  React.createElement(DefaultPortal, rest);
}

Portal.defaultProps = {
  appendToParentPortal: true
};
Portal.className = PORTAL_CLASSNAME;
Portal.selector = PORTAL_SELECTOR;

if (__DEV__) {
  Portal.displayName = "Portal";
}

var ColorModeContext =
/* @__PURE__ */
React.createContext({});

if (__DEV__) {
  ColorModeContext.displayName = "ColorModeContext";
}

var useColorMode = function useColorMode2() {
  var context = React.useContext(ColorModeContext);

  if (context === void 0) {
    throw new Error("useColorMode must be used within a ColorModeProvider");
  }

  return context;
};

function _extends$4() {
  _extends$4 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$4.apply(this, arguments);
}

var tokenToCSSVar = function tokenToCSSVar2(scale2, value) {
  return function (theme2) {
    var valueStr = String(value);
    var key = scale2 ? scale2 + "." + valueStr : valueStr;
    return isObject(theme2.__cssMap) && key in theme2.__cssMap ? theme2.__cssMap[key].varRef : value;
  };
};

function createTransform(options) {
  var scale2 = options.scale,
      transform10 = options.transform,
      compose = options.compose;

  var fn6 = function fn7(value, theme2) {
    var _transform;

    var _value = tokenToCSSVar(scale2, value)(theme2);

    var result = (_transform = transform10 == null ? void 0 : transform10(_value, theme2)) != null ? _transform : _value;

    if (compose) {
      result = compose(result, theme2);
    }

    return result;
  };

  return fn6;
}

function toConfig(scale2, transform10) {
  return function (property) {
    var result = {
      property: property,
      scale: scale2
    };
    result.transform = createTransform({
      scale: scale2,
      transform: transform10
    });
    return result;
  };
}

var getRtl = function getRtl2(_ref) {
  var rtl = _ref.rtl,
      ltr = _ref.ltr;
  return function (theme2) {
    return theme2.direction === "rtl" ? rtl : ltr;
  };
};

function logical(options) {
  var property = options.property,
      scale2 = options.scale,
      transform10 = options.transform;
  return {
    scale: scale2,
    property: getRtl(property),
    transform: scale2 ? createTransform({
      scale: scale2,
      compose: transform10
    }) : transform10
  };
}

var _spaceXTemplate, _spaceYTemplate;

var transformTemplate = ["rotate(var(--chakra-rotate, 0))", "scaleX(var(--chakra-scale-x, 1))", "scaleY(var(--chakra-scale-y, 1))", "skewX(var(--chakra-skew-x, 0))", "skewY(var(--chakra-skew-y, 0))"];

function getTransformTemplate() {
  return ["translateX(var(--chakra-translate-x, 0))", "translateY(var(--chakra-translate-y, 0))"].concat(transformTemplate).join(" ");
}

function getTransformGpuTemplate() {
  return ["translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)"].concat(transformTemplate).join(" ");
}

var filterTemplate = {
  "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
  filter: ["var(--chakra-blur)", "var(--chakra-brightness)", "var(--chakra-contrast)", "var(--chakra-grayscale)", "var(--chakra-hue-rotate)", "var(--chakra-invert)", "var(--chakra-saturate)", "var(--chakra-sepia)", "var(--chakra-drop-shadow)"].join(" ")
};
var backdropFilterTemplate = {
  backdropFilter: ["var(--chakra-backdrop-blur)", "var(--chakra-backdrop-brightness)", "var(--chakra-backdrop-contrast)", "var(--chakra-backdrop-grayscale)", "var(--chakra-backdrop-hue-rotate)", "var(--chakra-backdrop-invert)", "var(--chakra-backdrop-opacity)", "var(--chakra-backdrop-saturate)", "var(--chakra-backdrop-sepia)"].join(" "),
  "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};

function getRingTemplate(value) {
  return {
    "--chakra-ring-offset-shadow": "var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)",
    "--chakra-ring-shadow": "var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)",
    "--chakra-ring-width": value,
    boxShadow: ["var(--chakra-ring-offset-shadow)", "var(--chakra-ring-shadow)", "var(--chakra-shadow, 0 0 #0000)"].join(", ")
  };
}

var flexDirectionTemplate = {
  "row-reverse": {
    space: "--chakra-space-x-reverse",
    divide: "--chakra-divide-x-reverse"
  },
  "column-reverse": {
    space: "--chakra-space-y-reverse",
    divide: "--chakra-divide-y-reverse"
  }
};
var owlSelector = "& > :not(style) ~ :not(style)";
var spaceXTemplate = (_spaceXTemplate = {}, _spaceXTemplate[owlSelector] = {
  marginInlineStart: "calc(var(--chakra-space-x) * calc(1 - var(--chakra-space-x-reverse)))",
  marginInlineEnd: "calc(var(--chakra-space-x) * var(--chakra-space-x-reverse))"
}, _spaceXTemplate);
var spaceYTemplate = (_spaceYTemplate = {}, _spaceYTemplate[owlSelector] = {
  marginTop: "calc(var(--chakra-space-y) * calc(1 - var(--chakra-space-y-reverse)))",
  marginBottom: "calc(var(--chakra-space-y) * var(--chakra-space-y-reverse))"
}, _spaceYTemplate);

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _wrapRegExp() {
  _wrapRegExp = function _wrapRegExp(re, groups) {
    return new BabelRegExp(re, void 0, groups);
  };

  var _super = RegExp.prototype;

  var _groups =
  /* @__PURE__ */
  new WeakMap();

  function BabelRegExp(re, flags, groups) {
    var _this = new RegExp(re, flags);

    _groups.set(_this, groups || _groups.get(re));

    return _setPrototypeOf(_this, BabelRegExp.prototype);
  }

  _inherits(BabelRegExp, RegExp);

  BabelRegExp.prototype.exec = function (str) {
    var result = _super.exec.call(this, str);

    if (result) result.groups = buildGroups(result, this);
    return result;
  };

  BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
    if (typeof substitution === "string") {
      var groups = _groups.get(this);

      return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
        return "$" + groups[name];
      }));
    } else if (typeof substitution === "function") {
      var _this = this;

      return _super[Symbol.replace].call(this, str, function () {
        var args = arguments;

        if (_typeof(args[args.length - 1]) !== "object") {
          args = [].slice.call(args);
          args.push(buildGroups(args, _this));
        }

        return substitution.apply(this, args);
      });
    } else {
      return _super[Symbol.replace].call(this, str, substitution);
    }
  };

  function buildGroups(result, re) {
    var g = _groups.get(re);

    return Object.keys(g).reduce(function (groups, name) {
      groups[name] = result[g[name]];
      return groups;
    },
    /* @__PURE__ */
    Object.create(null));
  }

  return _wrapRegExp.apply(this, arguments);
}

var directionMap = {
  "to-t": "to top",
  "to-tr": "to top right",
  "to-r": "to right",
  "to-br": "to bottom right",
  "to-b": "to bottom",
  "to-bl": "to bottom left",
  "to-l": "to left",
  "to-tl": "to top left"
};
var valueSet = new Set(Object.values(directionMap));
var globalSet =
/* @__PURE__ */
new Set(["none", "-moz-initial", "inherit", "initial", "revert", "unset"]);

var trimSpace = function trimSpace2(str) {
  return str.trim();
};

function parseGradient(value, theme2) {
  var _regex$exec$groups, _regex$exec;

  if (value == null || globalSet.has(value)) return value;

  var regex =
  /* @__PURE__ */
  _wrapRegExp(/(^[\x2DA-Za-z]+)\(((.*))\)/g, {
    type: 1,
    values: 2
  });

  var _ref = (_regex$exec$groups = (_regex$exec = regex.exec(value)) == null ? void 0 : _regex$exec.groups) != null ? _regex$exec$groups : {},
      type = _ref.type,
      values = _ref.values;

  if (!type || !values) return value;

  var _type = type.includes("-gradient") ? type : type + "-gradient";

  var _values$split$map$fil = values.split(",").map(trimSpace).filter(Boolean),
      maybeDirection = _values$split$map$fil[0],
      stops = _values$split$map$fil.slice(1);

  if ((stops == null ? void 0 : stops.length) === 0) return value;
  var direction = maybeDirection in directionMap ? directionMap[maybeDirection] : maybeDirection;
  stops.unshift(direction);

  var _values = stops.map(function (stop) {
    if (valueSet.has(stop)) return stop;
    var firstStop = stop.indexOf(" ");

    var _ref2 = firstStop !== -1 ? [stop.substr(0, firstStop), stop.substr(firstStop + 1)] : [stop],
        _color = _ref2[0],
        _stop = _ref2[1];

    var _stopOrFunc = isCSSFunction(_stop) ? _stop : _stop && _stop.split(" ");

    var key = "colors." + _color;
    var color2 = key in theme2.__cssMap ? theme2.__cssMap[key].varRef : _color;
    return _stopOrFunc ? [color2].concat(Array.isArray(_stopOrFunc) ? _stopOrFunc : [_stopOrFunc]).join(" ") : color2;
  });

  return _type + "(" + _values.join(", ") + ")";
}

var isCSSFunction = function isCSSFunction2(value) {
  return isString(value) && value.includes("(") && value.includes(")");
};

var gradientTransform = function gradientTransform2(value, theme2) {
  return parseGradient(value, theme2 != null ? theme2 : {});
};

var analyzeCSSValue = function analyzeCSSValue2(value) {
  var num = parseFloat(value.toString());
  var unit = value.toString().replace(String(num), "");
  return {
    unitless: !unit,
    value: num,
    unit: unit
  };
};

var wrap = function wrap2(str) {
  return function (value) {
    return str + "(" + value + ")";
  };
};

var transformFunctions = {
  filter: function filter(value) {
    return value !== "auto" ? value : filterTemplate;
  },
  backdropFilter: function backdropFilter(value) {
    return value !== "auto" ? value : backdropFilterTemplate;
  },
  ring: function ring(value) {
    return getRingTemplate(transformFunctions.px(value));
  },
  bgClip: function bgClip(value) {
    return value === "text" ? {
      color: "transparent",
      backgroundClip: "text"
    } : {
      backgroundClip: value
    };
  },
  transform: function transform(value) {
    if (value === "auto") return getTransformTemplate();
    if (value === "auto-gpu") return getTransformGpuTemplate();
    return value;
  },
  px: function px2(value) {
    if (value == null) return value;

    var _analyzeCSSValue = analyzeCSSValue(value),
        unitless = _analyzeCSSValue.unitless;

    return unitless || isNumber(value) ? value + "px" : value;
  },
  fraction: function fraction(value) {
    return !isNumber(value) || value > 1 ? value : value * 100 + "%";
  },
  "float": function _float(value, theme2) {
    var map = {
      left: "right",
      right: "left"
    };
    return theme2.direction === "rtl" ? map[value] : value;
  },
  degree: function degree(value) {
    if (isCssVar(value) || value == null) return value;
    var unitless = isString(value) && !value.endsWith("deg");
    return isNumber(value) || unitless ? value + "deg" : value;
  },
  gradient: gradientTransform,
  blur: wrap("blur"),
  opacity: wrap("opacity"),
  brightness: wrap("brightness"),
  contrast: wrap("contrast"),
  dropShadow: wrap("drop-shadow"),
  grayscale: wrap("grayscale"),
  hueRotate: wrap("hue-rotate"),
  invert: wrap("invert"),
  saturate: wrap("saturate"),
  sepia: wrap("sepia"),
  bgImage: function bgImage(value) {
    if (value == null) return value;
    var prevent = isCSSFunction(value) || globalSet.has(value);
    return !prevent ? "url(" + value + ")" : value;
  },
  outline: function outline(value) {
    var isNoneOrZero = String(value) === "0" || String(value) === "none";
    return value !== null && isNoneOrZero ? {
      outline: "2px solid transparent",
      outlineOffset: "2px"
    } : {
      outline: value
    };
  },
  flexDirection: function flexDirection(value) {
    var _flexDirectionTemplat;

    var _ref = (_flexDirectionTemplat = flexDirectionTemplate[value]) != null ? _flexDirectionTemplat : {},
        space2 = _ref.space,
        divide3 = _ref.divide;

    var result = {
      flexDirection: value
    };
    if (space2) result[space2] = 1;
    if (divide3) result[divide3] = 1;
    return result;
  }
};
var t = {
  borderWidths: toConfig("borderWidths"),
  borderStyles: toConfig("borderStyles"),
  colors: toConfig("colors"),
  borders: toConfig("borders"),
  radii: toConfig("radii", transformFunctions.px),
  space: toConfig("space", transformFunctions.px),
  spaceT: toConfig("space", transformFunctions.px),
  degreeT: function degreeT(property) {
    return {
      property: property,
      transform: transformFunctions.degree
    };
  },
  prop: function prop(property, scale2, transform10) {
    return _extends$4({
      property: property,
      scale: scale2
    }, scale2 && {
      transform: createTransform({
        scale: scale2,
        transform: transform10
      })
    });
  },
  propT: function propT(property, transform10) {
    return {
      property: property,
      transform: transform10
    };
  },
  sizes: toConfig("sizes", transformFunctions.px),
  sizesT: toConfig("sizes", transformFunctions.fraction),
  shadows: toConfig("shadows"),
  logical: logical,
  blur: toConfig("blur", transformFunctions.blur)
};
var background = {
  background: t.colors("background"),
  backgroundColor: t.colors("backgroundColor"),
  backgroundImage: t.propT("backgroundImage", transformFunctions.bgImage),
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true,
  backgroundAttachment: true,
  backgroundClip: {
    transform: transformFunctions.bgClip
  },
  bgSize: t.prop("backgroundSize"),
  bgPosition: t.prop("backgroundPosition"),
  bg: t.colors("background"),
  bgColor: t.colors("backgroundColor"),
  bgPos: t.prop("backgroundPosition"),
  bgRepeat: t.prop("backgroundRepeat"),
  bgAttachment: t.prop("backgroundAttachment"),
  bgGradient: t.propT("backgroundImage", transformFunctions.gradient),
  bgClip: {
    transform: transformFunctions.bgClip
  }
};
Object.assign(background, {
  bgImage: background.backgroundImage,
  bgImg: background.backgroundImage
});
var border = {
  border: t.borders("border"),
  borderWidth: t.borderWidths("borderWidth"),
  borderStyle: t.borderStyles("borderStyle"),
  borderColor: t.colors("borderColor"),
  borderRadius: t.radii("borderRadius"),
  borderTop: t.borders("borderTop"),
  borderBlockStart: t.borders("borderBlockStart"),
  borderTopLeftRadius: t.radii("borderTopLeftRadius"),
  borderStartStartRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderTopLeftRadius",
      rtl: "borderTopRightRadius"
    }
  }),
  borderEndStartRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomLeftRadius",
      rtl: "borderBottomRightRadius"
    }
  }),
  borderTopRightRadius: t.radii("borderTopRightRadius"),
  borderStartEndRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderTopRightRadius",
      rtl: "borderTopLeftRadius"
    }
  }),
  borderEndEndRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomRightRadius",
      rtl: "borderBottomLeftRadius"
    }
  }),
  borderRight: t.borders("borderRight"),
  borderInlineEnd: t.borders("borderInlineEnd"),
  borderBottom: t.borders("borderBottom"),
  borderBlockEnd: t.borders("borderBlockEnd"),
  borderBottomLeftRadius: t.radii("borderBottomLeftRadius"),
  borderBottomRightRadius: t.radii("borderBottomRightRadius"),
  borderLeft: t.borders("borderLeft"),
  borderInlineStart: {
    property: "borderInlineStart",
    scale: "borders"
  },
  borderInlineStartRadius: t.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
      rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
    }
  }),
  borderInlineEndRadius: t.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
      rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
    }
  }),
  borderX: t.borders(["borderLeft", "borderRight"]),
  borderInline: t.borders("borderInline"),
  borderY: t.borders(["borderTop", "borderBottom"]),
  borderBlock: t.borders("borderBlock"),
  borderTopWidth: t.borderWidths("borderTopWidth"),
  borderBlockStartWidth: t.borderWidths("borderBlockStartWidth"),
  borderTopColor: t.colors("borderTopColor"),
  borderBlockStartColor: t.colors("borderBlockStartColor"),
  borderTopStyle: t.borderStyles("borderTopStyle"),
  borderBlockStartStyle: t.borderStyles("borderBlockStartStyle"),
  borderBottomWidth: t.borderWidths("borderBottomWidth"),
  borderBlockEndWidth: t.borderWidths("borderBlockEndWidth"),
  borderBottomColor: t.colors("borderBottomColor"),
  borderBlockEndColor: t.colors("borderBlockEndColor"),
  borderBottomStyle: t.borderStyles("borderBottomStyle"),
  borderBlockEndStyle: t.borderStyles("borderBlockEndStyle"),
  borderLeftWidth: t.borderWidths("borderLeftWidth"),
  borderInlineStartWidth: t.borderWidths("borderInlineStartWidth"),
  borderLeftColor: t.colors("borderLeftColor"),
  borderInlineStartColor: t.colors("borderInlineStartColor"),
  borderLeftStyle: t.borderStyles("borderLeftStyle"),
  borderInlineStartStyle: t.borderStyles("borderInlineStartStyle"),
  borderRightWidth: t.borderWidths("borderRightWidth"),
  borderInlineEndWidth: t.borderWidths("borderInlineEndWidth"),
  borderRightColor: t.colors("borderRightColor"),
  borderInlineEndColor: t.colors("borderInlineEndColor"),
  borderRightStyle: t.borderStyles("borderRightStyle"),
  borderInlineEndStyle: t.borderStyles("borderInlineEndStyle"),
  borderTopRadius: t.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
  borderBottomRadius: t.radii(["borderBottomLeftRadius", "borderBottomRightRadius"]),
  borderLeftRadius: t.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
  borderRightRadius: t.radii(["borderTopRightRadius", "borderBottomRightRadius"])
};
Object.assign(border, {
  rounded: border.borderRadius,
  roundedTop: border.borderTopRadius,
  roundedTopLeft: border.borderTopLeftRadius,
  roundedTopRight: border.borderTopRightRadius,
  roundedTopStart: border.borderStartStartRadius,
  roundedTopEnd: border.borderStartEndRadius,
  roundedBottom: border.borderBottomRadius,
  roundedBottomLeft: border.borderBottomLeftRadius,
  roundedBottomRight: border.borderBottomRightRadius,
  roundedBottomStart: border.borderEndStartRadius,
  roundedBottomEnd: border.borderEndEndRadius,
  roundedLeft: border.borderLeftRadius,
  roundedRight: border.borderRightRadius,
  roundedStart: border.borderInlineStartRadius,
  roundedEnd: border.borderInlineEndRadius,
  borderStart: border.borderInlineStart,
  borderEnd: border.borderInlineEnd,
  borderTopStartRadius: border.borderStartStartRadius,
  borderTopEndRadius: border.borderStartEndRadius,
  borderBottomStartRadius: border.borderEndStartRadius,
  borderBottomEndRadius: border.borderEndEndRadius,
  borderStartRadius: border.borderInlineStartRadius,
  borderEndRadius: border.borderInlineEndRadius,
  borderStartWidth: border.borderInlineStartWidth,
  borderEndWidth: border.borderInlineEndWidth,
  borderStartColor: border.borderInlineStartColor,
  borderEndColor: border.borderInlineEndColor,
  borderStartStyle: border.borderInlineStartStyle,
  borderEndStyle: border.borderInlineEndStyle
});
var color = {
  color: t.colors("color"),
  textColor: t.colors("color"),
  fill: t.colors("fill"),
  stroke: t.colors("stroke")
};
var effect4 = {
  boxShadow: t.shadows("boxShadow"),
  mixBlendMode: true,
  blendMode: t.prop("mixBlendMode"),
  backgroundBlendMode: true,
  bgBlendMode: t.prop("backgroundBlendMode"),
  opacity: true
};
Object.assign(effect4, {
  shadow: effect4.boxShadow
});
var filter2 = {
  filter: {
    transform: transformFunctions.filter
  },
  blur: t.blur("--chakra-blur"),
  brightness: t.propT("--chakra-brightness", transformFunctions.brightness),
  contrast: t.propT("--chakra-contrast", transformFunctions.contrast),
  hueRotate: t.degreeT("--chakra-hue-rotate"),
  invert: t.propT("--chakra-invert", transformFunctions.invert),
  saturate: t.propT("--chakra-saturate", transformFunctions.saturate),
  dropShadow: t.propT("--chakra-drop-shadow", transformFunctions.dropShadow),
  backdropFilter: {
    transform: transformFunctions.backdropFilter
  },
  backdropBlur: t.blur("--chakra-backdrop-blur"),
  backdropBrightness: t.propT("--chakra-backdrop-brightness", transformFunctions.brightness),
  backdropContrast: t.propT("--chakra-backdrop-contrast", transformFunctions.contrast),
  backdropHueRotate: t.degreeT("--chakra-backdrop-hue-rotate"),
  backdropInvert: t.propT("--chakra-backdrop-invert", transformFunctions.invert),
  backdropSaturate: t.propT("--chakra-backdrop-saturate", transformFunctions.saturate)
};
var flexbox = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: {
    transform: transformFunctions.flexDirection
  },
  experimental_spaceX: {
    "static": spaceXTemplate,
    transform: createTransform({
      scale: "space",
      transform: function transform2(value) {
        return value !== null ? {
          "--chakra-space-x": value
        } : null;
      }
    })
  },
  experimental_spaceY: {
    "static": spaceYTemplate,
    transform: createTransform({
      scale: "space",
      transform: function transform3(value) {
        return value != null ? {
          "--chakra-space-y": value
        } : null;
      }
    })
  },
  flex: true,
  flexFlow: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: t.sizes("flexBasis"),
  justifySelf: true,
  alignSelf: true,
  order: true,
  placeItems: true,
  placeContent: true,
  placeSelf: true,
  gap: t.space("gap"),
  rowGap: t.space("rowGap"),
  columnGap: t.space("columnGap")
};
Object.assign(flexbox, {
  flexDir: flexbox.flexDirection
});
var grid = {
  gridGap: t.space("gridGap"),
  gridColumnGap: t.space("gridColumnGap"),
  gridRowGap: t.space("gridRowGap"),
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridColumnStart: true,
  gridColumnEnd: true,
  gridRowStart: true,
  gridRowEnd: true,
  gridAutoRows: true,
  gridTemplate: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true
};
var interactivity = {
  appearance: true,
  cursor: true,
  resize: true,
  userSelect: true,
  pointerEvents: true,
  outline: {
    transform: transformFunctions.outline
  },
  outlineOffset: true,
  outlineColor: t.colors("outlineColor")
};
var layout = {
  width: t.sizesT("width"),
  inlineSize: t.sizesT("inlineSize"),
  height: t.sizes("height"),
  blockSize: t.sizes("blockSize"),
  boxSize: t.sizes(["width", "height"]),
  minWidth: t.sizes("minWidth"),
  minInlineSize: t.sizes("minInlineSize"),
  minHeight: t.sizes("minHeight"),
  minBlockSize: t.sizes("minBlockSize"),
  maxWidth: t.sizes("maxWidth"),
  maxInlineSize: t.sizes("maxInlineSize"),
  maxHeight: t.sizes("maxHeight"),
  maxBlockSize: t.sizes("maxBlockSize"),
  d: t.prop("display"),
  overflow: true,
  overflowX: true,
  overflowY: true,
  overscrollBehavior: true,
  overscrollBehaviorX: true,
  overscrollBehaviorY: true,
  display: true,
  verticalAlign: true,
  boxSizing: true,
  boxDecorationBreak: true,
  "float": t.propT("float", transformFunctions["float"]),
  objectFit: true,
  objectPosition: true,
  visibility: true,
  isolation: true
};
Object.assign(layout, {
  w: layout.width,
  h: layout.height,
  minW: layout.minWidth,
  maxW: layout.maxWidth,
  minH: layout.minHeight,
  maxH: layout.maxHeight,
  overscroll: layout.overscrollBehavior,
  overscrollX: layout.overscrollBehaviorX,
  overscrollY: layout.overscrollBehaviorY
});
var list = {
  listStyleType: true,
  listStylePosition: true,
  listStylePos: t.prop("listStylePosition"),
  listStyleImage: true,
  listStyleImg: t.prop("listStyleImage")
};
var srOnly = {
  border: "0px",
  clip: "rect(0, 0, 0, 0)",
  width: "1px",
  height: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
};
var srFocusable = {
  position: "static",
  width: "auto",
  height: "auto",
  clip: "auto",
  padding: "0",
  margin: "0",
  overflow: "visible",
  whiteSpace: "normal"
};

var getWithPriority = function getWithPriority2(theme2, key, styles) {
  var result = {};
  var obj = memoizedGet(theme2, key, {});

  for (var prop2 in obj) {
    var isInStyles = prop2 in styles && styles[prop2] != null;
    if (!isInStyles) result[prop2] = obj[prop2];
  }

  return result;
};

var others = {
  srOnly: {
    transform: function transform4(value) {
      if (value === true) return srOnly;
      if (value === "focusable") return srFocusable;
      return {};
    }
  },
  layerStyle: {
    processResult: true,
    transform: function transform5(value, theme2, styles) {
      return getWithPriority(theme2, "layerStyles." + value, styles);
    }
  },
  textStyle: {
    processResult: true,
    transform: function transform6(value, theme2, styles) {
      return getWithPriority(theme2, "textStyles." + value, styles);
    }
  },
  apply: {
    processResult: true,
    transform: function transform7(value, theme2, styles) {
      return getWithPriority(theme2, value, styles);
    }
  }
};
var position = {
  position: true,
  pos: t.prop("position"),
  zIndex: t.prop("zIndex", "zIndices"),
  inset: t.spaceT("inset"),
  insetX: t.spaceT(["left", "right"]),
  insetInline: t.spaceT("insetInline"),
  insetY: t.spaceT(["top", "bottom"]),
  insetBlock: t.spaceT("insetBlock"),
  top: t.spaceT("top"),
  insetBlockStart: t.spaceT("insetBlockStart"),
  bottom: t.spaceT("bottom"),
  insetBlockEnd: t.spaceT("insetBlockEnd"),
  left: t.spaceT("left"),
  insetInlineStart: t.logical({
    scale: "space",
    property: {
      ltr: "left",
      rtl: "right"
    }
  }),
  right: t.spaceT("right"),
  insetInlineEnd: t.logical({
    scale: "space",
    property: {
      ltr: "right",
      rtl: "left"
    }
  })
};
Object.assign(position, {
  insetStart: position.insetInlineStart,
  insetEnd: position.insetInlineEnd
});
var ring2 = {
  ring: {
    transform: transformFunctions.ring
  },
  ringColor: t.colors("--chakra-ring-color"),
  ringOffset: t.prop("--chakra-ring-offset-width"),
  ringOffsetColor: t.colors("--chakra-ring-offset-color"),
  ringInset: t.prop("--chakra-ring-inset")
};
var space = {
  margin: t.spaceT("margin"),
  marginTop: t.spaceT("marginTop"),
  marginBlockStart: t.spaceT("marginBlockStart"),
  marginRight: t.spaceT("marginRight"),
  marginInlineEnd: t.spaceT("marginInlineEnd"),
  marginBottom: t.spaceT("marginBottom"),
  marginBlockEnd: t.spaceT("marginBlockEnd"),
  marginLeft: t.spaceT("marginLeft"),
  marginInlineStart: t.spaceT("marginInlineStart"),
  marginX: t.spaceT(["marginInlineStart", "marginInlineEnd"]),
  marginInline: t.spaceT("marginInline"),
  marginY: t.spaceT(["marginTop", "marginBottom"]),
  marginBlock: t.spaceT("marginBlock"),
  padding: t.space("padding"),
  paddingTop: t.space("paddingTop"),
  paddingBlockStart: t.space("paddingBlockStart"),
  paddingRight: t.space("paddingRight"),
  paddingBottom: t.space("paddingBottom"),
  paddingBlockEnd: t.space("paddingBlockEnd"),
  paddingLeft: t.space("paddingLeft"),
  paddingInlineStart: t.space("paddingInlineStart"),
  paddingInlineEnd: t.space("paddingInlineEnd"),
  paddingX: t.space(["paddingInlineStart", "paddingInlineEnd"]),
  paddingInline: t.space("paddingInline"),
  paddingY: t.space(["paddingTop", "paddingBottom"]),
  paddingBlock: t.space("paddingBlock")
};
Object.assign(space, {
  m: space.margin,
  mt: space.marginTop,
  mr: space.marginRight,
  me: space.marginInlineEnd,
  marginEnd: space.marginInlineEnd,
  mb: space.marginBottom,
  ml: space.marginLeft,
  ms: space.marginInlineStart,
  marginStart: space.marginInlineStart,
  mx: space.marginX,
  my: space.marginY,
  p: space.padding,
  pt: space.paddingTop,
  py: space.paddingY,
  px: space.paddingX,
  pb: space.paddingBottom,
  pl: space.paddingLeft,
  ps: space.paddingInlineStart,
  paddingStart: space.paddingInlineStart,
  pr: space.paddingRight,
  pe: space.paddingInlineEnd,
  paddingEnd: space.paddingInlineEnd
});
var textDecoration = {
  textDecorationColor: t.colors("textDecorationColor"),
  textDecoration: true,
  textDecor: {
    property: "textDecoration"
  },
  textDecorationLine: true,
  textDecorationStyle: true,
  textDecorationThickness: true,
  textUnderlineOffset: true,
  textShadow: t.shadows("textShadow")
};
var transform8 = {
  clipPath: true,
  transform: t.propT("transform", transformFunctions.transform),
  transformOrigin: true,
  translateX: t.spaceT("--chakra-translate-x"),
  translateY: t.spaceT("--chakra-translate-y"),
  skewX: t.degreeT("--chakra-skew-x"),
  skewY: t.degreeT("--chakra-skew-y"),
  scaleX: t.prop("--chakra-scale-x"),
  scaleY: t.prop("--chakra-scale-y"),
  scale: t.prop(["--chakra-scale-x", "--chakra-scale-y"]),
  rotate: t.degreeT("--chakra-rotate")
};
var transition = {
  transition: true,
  transitionDelay: true,
  animation: true,
  willChange: true,
  transitionDuration: t.prop("transitionDuration", "transition.duration"),
  transitionProperty: t.prop("transitionProperty", "transition.property"),
  transitionTimingFunction: t.prop("transitionTimingFunction", "transition.easing")
};
var typography = {
  fontFamily: t.prop("fontFamily", "fonts"),
  fontSize: t.prop("fontSize", "fontSizes", transformFunctions.px),
  fontWeight: t.prop("fontWeight", "fontWeights"),
  lineHeight: t.prop("lineHeight", "lineHeights"),
  letterSpacing: t.prop("letterSpacing", "letterSpacings"),
  textAlign: true,
  fontStyle: true,
  wordBreak: true,
  overflowWrap: true,
  textOverflow: true,
  textTransform: true,
  whiteSpace: true,
  noOfLines: {
    "static": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      //@ts-ignore
      WebkitLineClamp: "var(--chakra-line-clamp)"
    },
    property: "--chakra-line-clamp"
  },
  isTruncated: {
    transform: function transform9(value) {
      if (value === true) {
        return {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        };
      }
    }
  }
};
var scroll = {
  scrollBehavior: true,
  scrollSnapAlign: true,
  scrollSnapStop: true,
  scrollSnapType: true,
  // scroll margin
  scrollMargin: t.spaceT("scrollMargin"),
  scrollMarginTop: t.spaceT("scrollMarginTop"),
  scrollMarginBottom: t.spaceT("scrollMarginBottom"),
  scrollMarginLeft: t.spaceT("scrollMarginLeft"),
  scrollMarginRight: t.spaceT("scrollMarginRight"),
  scrollMarginX: t.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
  scrollMarginY: t.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
  // scroll padding
  scrollPadding: t.spaceT("scrollPadding"),
  scrollPaddingTop: t.spaceT("scrollPaddingTop"),
  scrollPaddingBottom: t.spaceT("scrollPaddingBottom"),
  scrollPaddingLeft: t.spaceT("scrollPaddingLeft"),
  scrollPaddingRight: t.spaceT("scrollPaddingRight"),
  scrollPaddingX: t.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
  scrollPaddingY: t.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
};

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var state = {
  hover: function hover(str, post) {
    return str + ":hover " + post + ", " + str + "[data-hover] " + post;
  },
  focus: function focus(str, post) {
    return str + ":focus " + post + ", " + str + "[data-focus] " + post;
  },
  focusVisible: function focusVisible(str, post) {
    return str + ":focus-visible " + post;
  },
  focusWithin: function focusWithin(str, post) {
    return str + ":focus-within " + post;
  },
  active: function active(str, post) {
    return str + ":active " + post + ", " + str + "[data-active] " + post;
  },
  disabled: function disabled(str, post) {
    return str + ":disabled " + post + ", " + str + "[data-disabled] " + post;
  },
  invalid: function invalid(str, post) {
    return str + ":invalid " + post + ", " + str + "[data-invalid] " + post;
  },
  checked: function checked(str, post) {
    return str + ":checked " + post + ", " + str + "[data-checked] " + post;
  },
  indeterminate: function indeterminate(str, post) {
    return str + ":indeterminate " + post + ", " + str + "[aria-checked=mixed] " + post + ", " + str + "[data-indeterminate] " + post;
  },
  readOnly: function readOnly(str, post) {
    return str + ":read-only " + post + ", " + str + "[readonly] " + post + ", " + str + "[data-read-only] " + post;
  },
  expanded: function expanded(str, post) {
    return str + ":read-only " + post + ", " + str + "[aria-expanded=true] " + post + ", " + str + "[data-expanded] " + post;
  },
  placeholderShown: function placeholderShown(str, post) {
    return str + ":placeholder-shown " + post;
  }
};

var toGroup = function toGroup2(fn6) {
  return merge(function (v) {
    return fn6(v, "&");
  }, "[role=group]", "[data-group]", ".group");
};

var toPeer = function toPeer2(fn6) {
  return merge(function (v) {
    return fn6(v, "~ &");
  }, "[data-peer]", ".peer");
};

var merge = function merge2(fn6) {
  for (var _len = arguments.length, selectors = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    selectors[_key - 1] = arguments[_key];
  }

  return selectors.map(fn6).join(", ");
};

var pseudoSelectors = {
  /**
   * Styles for CSS selector `&:hover`
   */
  _hover: "&:hover, &[data-hover]",

  /**
   * Styles for CSS Selector `&:active`
   */
  _active: "&:active, &[data-active]",

  /**
   * Styles for CSS selector `&:focus`
   *
   */
  _focus: "&:focus, &[data-focus]",

  /**
   * Styles for the highlighted state.
   */
  _highlighted: "&[data-highlighted]",

  /**
   * Styles to apply when a child of this element has received focus
   * - CSS Selector `&:focus-within`
   */
  _focusWithin: "&:focus-within",

  /**
   * Styles to apply when this element has received focus via tabbing
   * - CSS Selector `&:focus-visible`
   */
  _focusVisible: "&:focus-visible",

  /**
   * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
   * - `&[aria-disabled=true]`
   * - `&:disabled`
   * - `&[data-disabled]`
   */
  _disabled: "&[disabled], &[aria-disabled=true], &[data-disabled]",

  /**
   * Styles for CSS Selector `&:readonly`
   */
  _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",

  /**
   * Styles for CSS selector `&::before`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _before={{content:`""` }}/>
   * ```
   */
  _before: "&::before",

  /**
   * Styles for CSS selector `&::after`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _after={{content:`""` }}/>
   * ```
   */
  _after: "&::after",

  /**
   * Styles for CSS selector `&:empty`
   */
  _empty: "&:empty",

  /**
   * Styles to apply when the ARIA attribute `aria-expanded` is `true`
   * - CSS selector `&[aria-expanded=true]`
   */
  _expanded: "&[aria-expanded=true], &[data-expanded]",

  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `true`
   * - CSS selector `&[aria-checked=true]`
   */
  _checked: "&[aria-checked=true], &[data-checked]",

  /**
   * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
   * - CSS selector `&[aria-grabbed=true]`
   */
  _grabbed: "&[aria-grabbed=true], &[data-grabbed]",

  /**
   * Styles for CSS Selector `&[aria-pressed=true]`
   * Typically used to style the current "pressed" state of toggle buttons
   */
  _pressed: "&[aria-pressed=true], &[data-pressed]",

  /**
   * Styles to apply when the ARIA attribute `aria-invalid` is `true`
   * - CSS selector `&[aria-invalid=true]`
   */
  _invalid: "&[aria-invalid=true], &[data-invalid]",

  /**
   * Styles for the valid state
   * - CSS selector `&[data-valid], &[data-state=valid]`
   */
  _valid: "&[data-valid], &[data-state=valid]",

  /**
   * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
   * Useful for styling loading states
   */
  _loading: "&[data-loading], &[aria-busy=true]",

  /**
   * Styles to apply when the ARIA attribute `aria-selected` is `true`
   *
   * - CSS selector `&[aria-selected=true]`
   */
  _selected: "&[aria-selected=true], &[data-selected]",

  /**
   * Styles for CSS Selector `[hidden=true]`
   */
  _hidden: "&[hidden], &[data-hidden]",

  /**
   * Styles for CSS Selector `&:-webkit-autofill`
   */
  _autofill: "&:-webkit-autofill",

  /**
   * Styles for CSS Selector `&:nth-child(even)`
   */
  _even: "&:nth-of-type(even)",

  /**
   * Styles for CSS Selector `&:nth-child(odd)`
   */
  _odd: "&:nth-of-type(odd)",

  /**
   * Styles for CSS Selector `&:first-of-type`
   */
  _first: "&:first-of-type",

  /**
   * Styles for CSS Selector `&:last-of-type`
   */
  _last: "&:last-of-type",

  /**
   * Styles for CSS Selector `&:not(:first-of-type)`
   */
  _notFirst: "&:not(:first-of-type)",

  /**
   * Styles for CSS Selector `&:not(:last-of-type)`
   */
  _notLast: "&:not(:last-of-type)",

  /**
   * Styles for CSS Selector `&:visited`
   */
  _visited: "&:visited",

  /**
   * Used to style the active link in a navigation
   * Styles for CSS Selector `&[aria-current=page]`
   */
  _activeLink: "&[aria-current=page]",

  /**
   * Used to style the current step within a process
   * Styles for CSS Selector `&[aria-current=step]`
   */
  _activeStep: "&[aria-current=step]",

  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
   * - CSS selector `&[aria-checked=mixed]`
   */
  _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",

  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
   */
  _groupHover: toGroup(state.hover),

  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
   */
  _peerHover: toPeer(state.hover),

  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
   */
  _groupFocus: toGroup(state.focus),

  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
   */
  _peerFocus: toPeer(state.focus),

  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
   */
  _groupFocusVisible: toGroup(state.focusVisible),

  /**
   * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
   */
  _peerFocusVisible: toPeer(state.focusVisible),

  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
   */
  _groupActive: toGroup(state.active),

  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is active
   */
  _peerActive: toPeer(state.active),

  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
   */
  _groupDisabled: toGroup(state.disabled),

  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
   */
  _peerDisabled: toPeer(state.disabled),

  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
   */
  _groupInvalid: toGroup(state.invalid),

  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
   */
  _peerInvalid: toPeer(state.invalid),

  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
   */
  _groupChecked: toGroup(state.checked),

  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
   */
  _peerChecked: toPeer(state.checked),

  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
   */
  _groupFocusWithin: toGroup(state.focusWithin),

  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
   */
  _peerFocusWithin: toPeer(state.focusWithin),

  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
   */
  _peerPlaceholderShown: toPeer(state.placeholderShown),

  /**
   * Styles for CSS Selector `&::placeholder`.
   */
  _placeholder: "&::placeholder",

  /**
   * Styles for CSS Selector `&:placeholder-shown`.
   */
  _placeholderShown: "&:placeholder-shown",

  /**
   * Styles for CSS Selector `&:fullscreen`.
   */
  _fullScreen: "&:fullscreen",

  /**
   * Styles for CSS Selector `&::selection`
   */
  _selection: "&::selection",

  /**
   * Styles for CSS Selector `[dir=rtl] &`
   * It is applied when a parent element or this element has `dir="rtl"`
   */
  _rtl: "[dir=rtl] &, &[dir=rtl]",

  /**
   * Styles for CSS Selector `[dir=ltr] &`
   * It is applied when a parent element or this element has `dir="ltr"`
   */
  _ltr: "[dir=ltr] &, &[dir=ltr]",

  /**
   * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
   * It is used when the user has requested the system use a light or dark color theme.
   */
  _mediaDark: "@media (prefers-color-scheme: dark)",

  /**
   * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
   * It is used when the user has requested the system to reduce the amount of animations.
   */
  _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",

  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",

  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]"
};
var pseudoPropNames = objectKeys(pseudoSelectors);
var systemProps = mergeWith({}, background, border, color, flexbox, layout, filter2, ring2, interactivity, grid, others, position, effect4, space, scroll, typography, textDecoration, transform8, list, transition);
Object.assign({}, space, layout, flexbox, grid, position);
var propNames = [].concat(objectKeys(systemProps), pseudoPropNames);

var styleProps = _extends$4({}, systemProps, pseudoSelectors);

var isStyleProp = function isStyleProp2(prop2) {
  return prop2 in styleProps;
};

var expandResponsive = function expandResponsive2(styles) {
  return function (theme2) {
    if (!theme2.__breakpoints) return styles;
    var _theme$__breakpoints = theme2.__breakpoints,
        isResponsive = _theme$__breakpoints.isResponsive,
        toArrayValue = _theme$__breakpoints.toArrayValue,
        medias = _theme$__breakpoints.media;
    var computedStyles = {};

    for (var key in styles) {
      var value = runIfFn(styles[key], theme2);
      if (value == null) continue;
      value = isObject(value) && isResponsive(value) ? toArrayValue(value) : value;

      if (!Array.isArray(value)) {
        computedStyles[key] = value;
        continue;
      }

      var queries = value.slice(0, medias.length).length;

      for (var index2 = 0; index2 < queries; index2 += 1) {
        var media = medias == null ? void 0 : medias[index2];

        if (!media) {
          computedStyles[key] = value[index2];
          continue;
        }

        computedStyles[media] = computedStyles[media] || {};

        if (value[index2] == null) {
          continue;
        }

        computedStyles[media][key] = value[index2];
      }
    }

    return computedStyles;
  };
};

var isCSSVariableTokenValue = function isCSSVariableTokenValue2(key, value) {
  return key.startsWith("--") && isString(value) && !isCssVar(value);
};

var resolveTokenValue = function resolveTokenValue2(theme2, value) {
  var _ref, _getVar2;

  if (value == null) return value;

  var getVar = function getVar2(val) {
    var _theme$__cssMap, _theme$__cssMap$val;

    return (_theme$__cssMap = theme2.__cssMap) == null ? void 0 : (_theme$__cssMap$val = _theme$__cssMap[val]) == null ? void 0 : _theme$__cssMap$val.varRef;
  };

  var getValue = function getValue2(val) {
    var _getVar;

    return (_getVar = getVar(val)) != null ? _getVar : val;
  };

  var valueSplit = value.split(",").map(function (v) {
    return v.trim();
  });
  var tokenValue = valueSplit[0],
      fallbackValue = valueSplit[1];
  value = (_ref = (_getVar2 = getVar(tokenValue)) != null ? _getVar2 : getValue(fallbackValue)) != null ? _ref : getValue(value);
  return value;
};

function getCss(options) {
  var _options$configs = options.configs,
      configs = _options$configs === void 0 ? {} : _options$configs,
      _options$pseudos = options.pseudos,
      pseudos = _options$pseudos === void 0 ? {} : _options$pseudos,
      theme2 = options.theme;

  var css4 = function css5(stylesOrFn, nested) {
    if (nested === void 0) {
      nested = false;
    }

    var _styles = runIfFn(stylesOrFn, theme2);

    var styles = expandResponsive(_styles)(theme2);
    var computedStyles = {};

    for (var key in styles) {
      var _config$transform, _config, _config2, _config3, _config4;

      var valueOrFn = styles[key];
      var value = runIfFn(valueOrFn, theme2);

      if (key in pseudos) {
        key = pseudos[key];
      }

      if (isCSSVariableTokenValue(key, value)) {
        value = resolveTokenValue(theme2, value);
      }

      var config2 = configs[key];

      if (config2 === true) {
        config2 = {
          property: key
        };
      }

      if (isObject(value)) {
        var _computedStyles$key;

        computedStyles[key] = (_computedStyles$key = computedStyles[key]) != null ? _computedStyles$key : {};
        computedStyles[key] = mergeWith({}, computedStyles[key], css5(value, true));
        continue;
      }

      var rawValue = (_config$transform = (_config = config2) == null ? void 0 : _config.transform == null ? void 0 : _config.transform(value, theme2, _styles)) != null ? _config$transform : value;
      rawValue = (_config2 = config2) != null && _config2.processResult ? css5(rawValue, true) : rawValue;
      var configProperty = runIfFn((_config3 = config2) == null ? void 0 : _config3.property, theme2);

      if (!nested && (_config4 = config2) != null && _config4["static"]) {
        var staticStyles = runIfFn(config2["static"], theme2);
        computedStyles = mergeWith({}, computedStyles, staticStyles);
      }

      if (configProperty && Array.isArray(configProperty)) {
        for (var _iterator = _createForOfIteratorHelperLoose(configProperty), _step; !(_step = _iterator()).done;) {
          var property = _step.value;
          computedStyles[property] = rawValue;
        }

        continue;
      }

      if (configProperty) {
        if (configProperty === "&" && isObject(rawValue)) {
          computedStyles = mergeWith({}, computedStyles, rawValue);
        } else {
          computedStyles[configProperty] = rawValue;
        }

        continue;
      }

      if (isObject(rawValue)) {
        computedStyles = mergeWith({}, computedStyles, rawValue);
        continue;
      }

      computedStyles[key] = rawValue;
    }

    return computedStyles;
  };

  return css4;
}

var css2 = function css3(styles) {
  return function (theme2) {
    var cssFn = getCss({
      theme: theme2,
      pseudos: pseudoSelectors,
      configs: systemProps
    });
    return cssFn(styles);
  };
};

function resolveReference(operand) {
  if (isObject(operand) && operand.reference) {
    return operand.reference;
  }

  return String(operand);
}

var toExpression = function toExpression2(operator) {
  for (var _len = arguments.length, operands = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    operands[_key - 1] = arguments[_key];
  }

  return operands.map(resolveReference).join(" " + operator + " ").replace(/calc/g, "");
};

var _add = function add2() {
  for (var _len2 = arguments.length, operands = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    operands[_key2] = arguments[_key2];
  }

  return "calc(" + toExpression.apply(void 0, ["+"].concat(operands)) + ")";
};

var _subtract = function subtract2() {
  for (var _len3 = arguments.length, operands = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    operands[_key3] = arguments[_key3];
  }

  return "calc(" + toExpression.apply(void 0, ["-"].concat(operands)) + ")";
};

var _multiply = function multiply2() {
  for (var _len4 = arguments.length, operands = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    operands[_key4] = arguments[_key4];
  }

  return "calc(" + toExpression.apply(void 0, ["*"].concat(operands)) + ")";
};

var _divide = function divide2() {
  for (var _len5 = arguments.length, operands = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    operands[_key5] = arguments[_key5];
  }

  return "calc(" + toExpression.apply(void 0, ["/"].concat(operands)) + ")";
};

var _negate = function negate2(x) {
  var value = resolveReference(x);

  if (value != null && !Number.isNaN(parseFloat(value))) {
    return String(value).startsWith("-") ? String(value).slice(1) : "-" + value;
  }

  return _multiply(value, -1);
};

var calc = Object.assign(function (x) {
  return {
    add: function add3() {
      for (var _len6 = arguments.length, operands = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        operands[_key6] = arguments[_key6];
      }

      return calc(_add.apply(void 0, [x].concat(operands)));
    },
    subtract: function subtract3() {
      for (var _len7 = arguments.length, operands = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        operands[_key7] = arguments[_key7];
      }

      return calc(_subtract.apply(void 0, [x].concat(operands)));
    },
    multiply: function multiply3() {
      for (var _len8 = arguments.length, operands = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        operands[_key8] = arguments[_key8];
      }

      return calc(_multiply.apply(void 0, [x].concat(operands)));
    },
    divide: function divide3() {
      for (var _len9 = arguments.length, operands = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        operands[_key9] = arguments[_key9];
      }

      return calc(_divide.apply(void 0, [x].concat(operands)));
    },
    negate: function negate3() {
      return calc(_negate(x));
    },
    toString: function toString() {
      return x.toString();
    }
  };
}, {
  add: _add,
  subtract: _subtract,
  multiply: _multiply,
  divide: _divide,
  negate: _negate
});
var hasElementType = typeof Element !== "undefined";
var hasMap = typeof Map === "function";
var hasSet = typeof Set === "function";
var hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;

function equal(a, b) {
  if (a === b) return true;

  if (a && b && _typeof(a) == "object" && _typeof(b) == "object") {
    if (a.constructor !== b.constructor) return false;
    var length, i, keys;

    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (!equal(a[i], b[i])) return false;
      }

      return true;
    }

    var it;

    if (hasMap && a instanceof Map && b instanceof Map) {
      if (a.size !== b.size) return false;
      it = a.entries();

      while (!(i = it.next()).done) {
        if (!b.has(i.value[0])) return false;
      }

      it = a.entries();

      while (!(i = it.next()).done) {
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      }

      return true;
    }

    if (hasSet && a instanceof Set && b instanceof Set) {
      if (a.size !== b.size) return false;
      it = a.entries();

      while (!(i = it.next()).done) {
        if (!b.has(i.value[0])) return false;
      }

      return true;
    }

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (a[i] !== b[i]) return false;
      }

      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;) {
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    }

    if (hasElementType && a instanceof Element) return false;

    for (i = length; i-- !== 0;) {
      if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) {
        continue;
      }

      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }

    return true;
  }

  return a !== a && b !== b;
}

var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message || "").match(/stack|recursion/i)) {
      console.warn("react-fast-compare cannot handle circular refs");
      return false;
    }

    throw error;
  }
};

var isEqual2 =
/* @__PURE__ */
getDefaultExportFromCjs(reactFastCompare);

function _extends$3() {
  _extends$3 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$3.apply(this, arguments);
}

function useTheme() {
  var theme2 = React.useContext(ThemeContext);

  if (!theme2) {
    throw Error("useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`");
  }

  return theme2;
}

createContext({
  name: "StylesContext",
  errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
});

function omitThemingProps(props) {
  return omit(props, ["styleConfig", "size", "variant", "colorScheme"]);
}

function useChakra() {
  var colorModeResult = useColorMode();
  var theme2 = useTheme();
  return _extends$3({}, colorModeResult, {
    theme: theme2
  });
}

function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var allPropNames = new Set([].concat(propNames, ["textStyle", "layerStyle", "apply", "isTruncated", "noOfLines", "focusBorderColor", "errorBorderColor", "as", "__css", "css", "sx"]));
var validHTMLProps =
/* @__PURE__ */
new Set(["htmlWidth", "htmlHeight", "htmlSize"]);

var shouldForwardProp = function shouldForwardProp2(prop2) {
  return validHTMLProps.has(prop2) || !allPropNames.has(prop2);
};

var _excluded$1$2 = ["theme", "css", "__css", "sx"],
    _excluded2 = ["baseStyle"];

var toCSSObject = function toCSSObject2(_ref) {
  var baseStyle = _ref.baseStyle;
  return function (props) {
    props.theme;

    var cssProp = props.css,
        __css = props.__css,
        sx = props.sx,
        rest = _objectWithoutPropertiesLoose$3(props, _excluded$1$2);

    var styleProps2 = objectFilter(rest, function (_, prop2) {
      return isStyleProp(prop2);
    });
    var finalBaseStyle = runIfFn(baseStyle, props);
    var finalStyles = Object.assign({}, __css, finalBaseStyle, filterUndefined(styleProps2), sx);
    var computedCSS = css2(finalStyles)(props.theme);
    return cssProp ? [computedCSS, cssProp] : computedCSS;
  };
};

function styled(component, options) {
  var _ref2 = options != null ? options : {},
      baseStyle = _ref2.baseStyle,
      styledOptions = _objectWithoutPropertiesLoose$3(_ref2, _excluded2);

  if (!styledOptions.shouldForwardProp) {
    styledOptions.shouldForwardProp = shouldForwardProp;
  }

  var styleObject = toCSSObject({
    baseStyle: baseStyle
  });
  return _styled(component, styledOptions)(styleObject);
}

function forwardRef(component) {
  return (
    /* @__PURE__ */
    React.forwardRef(component)
  );
}

var _excluded$i = ["styleConfig"];

function useStyleConfig(themeKey, props, opts) {
  var _styleConfig$defaultP;

  if (props === void 0) {
    props = {};
  }

  if (opts === void 0) {
    opts = {};
  }

  var _props = props,
      styleConfigProp = _props.styleConfig,
      rest = _objectWithoutPropertiesLoose$3(_props, _excluded$i);

  var _useChakra = useChakra(),
      theme2 = _useChakra.theme,
      colorMode = _useChakra.colorMode;

  var themeStyleConfig = memoizedGet(theme2, "components." + themeKey);
  var styleConfig = styleConfigProp || themeStyleConfig;
  var mergedProps = mergeWith({
    theme: theme2,
    colorMode: colorMode
  }, (_styleConfig$defaultP = styleConfig == null ? void 0 : styleConfig.defaultProps) != null ? _styleConfig$defaultP : {}, filterUndefined(omit(rest, ["children"])));
  var stylesRef = useRef({});

  if (styleConfig) {
    var _styleConfig$baseStyl, _styleConfig$variants, _styleConfig$variants2, _styleConfig$sizes$me, _styleConfig$sizes, _opts;

    var baseStyles = runIfFn((_styleConfig$baseStyl = styleConfig.baseStyle) != null ? _styleConfig$baseStyl : {}, mergedProps);
    var variants = runIfFn((_styleConfig$variants = (_styleConfig$variants2 = styleConfig.variants) == null ? void 0 : _styleConfig$variants2[mergedProps.variant]) != null ? _styleConfig$variants : {}, mergedProps);
    var sizes = runIfFn((_styleConfig$sizes$me = (_styleConfig$sizes = styleConfig.sizes) == null ? void 0 : _styleConfig$sizes[mergedProps.size]) != null ? _styleConfig$sizes$me : {}, mergedProps);
    var styles = mergeWith({}, baseStyles, sizes, variants);

    if ((_opts = opts) != null && _opts.isMultiPart && styleConfig.parts) {
      styleConfig.parts.forEach(function (part) {
        var _styles$part;

        styles[part] = (_styles$part = styles[part]) != null ? _styles$part : {};
      });
    }

    var isStyleEqual = isEqual2(stylesRef.current, styles);

    if (!isStyleEqual) {
      stylesRef.current = styles;
    }
  }

  return stylesRef.current;
}

function useMultiStyleConfig(themeKey, props) {
  return useStyleConfig(themeKey, props, {
    isMultiPart: true
  });
}

function factory() {
  var cache =
  /* @__PURE__ */
  new Map();
  return new Proxy(styled, {
    /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */
    apply: function apply(target, thisArg, argArray) {
      return styled.apply(void 0, argArray);
    },

    /**
     * @example
     * <chakra.div />
     */
    get: function get2(_, element) {
      if (!cache.has(element)) {
        cache.set(element, styled(element));
      }

      return cache.get(element);
    }
  });
}

var chakra2 = factory();
var visuallyHiddenStyle = {
  border: "0px",
  clip: "rect(0px, 0px, 0px, 0px)",
  height: "1px",
  width: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
};
var VisuallyHidden = chakra2("span", {
  baseStyle: visuallyHiddenStyle
});

if (__DEV__) {
  VisuallyHidden.displayName = "VisuallyHidden";
}

var VisuallyHiddenInput = chakra2("input", {
  baseStyle: visuallyHiddenStyle
});

if (__DEV__) {
  VisuallyHiddenInput.displayName = "VisuallyHiddenInput";
}

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var scale = {
  exit: {
    scale: 0.85,
    opacity: 0,
    transition: {
      opacity: {
        duration: 0.15,
        easings: "easeInOut"
      },
      scale: {
        duration: 0.2,
        easings: "easeInOut"
      }
    }
  },
  enter: {
    scale: 1,
    opacity: 1,
    transition: {
      opacity: {
        easings: "easeOut",
        duration: 0.2
      },
      scale: {
        duration: 0.2,
        ease: [0.175, 0.885, 0.4, 1.1]
      }
    }
  }
};
var _excluded$1$1 = ["openDelay", "closeDelay", "closeOnClick", "closeOnMouseDown", "closeOnEsc", "onOpen", "onClose", "placement", "id", "isOpen", "defaultIsOpen", "arrowSize", "arrowShadowColor", "arrowPadding", "modifiers", "isDisabled", "gutter", "offset", "direction"];

function useTooltip(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      _props$openDelay = _props.openDelay,
      openDelay = _props$openDelay === void 0 ? 0 : _props$openDelay,
      _props$closeDelay = _props.closeDelay,
      closeDelay = _props$closeDelay === void 0 ? 0 : _props$closeDelay,
      _props$closeOnClick = _props.closeOnClick,
      closeOnClick = _props$closeOnClick === void 0 ? true : _props$closeOnClick,
      closeOnMouseDown = _props.closeOnMouseDown,
      _props$closeOnEsc = _props.closeOnEsc,
      closeOnEsc = _props$closeOnEsc === void 0 ? true : _props$closeOnEsc,
      onOpenProp = _props.onOpen,
      onCloseProp = _props.onClose,
      placement = _props.placement,
      id = _props.id,
      isOpenProp = _props.isOpen,
      defaultIsOpen = _props.defaultIsOpen,
      _props$arrowSize = _props.arrowSize,
      arrowSize = _props$arrowSize === void 0 ? 10 : _props$arrowSize,
      arrowShadowColor = _props.arrowShadowColor,
      arrowPadding = _props.arrowPadding,
      modifiers = _props.modifiers,
      isDisabled = _props.isDisabled,
      gutter = _props.gutter,
      offset2 = _props.offset,
      direction = _props.direction,
      htmlProps = _objectWithoutPropertiesLoose$2(_props, _excluded$1$1);

  var _useDisclosure = useDisclosure({
    isOpen: isOpenProp,
    defaultIsOpen: defaultIsOpen,
    onOpen: onOpenProp,
    onClose: onCloseProp
  }),
      isOpen = _useDisclosure.isOpen,
      onOpen = _useDisclosure.onOpen,
      onClose = _useDisclosure.onClose;

  var _usePopper = usePopper({
    enabled: isOpen,
    placement: placement,
    arrowPadding: arrowPadding,
    modifiers: modifiers,
    gutter: gutter,
    offset: offset2,
    direction: direction
  }),
      referenceRef = _usePopper.referenceRef,
      getPopperProps = _usePopper.getPopperProps,
      getArrowInnerProps = _usePopper.getArrowInnerProps,
      getArrowProps = _usePopper.getArrowProps;

  var tooltipId = useId(id, "tooltip");
  var ref = React.useRef(null);
  var enterTimeout = React.useRef();
  var exitTimeout = React.useRef();
  var openWithDelay = React.useCallback(function () {
    if (!isDisabled) {
      enterTimeout.current = window.setTimeout(onOpen, openDelay);
    }
  }, [isDisabled, onOpen, openDelay]);
  var closeWithDelay = React.useCallback(function () {
    if (enterTimeout.current) {
      clearTimeout(enterTimeout.current);
    }

    exitTimeout.current = window.setTimeout(onClose, closeDelay);
  }, [closeDelay, onClose]);
  var onClick = React.useCallback(function () {
    if (closeOnClick) {
      closeWithDelay();
    }
  }, [closeOnClick, closeWithDelay]);
  var onMouseDown = React.useCallback(function () {
    if (closeOnMouseDown) {
      closeWithDelay();
    }
  }, [closeOnMouseDown, closeWithDelay]);
  var onKeyDown = React.useCallback(function (event) {
    if (isOpen && event.key === "Escape") {
      closeWithDelay();
    }
  }, [isOpen, closeWithDelay]);
  useEventListener("keydown", closeOnEsc ? onKeyDown : void 0);
  React.useEffect(function () {
    return function () {
      clearTimeout(enterTimeout.current);
      clearTimeout(exitTimeout.current);
    };
  }, []);
  useEventListener("mouseleave", closeWithDelay, function () {
    return ref.current;
  });
  var getTriggerProps = React.useCallback(function (props2, _ref) {
    if (props2 === void 0) {
      props2 = {};
    }

    if (_ref === void 0) {
      _ref = null;
    }

    var triggerProps = _extends$2({}, props2, {
      ref: mergeRefs(ref, _ref, referenceRef),
      onMouseEnter: callAllHandlers(props2.onMouseEnter, openWithDelay),
      onClick: callAllHandlers(props2.onClick, onClick),
      onMouseDown: callAllHandlers(props2.onMouseDown, onMouseDown),
      onFocus: callAllHandlers(props2.onFocus, openWithDelay),
      onBlur: callAllHandlers(props2.onBlur, closeWithDelay),
      "aria-describedby": isOpen ? tooltipId : void 0
    });

    return triggerProps;
  }, [openWithDelay, closeWithDelay, onMouseDown, isOpen, tooltipId, onClick, referenceRef]);
  var getTooltipPositionerProps = React.useCallback(function (props2, forwardedRef) {
    var _extends2;

    if (props2 === void 0) {
      props2 = {};
    }

    if (forwardedRef === void 0) {
      forwardedRef = null;
    }

    return getPopperProps(_extends$2({}, props2, {
      style: _extends$2({}, props2.style, (_extends2 = {}, _extends2[cssVars.arrowSize["var"]] = arrowSize ? px(arrowSize) : void 0, _extends2[cssVars.arrowShadowColor["var"]] = arrowShadowColor, _extends2))
    }), forwardedRef);
  }, [getPopperProps, arrowSize, arrowShadowColor]);
  var getTooltipProps = React.useCallback(function (props2, _ref) {
    if (props2 === void 0) {
      props2 = {};
    }

    if (_ref === void 0) {
      _ref = null;
    }

    var tooltipProps = _extends$2({
      ref: _ref
    }, htmlProps, props2, {
      id: tooltipId,
      role: "tooltip",
      style: _extends$2({}, props2.style, {
        position: "relative",
        transformOrigin: cssVars.transformOrigin.varRef
      })
    });

    return tooltipProps;
  }, [htmlProps, tooltipId]);
  return {
    isOpen: isOpen,
    show: openWithDelay,
    hide: closeWithDelay,
    getTriggerProps: getTriggerProps,
    getTooltipProps: getTooltipProps,
    getTooltipPositionerProps: getTooltipPositionerProps,
    getArrowProps: getArrowProps,
    getArrowInnerProps: getArrowInnerProps
  };
}

var _excluded$e = ["children", "label", "shouldWrapChildren", "aria-label", "hasArrow", "bg", "portalProps", "background", "backgroundColor", "bgColor"];
var StyledTooltip = chakra2(motion.div);
var Tooltip2 =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var _ref, _ref2;

  var styles = useStyleConfig("Tooltip", props);
  var ownProps = omitThemingProps(props);
  var theme2 = useTheme();

  var children = ownProps.children,
      label = ownProps.label,
      shouldWrapChildren = ownProps.shouldWrapChildren,
      ariaLabel = ownProps["aria-label"],
      hasArrow = ownProps.hasArrow,
      bg = ownProps.bg,
      portalProps = ownProps.portalProps,
      background2 = ownProps.background,
      backgroundColor = ownProps.backgroundColor,
      bgColor = ownProps.bgColor,
      rest = _objectWithoutPropertiesLoose$2(ownProps, _excluded$e);

  var userDefinedBg = (_ref = (_ref2 = background2 != null ? background2 : backgroundColor) != null ? _ref2 : bg) != null ? _ref : bgColor;

  if (userDefinedBg) {
    styles.bg = userDefinedBg;
    styles[cssVars.arrowBg["var"]] = getCSSVar(theme2, "colors", userDefinedBg);
  }

  var tooltip = useTooltip(_extends$2({}, rest, {
    direction: theme2.direction
  }));
  var shouldWrap = isString(children) || shouldWrapChildren;
  var trigger;

  if (shouldWrap) {
    trigger =
    /* @__PURE__ */
    React.createElement(chakra2.span, _extends$2({
      tabIndex: 0
    }, tooltip.getTriggerProps()), children);
  } else {
    var child = React.Children.only(children);
    trigger =
    /* @__PURE__ */
    React.cloneElement(child, tooltip.getTriggerProps(child.props, child.ref));
  }

  var hasAriaLabel = !!ariaLabel;

  var _tooltipProps = tooltip.getTooltipProps({}, ref);

  var tooltipProps = hasAriaLabel ? omit(_tooltipProps, ["role", "id"]) : _tooltipProps;
  var hiddenProps = pick(_tooltipProps, ["role", "id"]);

  if (!label) {
    return (
      /* @__PURE__ */
      React.createElement(React.Fragment, null, children)
    );
  }

  return (
    /* @__PURE__ */
    React.createElement(React.Fragment, null, trigger,
    /* @__PURE__ */
    React.createElement(AnimatePresence, null, tooltip.isOpen &&
    /* @__PURE__ */
    React.createElement(Portal, portalProps,
    /* @__PURE__ */
    React.createElement(chakra2.div, _extends$2({}, tooltip.getTooltipPositionerProps(), {
      __css: {
        zIndex: styles.zIndex,
        pointerEvents: "none"
      }
    }),
    /* @__PURE__ */
    React.createElement(StyledTooltip, _extends$2({
      variants: scale
    }, tooltipProps, {
      initial: "exit",
      animate: "enter",
      exit: "exit",
      __css: styles
    }), label, hasAriaLabel &&
    /* @__PURE__ */
    React.createElement(VisuallyHidden, hiddenProps, ariaLabel), hasArrow &&
    /* @__PURE__ */
    React.createElement(chakra2.div, {
      "data-popper-arrow": true,
      className: "chakra-tooltip__arrow-wrapper"
    },
    /* @__PURE__ */
    React.createElement(chakra2.div, {
      "data-popper-arrow-inner": true,
      className: "chakra-tooltip__arrow",
      __css: {
        bg: styles.bg
      }
    })))))))
  );
});

if (__DEV__) {
  Tooltip2.displayName = "Tooltip";
}

function ConditionalTooltip(_ref43) {
  var label = _ref43.label,
      children = _ref43.children,
      rest = _objectWithoutProperties(_ref43, ["label", "children"]);

  return label ? React__default.createElement(Tooltip2, _objectSpread({}, rest, {
    label: label
  }), children) : React__default.createElement(React__default.Fragment, null, children);
}

var Textarea = forwardRef$1(function BaseTextarea(_ref44, ref) {
  var _ref44$isInvalid = _ref44.isInvalid,
      isInvalid = _ref44$isInvalid === void 0 ? false : _ref44$isInvalid,
      _ref44$isDisabled = _ref44.isDisabled,
      isDisabled = _ref44$isDisabled === void 0 ? false : _ref44$isDisabled,
      _ref44$isRequired = _ref44.isRequired,
      isRequired = _ref44$isRequired === void 0 ? false : _ref44$isRequired,
      label = _ref44.label,
      formControlProps = _ref44.formControlProps,
      labelProps = _ref44.labelProps,
      formErrorMessage = _ref44.formErrorMessage,
      formErrorMessageProps = _ref44.formErrorMessageProps,
      rest = _objectWithoutProperties(_ref44, ["isInvalid", "isDisabled", "isRequired", "label", "formControlProps", "labelProps", "formErrorMessage", "formErrorMessageProps"]);

  return React__default.createElement(FormControl, _objectSpread({
    isInvalid: isInvalid,
    isDisabled: isDisabled,
    isRequired: isRequired
  }, formControlProps), label && React__default.createElement(InputLabel, _objectSpread({}, labelProps), label), React__default.createElement(Textarea$1, _objectSpread({
    ref: ref
  }, rest)), formErrorMessage && React__default.createElement(FormErrorMessage$1, _objectSpread({}, formErrorMessageProps), formErrorMessage));
});
var Flex$1 = forwardRef$1(function BaseFlex(_ref45, ref) {
  var children = _ref45.children,
      rest = _objectWithoutProperties(_ref45, ["children"]);

  return React__default.createElement(Flex$2, _objectSpread({
    ref: ref
  }, rest), children);
});
var IconButton = forwardRef$1(function BaseIconButton(props, ref) {
  return React__default.createElement(IconButton$1, _objectSpread({
    ref: ref
  }, props));
});
var SimpleIconButton = forwardRef$1(function BaseIconButton2(_ref46, ref) {
  var icon = _ref46.icon,
      rest = _objectWithoutProperties(_ref46, ["icon"]);

  return React__default.createElement(IconButton$1, _objectSpread({
    icon: React__default.createElement(Icon$1, {
      icon: icon
    }),
    ref: ref
  }, rest));
});
var NumberInput = forwardRef$1(function BaseNumberInput(_ref47, ref) {
  var _ref47$size = _ref47.size,
      size = _ref47$size === void 0 ? "md" : _ref47$size,
      label = _ref47.label,
      _ref47$noStepper = _ref47.noStepper,
      noStepper = _ref47$noStepper === void 0 ? false : _ref47$noStepper,
      inputProps = _ref47.inputProps,
      stepperProps = _ref47.stepperProps,
      incrementStepperProps = _ref47.incrementStepperProps,
      decrementStepperProps = _ref47.decrementStepperProps,
      rest = _objectWithoutProperties(_ref47, ["size", "label", "noStepper", "inputProps", "stepperProps", "incrementStepperProps", "decrementStepperProps"]);

  return React__default.createElement(React__default.Fragment, null, label && React__default.createElement(InputLabel, null, label), React__default.createElement(NumberInput$1, _objectSpread({
    size: size,
    ref: ref
  }, rest), React__default.createElement(NumberInputField, _objectSpread({}, inputProps)), !noStepper && React__default.createElement(NumberInputStepper, _objectSpread({}, stepperProps), React__default.createElement(NumberIncrementStepper, _objectSpread({}, incrementStepperProps)), React__default.createElement(NumberDecrementStepper, _objectSpread({}, decrementStepperProps)))));
});
var Spinner = forwardRef$1(function BaseSpinner(_ref48, ref) {
  var children = _ref48.children,
      rest = _objectWithoutProperties(_ref48, ["children"]);

  return React__default.createElement(Spinner$1, _objectSpread({
    ref: ref
  }, rest), children);
});

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded = ["as", "viewBox", "color", "focusable", "children", "className", "__css"];
var fallbackIcon = {
  path:
  /* @__PURE__ */
  React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: "1.5"
  },
  /* @__PURE__ */
  React.createElement("path", {
    strokeLinecap: "round",
    fill: "none",
    d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
  }),
  /* @__PURE__ */
  React.createElement("path", {
    fill: "currentColor",
    strokeLinecap: "round",
    d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
  }),
  /* @__PURE__ */
  React.createElement("circle", {
    fill: "none",
    strokeMiterlimit: "10",
    cx: "12",
    cy: "12",
    r: "11.25"
  })),
  viewBox: "0 0 24 24"
};
var Icon =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var element = props.as,
      viewBox = props.viewBox,
      _props$color = props.color,
      color2 = _props$color === void 0 ? "currentColor" : _props$color,
      _props$focusable = props.focusable,
      focusable = _props$focusable === void 0 ? false : _props$focusable,
      children = props.children,
      className = props.className,
      __css = props.__css,
      rest = _objectWithoutPropertiesLoose$1(props, _excluded);

  var _className = cx("chakra-icon", className);

  var styles = _extends$1({
    w: "1em",
    h: "1em",
    display: "inline-block",
    lineHeight: "1em",
    flexShrink: 0,
    color: color2
  }, __css);

  var shared = {
    ref: ref,
    focusable: focusable,
    className: _className,
    __css: styles
  };

  var _viewBox = viewBox != null ? viewBox : fallbackIcon.viewBox;

  if (element && typeof element !== "string") {
    return (
      /* @__PURE__ */
      React.createElement(chakra2.svg, _extends$1({
        as: element
      }, shared, rest))
    );
  }

  var _path = children != null ? children : fallbackIcon.path;

  return (
    /* @__PURE__ */
    React.createElement(chakra2.svg, _extends$1({
      verticalAlign: "middle",
      viewBox: _viewBox
    }, shared, rest), _path)
  );
});

if (__DEV__) {
  Icon.displayName = "Icon";
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded$h = ["ratio", "children", "className"];
var AspectRatio =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var _props$ratio = props.ratio,
      ratio = _props$ratio === void 0 ? 4 / 3 : _props$ratio,
      children = props.children,
      className = props.className,
      rest = _objectWithoutPropertiesLoose(props, _excluded$h);

  var child = React.Children.only(children);

  var _className = cx("chakra-aspect-ratio", className);

  return (
    /* @__PURE__ */
    React.createElement(chakra2.div, _extends({
      ref: ref,
      position: "relative",
      className: _className,
      _before: {
        height: 0,
        content: '""',
        display: "block",
        paddingBottom: mapResponsive(ratio, function (r) {
          return 1 / r * 100 + "%";
        })
      },
      __css: {
        "& > *:not(style)": {
          overflow: "hidden",
          position: "absolute",
          top: "0",
          right: "0",
          bottom: "0",
          left: "0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100%"
        },
        "& > img, & > video": {
          objectFit: "cover"
        }
      }
    }, rest), child)
  );
});

if (__DEV__) {
  AspectRatio.displayName = "AspectRatio";
}

var _excluded$g = ["className"];
var Badge =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var styles = useStyleConfig("Badge", props);

  var _omitThemingProps = omitThemingProps(props);

  _omitThemingProps.className;

  var rest = _objectWithoutPropertiesLoose(_omitThemingProps, _excluded$g);

  return (
    /* @__PURE__ */
    React.createElement(chakra2.span, _extends({
      ref: ref,
      className: cx("chakra-badge", props.className)
    }, rest, {
      __css: _extends({
        display: "inline-block",
        whiteSpace: "nowrap",
        verticalAlign: "middle"
      }, styles)
    }))
  );
});

if (__DEV__) {
  Badge.displayName = "Badge";
}

var _excluded$f = ["size", "centerContent"],
    _excluded2$5 = ["size"];
var Box = chakra2("div");

if (__DEV__) {
  Box.displayName = "Box";
}

var Square =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var size = props.size,
      _props$centerContent = props.centerContent,
      centerContent = _props$centerContent === void 0 ? true : _props$centerContent,
      rest = _objectWithoutPropertiesLoose(props, _excluded$f);

  var styles = centerContent ? {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  } : {};
  return (
    /* @__PURE__ */
    React.createElement(Box, _extends({
      ref: ref,
      boxSize: size,
      __css: _extends({}, styles, {
        flexShrink: 0,
        flexGrow: 0
      })
    }, rest))
  );
});

if (__DEV__) {
  Square.displayName = "Square";
}

var Circle2 =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var size = props.size,
      rest = _objectWithoutPropertiesLoose(props, _excluded2$5);

  return (
    /* @__PURE__ */
    React.createElement(Square, _extends({
      size: size,
      ref: ref,
      borderRadius: "9999px"
    }, rest))
  );
});

if (__DEV__) {
  Circle2.displayName = "Circle";
}

var Center = chakra2("div", {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
});

if (__DEV__) {
  Center.displayName = "Center";
}

var _excluded$d = ["className"];
var Code =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var styles = useStyleConfig("Code", props);

  var _omitThemingProps = omitThemingProps(props);

  _omitThemingProps.className;

  var rest = _objectWithoutPropertiesLoose(_omitThemingProps, _excluded$d);

  return (
    /* @__PURE__ */
    React.createElement(chakra2.code, _extends({
      ref: ref,
      className: cx("chakra-code", props.className)
    }, rest, {
      __css: _extends({
        display: "inline-block"
      }, styles)
    }))
  );
});

if (__DEV__) {
  Code.displayName = "Code";
}

var _excluded$c = ["className", "centerContent"];
var Container2 =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var _omitThemingProps = omitThemingProps(props),
      className = _omitThemingProps.className,
      centerContent = _omitThemingProps.centerContent,
      rest = _objectWithoutPropertiesLoose(_omitThemingProps, _excluded$c);

  var styles = useStyleConfig("Container", props);
  return (
    /* @__PURE__ */
    React.createElement(chakra2.div, _extends({
      ref: ref,
      className: cx("chakra-container", className)
    }, rest, {
      __css: _extends({}, styles, centerContent && {
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      })
    }))
  );
});

if (__DEV__) {
  Container2.displayName = "Container";
}

var _excluded$b = ["borderLeftWidth", "borderBottomWidth", "borderTopWidth", "borderRightWidth", "borderWidth", "borderStyle", "borderColor"],
    _excluded2$4 = ["className", "orientation", "__css"];
var Divider2 =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var _useStyleConfig = useStyleConfig("Divider", props),
      borderLeftWidth = _useStyleConfig.borderLeftWidth,
      borderBottomWidth = _useStyleConfig.borderBottomWidth,
      borderTopWidth = _useStyleConfig.borderTopWidth,
      borderRightWidth = _useStyleConfig.borderRightWidth,
      borderWidth = _useStyleConfig.borderWidth,
      borderStyle = _useStyleConfig.borderStyle,
      borderColor = _useStyleConfig.borderColor,
      styles = _objectWithoutPropertiesLoose(_useStyleConfig, _excluded$b);

  var _omitThemingProps = omitThemingProps(props),
      className = _omitThemingProps.className,
      _omitThemingProps$ori = _omitThemingProps.orientation,
      orientation = _omitThemingProps$ori === void 0 ? "horizontal" : _omitThemingProps$ori,
      __css = _omitThemingProps.__css,
      rest = _objectWithoutPropertiesLoose(_omitThemingProps, _excluded2$4);

  var dividerStyles = {
    vertical: {
      borderLeftWidth: borderLeftWidth || borderRightWidth || borderWidth || "1px",
      height: "100%"
    },
    horizontal: {
      borderBottomWidth: borderBottomWidth || borderTopWidth || borderWidth || "1px",
      width: "100%"
    }
  };
  return (
    /* @__PURE__ */
    React.createElement(chakra2.hr, _extends({
      ref: ref,
      "aria-orientation": orientation
    }, rest, {
      __css: _extends({}, styles, {
        border: "0",
        borderColor: borderColor,
        borderStyle: borderStyle
      }, dividerStyles[orientation], __css),
      className: cx("chakra-divider", className)
    }))
  );
});

if (__DEV__) {
  Divider2.displayName = "Divider";
}

var _excluded$a = ["direction", "align", "justify", "wrap", "basis", "grow", "shrink"];
var Flex =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var direction = props.direction,
      align = props.align,
      justify = props.justify,
      wrap3 = props.wrap,
      basis = props.basis,
      grow = props.grow,
      shrink = props.shrink,
      rest = _objectWithoutPropertiesLoose(props, _excluded$a);

  var styles = {
    display: "flex",
    flexDirection: direction,
    alignItems: align,
    justifyContent: justify,
    flexWrap: wrap3,
    flexBasis: basis,
    flexGrow: grow,
    flexShrink: shrink
  };
  return (
    /* @__PURE__ */
    React.createElement(chakra2.div, _extends({
      ref: ref,
      __css: styles
    }, rest))
  );
});

if (__DEV__) {
  Flex.displayName = "Flex";
}

var _excluded$9 = ["area", "templateAreas", "gap", "rowGap", "columnGap", "column", "row", "autoFlow", "autoRows", "templateRows", "autoColumns", "templateColumns"];
var Grid2 =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var area = props.area,
      templateAreas = props.templateAreas,
      gap = props.gap,
      rowGap = props.rowGap,
      columnGap = props.columnGap,
      column = props.column,
      row = props.row,
      autoFlow = props.autoFlow,
      autoRows = props.autoRows,
      templateRows = props.templateRows,
      autoColumns = props.autoColumns,
      templateColumns = props.templateColumns,
      rest = _objectWithoutPropertiesLoose(props, _excluded$9);

  var styles = {
    display: "grid",
    gridArea: area,
    gridTemplateAreas: templateAreas,
    gridGap: gap,
    gridRowGap: rowGap,
    gridColumnGap: columnGap,
    gridAutoColumns: autoColumns,
    gridColumn: column,
    gridRow: row,
    gridAutoFlow: autoFlow,
    gridAutoRows: autoRows,
    gridTemplateRows: templateRows,
    gridTemplateColumns: templateColumns
  };
  return (
    /* @__PURE__ */
    React.createElement(chakra2.div, _extends({
      ref: ref,
      __css: styles
    }, rest))
  );
});

if (__DEV__) {
  Grid2.displayName = "Grid";
}

var _excluded$8 = ["className"];
var Heading =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var styles = useStyleConfig("Heading", props);

  var _omitThemingProps = omitThemingProps(props);

  _omitThemingProps.className;

  var rest = _objectWithoutPropertiesLoose(_omitThemingProps, _excluded$8);

  return (
    /* @__PURE__ */
    React.createElement(chakra2.h2, _extends({
      ref: ref,
      className: cx("chakra-heading", props.className)
    }, rest, {
      __css: styles
    }))
  );
});

if (__DEV__) {
  Heading.displayName = "Heading";
}

var _excluded$7 = ["className"];
var Kbd =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var styles = useStyleConfig("Kbd", props);

  var _omitThemingProps = omitThemingProps(props),
      className = _omitThemingProps.className,
      rest = _objectWithoutPropertiesLoose(_omitThemingProps, _excluded$7);

  return (
    /* @__PURE__ */
    React.createElement(chakra2.kbd, _extends({
      ref: ref,
      className: cx("chakra-kbd", className)
    }, rest, {
      __css: _extends({
        fontFamily: "mono"
      }, styles)
    }))
  );
});

if (__DEV__) {
  Kbd.displayName = "Kbd";
}

var _excluded$6 = ["className", "isExternal"];
var Link2 =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var styles = useStyleConfig("Link", props);

  var _omitThemingProps = omitThemingProps(props),
      className = _omitThemingProps.className,
      isExternal = _omitThemingProps.isExternal,
      rest = _objectWithoutPropertiesLoose(_omitThemingProps, _excluded$6);

  return (
    /* @__PURE__ */
    React.createElement(chakra2.a, _extends({
      target: isExternal ? "_blank" : void 0,
      rel: isExternal ? "noopener" : void 0,
      ref: ref,
      className: cx("chakra-link", className)
    }, rest, {
      __css: styles
    }))
  );
});

if (__DEV__) {
  Link2.displayName = "Link";
}

var _excluded$5 = ["children", "styleType", "stylePosition", "spacing"],
    _excluded2$2 = ["as"],
    _excluded3 = ["as"];

var _createContext = createContext({
  name: "StylesContext",
  errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in a `<*List />` "
}),
    StylesProvider = _createContext[0],
    useStyles = _createContext[1];

var List2 =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var _ref;

  var styles = useMultiStyleConfig("List", props);

  var _omitThemingProps = omitThemingProps(props),
      children = _omitThemingProps.children,
      _omitThemingProps$sty = _omitThemingProps.styleType,
      styleType = _omitThemingProps$sty === void 0 ? "none" : _omitThemingProps$sty,
      stylePosition = _omitThemingProps.stylePosition,
      spacing = _omitThemingProps.spacing,
      rest = _objectWithoutPropertiesLoose(_omitThemingProps, _excluded$5);

  var validChildren = getValidChildren(children);
  var selector2 = "& > *:not(style) ~ *:not(style)";
  var spacingStyle = spacing ? (_ref = {}, _ref[selector2] = {
    mt: spacing
  }, _ref) : {};
  return (
    /* @__PURE__ */
    React.createElement(StylesProvider, {
      value: styles
    },
    /* @__PURE__ */
    React.createElement(chakra2.ul, _extends({
      ref: ref,
      listStyleType: styleType,
      listStylePosition: stylePosition,
      role: "list",
      __css: _extends({}, styles.container, spacingStyle)
    }, rest), validChildren))
  );
});

if (__DEV__) {
  List2.displayName = "List";
}

var OrderedList2 =
/* @__PURE__ */
forwardRef(function (props, ref) {
  props.as;

  var rest = _objectWithoutPropertiesLoose(props, _excluded2$2);

  return (
    /* @__PURE__ */
    React.createElement(List2, _extends({
      ref: ref,
      as: "ol",
      styleType: "decimal",
      marginStart: "1em"
    }, rest))
  );
});

if (__DEV__) {
  OrderedList2.displayName = "OrderedList";
}

var UnorderedList2 =
/* @__PURE__ */
forwardRef(function (props, ref) {
  props.as;

  var rest = _objectWithoutPropertiesLoose(props, _excluded3);

  return (
    /* @__PURE__ */
    React.createElement(List2, _extends({
      ref: ref,
      as: "ul",
      styleType: "initial",
      marginStart: "1em"
    }, rest))
  );
});

if (__DEV__) {
  UnorderedList2.displayName = "UnorderedList";
}

var ListItem2 =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var styles = useStyles();
  return (
    /* @__PURE__ */
    React.createElement(chakra2.li, _extends({
      ref: ref
    }, props, {
      __css: styles.item
    }))
  );
});

if (__DEV__) {
  ListItem2.displayName = "ListItem";
}

var ListIcon2 =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var styles = useStyles();
  return (
    /* @__PURE__ */
    React.createElement(Icon, _extends({
      ref: ref,
      role: "presentation"
    }, props, {
      __css: styles.icon
    }))
  );
});

if (__DEV__) {
  ListIcon2.displayName = "ListIcon";
}

var _excluded$4 = ["columns", "spacingX", "spacingY", "spacing", "minChildWidth"];
var SimpleGrid =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var columns = props.columns,
      spacingX = props.spacingX,
      spacingY = props.spacingY,
      spacing = props.spacing,
      minChildWidth = props.minChildWidth,
      rest = _objectWithoutPropertiesLoose(props, _excluded$4);

  var templateColumns = minChildWidth ? widthToColumns(minChildWidth) : countToColumns(columns);
  return (
    /* @__PURE__ */
    React.createElement(Grid2, _extends({
      ref: ref,
      gap: spacing,
      columnGap: spacingX,
      rowGap: spacingY,
      templateColumns: templateColumns
    }, rest))
  );
});

if (__DEV__) {
  SimpleGrid.displayName = "SimpleGrid";
}

function toPx(n) {
  return isNumber(n) ? n + "px" : n;
}

function widthToColumns(width) {
  return mapResponsive(width, function (value) {
    return isNull(value) ? null : "repeat(auto-fit, minmax(" + toPx(value) + ", 1fr))";
  });
}

function countToColumns(count) {
  return mapResponsive(count, function (value) {
    return isNull(value) ? null : "repeat(" + value + ", minmax(0, 1fr))";
  });
}

var Spacer2 = chakra2("div", {
  baseStyle: {
    flex: 1,
    justifySelf: "stretch",
    alignSelf: "stretch"
  }
});

if (__DEV__) {
  Spacer2.displayName = "Spacer";
}

var selector = "& > *:not(style) ~ *:not(style)";

function getStackStyles(options) {
  var _ref;

  var spacing = options.spacing,
      direction = options.direction;
  var directionStyles = {
    column: {
      marginTop: spacing,
      marginEnd: 0,
      marginBottom: 0,
      marginStart: 0
    },
    row: {
      marginTop: 0,
      marginEnd: 0,
      marginBottom: 0,
      marginStart: spacing
    },
    "column-reverse": {
      marginTop: 0,
      marginEnd: 0,
      marginBottom: spacing,
      marginStart: 0
    },
    "row-reverse": {
      marginTop: 0,
      marginEnd: spacing,
      marginBottom: 0,
      marginStart: 0
    }
  };
  return _ref = {
    flexDirection: direction
  }, _ref[selector] = mapResponsive(direction, function (value) {
    return directionStyles[value];
  }), _ref;
}

function getDividerStyles(options) {
  var spacing = options.spacing,
      direction = options.direction;
  var dividerStyles = {
    column: {
      my: spacing,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    "column-reverse": {
      my: spacing,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    row: {
      mx: spacing,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    },
    "row-reverse": {
      mx: spacing,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    }
  };
  return {
    "&": mapResponsive(direction, function (value) {
      return dividerStyles[value];
    })
  };
}

var _excluded$3 = ["isInline", "direction", "align", "justify", "spacing", "wrap", "children", "divider", "className", "shouldWrapChildren"];

var StackItem = function StackItem2(props) {
  return (
    /* @__PURE__ */
    React.createElement(chakra2.div, _extends({
      className: "chakra-stack__item"
    }, props, {
      __css: _extends({
        display: "inline-block",
        flex: "0 0 auto",
        minWidth: 0
      }, props["__css"])
    }))
  );
};

var Stack =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var _ref;

  var isInline = props.isInline,
      directionProp = props.direction,
      align = props.align,
      justify = props.justify,
      _props$spacing = props.spacing,
      spacing = _props$spacing === void 0 ? "0.5rem" : _props$spacing,
      wrap3 = props.wrap,
      children = props.children,
      divider = props.divider,
      className = props.className,
      shouldWrapChildren = props.shouldWrapChildren,
      rest = _objectWithoutPropertiesLoose(props, _excluded$3);

  var direction = isInline ? "row" : directionProp != null ? directionProp : "column";
  var styles = React.useMemo(function () {
    return getStackStyles({
      direction: direction,
      spacing: spacing
    });
  }, [direction, spacing]);
  var dividerStyle = React.useMemo(function () {
    return getDividerStyles({
      spacing: spacing,
      direction: direction
    });
  }, [spacing, direction]);
  var hasDivider = !!divider;
  var shouldUseChildren = !shouldWrapChildren && !hasDivider;
  var validChildren = getValidChildren(children);
  var clones = shouldUseChildren ? validChildren : validChildren.map(function (child, index2) {
    var key = typeof child.key !== "undefined" ? child.key : index2;
    var isLast = index2 + 1 === validChildren.length;
    var wrappedChild =
    /* @__PURE__ */
    React.createElement(StackItem, {
      key: key
    }, child);

    var _child = shouldWrapChildren ? wrappedChild : child;

    if (!hasDivider) return _child;
    var clonedDivider =
    /* @__PURE__ */
    React.cloneElement(divider, {
      __css: dividerStyle
    });

    var _divider = isLast ? null : clonedDivider;

    return (
      /* @__PURE__ */
      React.createElement(React.Fragment, {
        key: key
      }, _child, _divider)
    );
  });

  var _className = cx("chakra-stack", className);

  return (
    /* @__PURE__ */
    React.createElement(chakra2.div, _extends({
      ref: ref,
      display: "flex",
      alignItems: align,
      justifyContent: justify,
      flexDirection: styles.flexDirection,
      flexWrap: wrap3,
      className: _className,
      __css: hasDivider ? {} : (_ref = {}, _ref[selector] = styles[selector], _ref)
    }, rest), clones)
  );
});

if (__DEV__) {
  Stack.displayName = "Stack";
}

var HStack =
/* @__PURE__ */
forwardRef(function (props, ref) {
  return (
    /* @__PURE__ */
    React.createElement(Stack, _extends({
      align: "center"
    }, props, {
      direction: "row",
      ref: ref
    }))
  );
});

if (__DEV__) {
  HStack.displayName = "HStack";
}

var VStack =
/* @__PURE__ */
forwardRef(function (props, ref) {
  return (
    /* @__PURE__ */
    React.createElement(Stack, _extends({
      align: "center"
    }, props, {
      direction: "column",
      ref: ref
    }))
  );
});

if (__DEV__) {
  VStack.displayName = "VStack";
}

var _excluded$2 = ["className", "align", "decoration", "casing"];
var Text =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var styles = useStyleConfig("Text", props);

  var _omitThemingProps = omitThemingProps(props);

  _omitThemingProps.className;
  _omitThemingProps.align;
  _omitThemingProps.decoration;
  _omitThemingProps.casing;

  var rest = _objectWithoutPropertiesLoose(_omitThemingProps, _excluded$2);

  var aliasedProps = filterUndefined({
    textAlign: props.align,
    textDecoration: props.decoration,
    textTransform: props.casing
  });
  return (
    /* @__PURE__ */
    React.createElement(chakra2.p, _extends({
      ref: ref,
      className: cx("chakra-text", props.className)
    }, aliasedProps, rest, {
      __css: styles
    }))
  );
});

if (__DEV__) {
  Text.displayName = "Text";
}

var _excluded$1 = ["spacing", "spacingX", "spacingY", "children", "justify", "direction", "align", "className", "shouldWrapChildren"],
    _excluded2$1 = ["className"];
var Wrap =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var _props$spacing = props.spacing,
      spacing = _props$spacing === void 0 ? "0.5rem" : _props$spacing,
      spacingX = props.spacingX,
      spacingY = props.spacingY,
      children = props.children,
      justify = props.justify,
      direction = props.direction,
      align = props.align,
      className = props.className,
      shouldWrapChildren = props.shouldWrapChildren,
      rest = _objectWithoutPropertiesLoose(props, _excluded$1);

  var styles = React.useMemo(function () {
    var _spacingX$spacingY = {
      spacingX: spacingX,
      spacingY: spacingY
    },
        _spacingX$spacingY$sp = _spacingX$spacingY.spacingX,
        x = _spacingX$spacingY$sp === void 0 ? spacing : _spacingX$spacingY$sp,
        _spacingX$spacingY$sp2 = _spacingX$spacingY.spacingY,
        y = _spacingX$spacingY$sp2 === void 0 ? spacing : _spacingX$spacingY$sp2;
    return {
      "--chakra-wrap-x-spacing": function chakraWrapXSpacing(theme2) {
        return mapResponsive(x, function (value) {
          return tokenToCSSVar("space", value)(theme2);
        });
      },
      "--chakra-wrap-y-spacing": function chakraWrapYSpacing(theme2) {
        return mapResponsive(y, function (value) {
          return tokenToCSSVar("space", value)(theme2);
        });
      },
      "--wrap-x-spacing": "calc(var(--chakra-wrap-x-spacing) / 2)",
      "--wrap-y-spacing": "calc(var(--chakra-wrap-y-spacing) / 2)",
      display: "flex",
      flexWrap: "wrap",
      justifyContent: justify,
      alignItems: align,
      flexDirection: direction,
      listStyleType: "none",
      padding: "0",
      margin: "calc(var(--wrap-y-spacing) * -1) calc(var(--wrap-x-spacing) * -1)",
      "& > *:not(style)": {
        margin: "var(--wrap-y-spacing) var(--wrap-x-spacing)"
      }
    };
  }, [spacing, spacingX, spacingY, justify, align, direction]);
  var childrenToRender = shouldWrapChildren ? React.Children.map(children, function (child, index2) {
    return (
      /* @__PURE__ */
      React.createElement(WrapItem, {
        key: index2
      }, child)
    );
  }) : children;
  return (
    /* @__PURE__ */
    React.createElement(chakra2.div, _extends({
      ref: ref,
      className: cx("chakra-wrap", className)
    }, rest),
    /* @__PURE__ */
    React.createElement(chakra2.ul, {
      className: "chakra-wrap__list",
      __css: styles
    }, childrenToRender))
  );
});

if (__DEV__) {
  Wrap.displayName = "Wrap";
}

var WrapItem =
/* @__PURE__ */
forwardRef(function (props, ref) {
  var className = props.className,
      rest = _objectWithoutPropertiesLoose(props, _excluded2$1);

  return (
    /* @__PURE__ */
    React.createElement(chakra2.li, _extends({
      ref: ref,
      __css: {
        display: "flex",
        alignItems: "flex-start"
      },
      className: cx("chakra-wrap__listitem", className)
    }, rest))
  );
});

if (__DEV__) {
  WrapItem.displayName = "WrapItem";
}

var MotionBox = motion(Box);

var BreadcrumbNav = function BreadcrumbNav(_ref49) {
  var items = _ref49.items,
      rest = _objectWithoutProperties(_ref49, ["items"]);

  return React__default.createElement(Breadcrumb, _objectSpread({}, rest), items.map(function (item, i) {
    var content = item.content,
        itemProps = item.itemProps,
        linkProps = item.linkProps;
    return React__default.createElement(BreadcrumbItem, _objectSpread({
      "data-testid": "breadcrumb-item",
      key: "breadcrumb-item-".concat(i)
    }, itemProps), linkProps ? React__default.createElement(BreadcrumbLink, _objectSpread({}, linkProps), content) : React__default.createElement(React__default.Fragment, null, content));
  }));
};

var swiper_min = "";
var pagination_min = "";
var navigation_min = "";
var scrollbar_min = "";
var freeMode_min = "";
var a11y_min = "";
var SwiperModules = {
  Navigation: Navigation,
  FreeMode: FreeMode,
  Pagination: Pagination,
  Scrollbar: Scrollbar,
  A11y: A11y
};

var Swiper = function Swiper(props) {
  return React__default.createElement(Swiper$1, _objectSpread({}, props));
};

var SlideUpModal = function SlideUpModal(_ref50) {
  var isOpen = _ref50.isOpen,
      bodyProps = _ref50.bodyProps,
      closeButtonProps = _ref50.closeButtonProps,
      modalSizeProps = _ref50.modalSizeProps,
      children = _ref50.children,
      modalProps = _objectWithoutProperties(_ref50, ["isOpen", "bodyProps", "closeButtonProps", "modalSizeProps", "children"]);

  var AnimatedContent = motion(Box$1);
  var AnimatedOverlay = motion(ModalOverlay);
  var hasAnimated = useRef(false);
  useEffect(function () {
    if (isOpen) {
      setTimeout(function () {
        hasAnimated.current = true;
      }, 1e3);
    } else {
      hasAnimated.current = false;
    }
  }, [isOpen]);
  return React__default.createElement(Modal, _objectSpread({
    isOpen: isOpen,
    motionPreset: "none",
    scrollBehavior: "inside"
  }, modalProps), React__default.createElement(Box$1, _objectSpread({}, {
    sx: {
      ".chakra-modal__content-container": {
        alignItems: "flex-end"
      }
    }
  }), React__default.createElement(AnimatedOverlay, _objectSpread({
    bg: "gray.400"
  }, {
    initial: !!(hasAnimated == null ? void 0 : hasAnimated.current) ? false : {
      opacity: 0
    },
    animate: {
      opacity: 0.6
    },
    exit: {
      opacity: 0
    },
    transition: {
      opacity: {
        duration: 0.4,
        ease: "easeInOut"
      }
    }
  })), React__default.createElement(ModalContent, _objectSpread({
    bg: "transparent",
    w: "100%",
    height: "90%",
    maxWidth: "800px",
    maxHeight: "calc(100% - 80px)",
    boxShadow: "none",
    mb: 0,
    mt: 0
  }, modalSizeProps), React__default.createElement(AnimatedContent, _objectSpread({
    key: "modal"
  }, _objectSpread({
    position: "relative",
    bg: "white",
    w: "full",
    h: "full",
    pt: 12,
    pb: "10px",
    top: "10px",
    overflow: "hidden",
    rounded: "2xl",
    boxShadow: "2xl",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    initial: !!(hasAnimated == null ? void 0 : hasAnimated.current) ? false : {
      opacity: 0,
      scale: 1.1,
      y: Math.min(window.innerHeight - 100, 400)
    },
    animate: {
      opacity: 1,
      y: 0,
      scale: 1
    },
    exit: {
      opacity: 0,
      scale: 0.8,
      y: Math.max(window.innerHeight - 100, 500)
    },
    transition: {
      scale: {
        duration: 0.3
      },
      opacity: {
        duration: 0.4,
        ease: "easeInOut"
      },
      y: {
        duration: 0.65,
        type: "spring",
        bounce: 0.2
      }
    }
  }, bodyProps)), React__default.createElement(ModalCloseButton, _objectSpread({
    zIndex: "popover",
    size: "lg",
    mr: 2
  }, closeButtonProps)), children))));
};

var SlideUpModalScrollableContent = function SlideUpModalScrollableContent(_ref51) {
  var footerHeight = _ref51.footerHeight,
      header = _ref51.header,
      scrollContainerProps = _ref51.scrollContainerProps,
      children = _ref51.children;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasFooterShadow = _useState2[0],
      setHasFooterShadow = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      bodyEl = _useState4[0],
      setBodyEl = _useState4[1];

  var _ref52 = scrollContainerProps || {},
      ref = _ref52.ref,
      overflowY = _ref52.overflowY,
      h = _ref52.h,
      height = _ref52.height,
      allowedProps = _objectWithoutProperties(_ref52, ["ref", "overflowY", "h", "height"]);

  var handleApplyShadow = useCallback(function () {
    setHasFooterShadow(bodyEl ? bodyEl.clientHeight + bodyEl.scrollTop < bodyEl.scrollHeight : false);
  }, [bodyEl]);
  var handleScroll = useCallback(function (e) {
    var target = e.target;

    if (target.classList.contains("modal-scroll-container")) {
      setHasFooterShadow(target.clientHeight + target.scrollTop < target.scrollHeight);
    }
  }, []);
  var elemRef = useCallback(function (node) {
    if (node !== null) {
      setBodyEl(node);
    }
  }, []);
  var onRender = useCallback(function () {
    handleApplyShadow();
  }, [handleApplyShadow]);
  return React__default.createElement(Box$1, _objectSpread({
    px: 8,
    pt: 2,
    zIndex: "1",
    w: "full"
  }, allowedProps, {
    className: "modal-scroll-container",
    h: footerHeight ? "calc(100% - ".concat(footerHeight, "px)") : "full",
    overflowY: "scroll",
    ref: elemRef,
    onScroll: handleScroll
  }, {
    sx: {
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      "&::-webkit-scrollbar": {
        width: 0,
        height: 0
      }
    }
  }, {}, hasFooterShadow && {
    boxShadow: "0px -15px 20px -15px var(--chakra-colors-gray-200) inset"
  }), header, children instanceof Function ? children({
    onRenderCallback: onRender
  }) : children);
};

var SlideUpModalHeader = function SlideUpModalHeader(_ref53) {
  var children = _ref53.children,
      props = _objectWithoutProperties(_ref53, ["children"]);

  return React__default.createElement(ModalHeader, _objectSpread({}, _objectSpread({
    fontSize: "2xl",
    fontWeight: "medium",
    color: "trueBlack",
    pt: 0,
    pb: 4,
    px: 0
  }, props)), children);
};

var SlideUpModalFooter = function SlideUpModalFooter(_ref54) {
  var _ref54$height = _ref54.height,
      height = _ref54$height === void 0 ? 90 : _ref54$height,
      children = _ref54.children,
      props = _objectWithoutProperties(_ref54, ["height", "children"]);

  return React__default.createElement(ModalFooter, _objectSpread({
    borderTop: "1px solid",
    borderColor: "gray.100",
    height: "".concat(height, "px")
  }, props), children);
};

var getPlacementStyles = function getPlacementStyles(_ref55) {
  var _ref55$placement = _ref55.placement,
      placement = _ref55$placement === void 0 ? "top-right" : _ref55$placement,
      _ref55$offsetX = _ref55.offsetX,
      offsetX = _ref55$offsetX === void 0 ? 0 : _ref55$offsetX,
      _ref55$offsetY = _ref55.offsetY,
      offsetY = _ref55$offsetY === void 0 ? 0 : _ref55$offsetY;
  var PlacementStyles = {
    "top-right": {
      top: 0 + offsetY,
      right: 0 + offsetX
    },
    "top-left": {
      top: 0 + offsetY,
      left: 0 + offsetX
    },
    "bottom-right": {
      bottom: 0 + offsetY,
      right: 0 + offsetX
    },
    "bottom-left": {
      bottom: 0 + offsetY,
      left: 0 + offsetX
    }
  };
  return PlacementStyles[placement];
};

var NotificationBadge = function NotificationBadge(props) {
  var _props$placement2 = props.placement,
      placement = _props$placement2 === void 0 ? "top-right" : _props$placement2,
      _props$offsetX = props.offsetX,
      offsetX = _props$offsetX === void 0 ? 0 : _props$offsetX,
      _props$offsetY = props.offsetY,
      offsetY = _props$offsetY === void 0 ? 0 : _props$offsetY,
      rest = _objectWithoutProperties(props, ["placement", "offsetX", "offsetY"]);

  return React__default.createElement(Circle$1, _objectSpread({
    size: "2",
    position: "absolute",
    bg: "red.500"
  }, getPlacementStyles({
    placement: placement,
    offsetX: offsetX,
    offsetY: offsetY
  }), {}, rest));
};

var NotificationBadgeContainer = function NotificationBadgeContainer(_ref56) {
  var children = _ref56.children,
      rest = _objectWithoutProperties(_ref56, ["children"]);

  return React__default.createElement(Box$1, _objectSpread({
    display: "inline-flex",
    position: "relative"
  }, rest), children);
};

var TRLogo = React__default.memo(function (_ref57) {
  var _ref57$size = _ref57.size,
      size = _ref57$size === void 0 ? 40 : _ref57$size;
  return React__default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("path", {
    d: "M37.7804 0H2.21957C0.99288 0 0 0.993988 0 2.21958V37.7804C0 39.0071 0.993988 40 2.21957 40H37.7804C39.006 40 40 39.006 40 37.7804V2.21958C40 0.993988 39.006 0 37.7804 0Z",
    fill: "#F15D4B"
  }), React__default.createElement("path", {
    d: "M20.688 15.6786C20.688 15.6786 19.9728 16.1748 19.6102 16.4212C19.2476 16.6677 18.8861 16.4433 18.7159 16.3273C17.7033 15.6377 16.4509 15.2742 15.1089 15.3935C12.5156 15.6234 10.4064 17.681 10.1223 20.268C9.75643 23.5977 12.3553 26.4156 15.6119 26.4156C16.5935 26.4156 17.5143 26.1592 18.3124 25.7106C19.0144 25.3138 19.22 25.8288 19.2454 25.904C19.346 26.2012 19.6279 26.4156 19.9595 26.4156H20.5387C20.8681 26.4156 21.1357 26.1482 21.1357 25.8189V15.914C21.1346 15.6842 20.877 15.5493 20.688 15.6786ZM19.2045 21.1455C19.0685 23.1026 17.364 24.6342 15.341 24.4861C13.632 24.3613 12.2193 23.0075 12.0292 21.3057C11.786 19.1353 13.4872 17.2898 15.6096 17.2898C17.5121 17.2898 19.074 18.7718 19.2034 20.6405V21.1455H19.2045Z",
    fill: "white"
  }), React__default.createElement("path", {
    d: "M10.4143 13.4428H8.10173C7.94476 13.4428 7.81764 13.3157 7.81764 13.1588V10.5441C7.81764 10.2855 7.52691 10.133 7.31356 10.28L6.02685 11.1718C5.94063 11.2315 5.88867 11.3298 5.88867 11.4359V23.1962H5.89309C5.89309 24.866 7.17207 26.244 8.80257 26.3999C8.96838 26.4153 9.11209 26.2816 9.11209 26.1159V24.7422C9.11209 24.6074 9.01149 24.4991 8.87884 24.4748C8.27307 24.3643 7.81211 23.8339 7.81211 23.1962H7.81653V15.6551C7.81653 15.4982 7.94365 15.3711 8.10062 15.3711H9.47577C9.56973 15.3711 9.65706 15.3247 9.71012 15.2485L10.6475 13.8881C10.778 13.6991 10.6431 13.4428 10.4143 13.4428Z",
    fill: "white"
  }), React__default.createElement("path", {
    d: "M34.0999 20.5429C33.9263 17.7206 31.5762 15.4551 28.7496 15.3734C27.4994 15.338 26.3409 15.7181 25.3991 16.3845C25.2587 16.484 24.8972 16.6343 24.5402 16.3878L23.5099 15.6773C23.3209 15.5469 23.0645 15.6828 23.0645 15.9115V28.5636C23.0645 28.6686 23.1153 28.7659 23.2015 28.8255L24.4938 29.7206C24.7049 29.8676 24.9945 29.7162 24.9945 29.4587V25.6606C24.9945 25.434 25.2499 25.2948 25.4356 25.4241C26.3299 26.0474 27.4165 26.4131 28.5883 26.4131C31.7531 26.4142 34.2967 23.751 34.0999 20.5429ZM28.8569 24.4859C26.8339 24.634 25.1294 23.1023 24.9934 21.1452V20.6413C25.1239 18.7715 26.6847 17.2907 28.5872 17.2907C30.7107 17.2907 32.4108 19.1351 32.1676 21.3054C31.9775 23.0073 30.5648 24.361 28.8569 24.4859Z",
    fill: "white"
  }));
});
TRLogo.displayName = "TRLogo";

var NavItem = function NavItem(_ref58) {
  var item = _ref58.item;
  var icon = item.icon,
      label = item.label,
      active2 = item.active,
      onClick = item.onClick;
  return React__default.createElement(UnstyledButton, {
    onClick: onClick,
    my: 8,
    sx: function sx(theme2) {
      return _objectSpread({
        display: "block",
        width: "100%",
        padding: theme2.spacing.xs,
        borderRadius: theme2.radius.md,
        color: theme2.colors.gray[2],
        fontSize: theme2.fontSizes.md,
        "&:hover": {
          backgroundColor: theme2.colors.blue[7]
        }
      }, !!active2 && {
        backgroundColor: theme2.colors.blue[7],
        color: "#FFF",
        fontWeight: 500
      });
    }
  }, React__default.createElement(Group, {
    spacing: "xs"
  }, React__default.createElement(ThemeIcon, {
    color: "#fff",
    variant: "dark"
  }, React__default.createElement(Icon$1, {
    boxSize: 5,
    icon: icon
  })), React__default.createElement(Text$1, null, label)));
};

var CurrentUser = function CurrentUser(_ref59) {
  var menuContent = _ref59.menuContent,
      menuLabel = _ref59.menuLabel;
  var theme2 = useMantineTheme();
  return React__default.createElement(Box$3, {
    p: 10,
    sx: {
      borderTop: "1px solid",
      borderColor: theme2.colors.blue[7]
    }
  }, React__default.createElement(Menu2, {
    shadow: "md",
    width: 245,
    offset: -5,
    transitionProps: {
      transition: "pop",
      duration: 250
    }
  }, React__default.createElement(Menu2.Target, null, React__default.createElement(UnstyledButton, {
    sx: {
      display: "block",
      width: "100%",
      padding: theme2.spacing.md,
      borderRadius: theme2.radius.sm,
      color: "#FFF",
      fontSize: theme2.fontSizes.md,
      "&:hover": {
        backgroundColor: theme2.colors.blue[7]
      }
    }
  }, React__default.createElement(Group, {
    sx: {
      flexWrap: "nowrap",
      gap: 0,
      justifyContent: "space-between"
    }
  }, React__default.createElement(Box$3, {
    sx: {
      flex: 1
    }
  }, menuLabel), React__default.createElement(Box$3, {
    display: "flex",
    miw: "20px"
  }, React__default.createElement(Icon$1, {
    boxSize: 5,
    icon: icons.fi.ChevronDown
  }))))), React__default.createElement(Menu2.Dropdown, null, menuContent)));
};

var NavbarUserMenuItem = function NavbarUserMenuItem(_ref60) {
  var children = _ref60.children,
      iconKey = _ref60.iconKey,
      sx = _ref60.sx,
      rest = _objectWithoutProperties(_ref60, ["children", "iconKey", "sx"]);

  var theme2 = useMantineTheme();
  return React__default.createElement(Menu2.Item, _objectSpread({
    sx: [{
      width: "calc(100% - 10px)",
      fontSize: theme2.fontSizes.md,
      lineHeight: 1
    }, sx],
    mx: "auto",
    my: 10,
    px: 10,
    py: 12,
    color: theme2.colors.gray[6],
    icon: React__default.createElement(Icon$1, {
      boxSize: 5,
      icon: iconKey
    })
  }, rest), children);
};

var HeaderTabs = function HeaderTabs(_ref61) {
  var tabs = _ref61.tabs,
      currentIndex = _ref61.currentIndex;

  var _a;

  return React__default.createElement(Tabs2, {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    value: ((_a = tabs[currentIndex]) == null ? void 0 : _a.key) || null,
    h: "57px",
    display: "flex",
    ml: 20,
    sx: {
      alignSelf: "flex-end",
      alignItems: "flex-start"
    },
    styles: function styles(theme2) {
      return {
        tab: {
          fontSize: theme2.fontSizes.md,
          padding: 0,
          paddingTop: 10,
          alignItems: "flex-start",
          "&:hover": {
            backgroundColor: "transparent",
            color: theme2.colors.gray[7],
            borderColor: "transparent"
          },
          "&:focus": {
            outline: "none"
          }
        },
        tabsList: {
          height: "100%",
          borderColor: "transparent"
        },
        tabLabel: {
          root: {
            "&[data-active]": {
              color: theme2.colors.blue[5]
            }
          }
        }
      };
    }
  }, React__default.createElement(Tabs2.List, null, tabs == null ? void 0 : tabs.map(function (tab, i) {
    return React__default.createElement(TabContent, {
      key: "tab-".concat(tab.key, "-").concat(i),
      i: i,
      currentIndex: currentIndex,
      tab: tab
    });
  })));
};

var TabContent = function TabContent(_ref62) {
  var i = _ref62.i,
      currentIndex = _ref62.currentIndex,
      tab = _ref62.tab;

  var _useHover = useHover(),
      hovered = _useHover.hovered,
      ref = _useHover.ref;

  return React__default.createElement(Tabs2.Tab, {
    mx: 10,
    px: 10,
    key: tab.key,
    value: tab.key,
    onClick: tab.onClick,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ref: ref,
    sx: function sx(theme2) {
      return {
        fontWeight: 400,
        color: theme2.colors.gray[3],
        "&[data-active]": {
          fontWeight: 600,
          color: theme2.colors.blue[5],
          borderColor: theme2.colors.blue[5],
          cursor: "initial"
        }
      };
    }
  }, tab.label, i !== currentIndex && React__default.createElement(TabUnderline, {
    isHovered: hovered
  }));
};

var TabUnderline = function TabUnderline(_ref63) {
  var isHovered = _ref63.isHovered;
  return React__default.createElement(Transition, {
    mounted: isHovered,
    transition: "scale-x",
    duration: 200,
    timingFunction: "ease"
  }, function (styles) {
    return React__default.createElement(Box$1, _objectSpread({
      style: styles
    }, {
      position: "absolute",
      w: "100%",
      h: "2px",
      left: 0,
      bottom: "-2px",
      bg: "blue.500"
    }));
  });
};

function Brand() {
  return React__default.createElement(Flex$1, {
    align: "center",
    borderBottom: "1px solid",
    borderColor: "blue.700",
    height: "5rem",
    p: 4
  }, React__default.createElement(Group, {
    position: "apart"
  }, React__default.createElement(TRLogo, null)));
}

var AppShell = function AppShell(_ref64) {
  var children = _ref64.children,
      sideNavItems = _ref64.sideNavItems,
      sidebarTopSection = _ref64.sidebarTopSection,
      _ref64$isFullscreen = _ref64.isFullscreen,
      isFullscreen = _ref64$isFullscreen === void 0 ? false : _ref64$isFullscreen,
      _ref64$noSidebarToggl = _ref64.noSidebarToggle,
      noSidebarToggle = _ref64$noSidebarToggl === void 0 ? false : _ref64$noSidebarToggl,
      headerContent = _ref64.headerContent,
      headerProps = _ref64.headerProps,
      userMenuLabel = _ref64.userMenuLabel,
      userMenuContent = _ref64.userMenuContent,
      gridProps = _ref64.gridProps,
      innerShellProps = _ref64.innerShellProps,
      _ref64$useGrid = _ref64.useGrid,
      useGrid = _ref64$useGrid === void 0 ? false : _ref64$useGrid,
      bodyMinWidth = _ref64.bodyMinWidth,
      rest = _objectWithoutProperties(_ref64, ["children", "sideNavItems", "sidebarTopSection", "isFullscreen", "noSidebarToggle", "headerContent", "headerProps", "userMenuLabel", "userMenuContent", "gridProps", "innerShellProps", "useGrid", "bodyMinWidth"]);

  var theme2 = useMantineTheme();

  var _useDisclosure$ = useDisclosure$1(!isFullscreen),
      _useDisclosure$2 = _slicedToArray(_useDisclosure$, 2),
      opened = _useDisclosure$2[0],
      toggle = _useDisclosure$2[1].toggle;

  var shouldToggle = !!opened && !!isFullscreen || !opened && !isFullscreen;
  var NAVBAR_WIDTH = !!opened ? 264 : 1;
  var totalMinWidth = (bodyMinWidth || 0) + NAVBAR_WIDTH;

  var _ref65 = innerShellProps || {},
      innerShellBg = _ref65.bg,
      otherInnerShellProps = _objectWithoutProperties(_ref65, ["bg"]);

  var _ref66 = headerProps || {},
      headerSx = _ref66.sx,
      otherHeaderProps = _objectWithoutProperties(_ref66, ["sx"]);

  var _ref67 = rest || {},
      shellSx = _ref67.sx,
      otherShellProps = _objectWithoutProperties(_ref67, ["sx"]);

  useDidUpdate(function () {
    if (shouldToggle) toggle();
  }, [isFullscreen]);
  return React__default.createElement(AppShell$1, _objectSpread({
    padding: "xs",
    layout: "alt",
    navbar: React__default.createElement(Navbar, {
      width: {
        base: NAVBAR_WIDTH
      },
      height: "100%",
      sx: function sx(theme22) {
        return {
          backgroundColor: theme22.colors.blue[6],
          display: !opened ? "none" : "flex"
        };
      }
    }, React__default.createElement(Navbar.Section, null, React__default.createElement(Brand, null)), !!sidebarTopSection && React__default.createElement(Navbar.Section, null, sidebarTopSection), React__default.createElement(Navbar.Section, {
      grow: true,
      component: ScrollArea
    }, React__default.createElement(Box$1, {
      mt: 4,
      mx: "auto",
      w: "calc(100% - 20px)"
    }, sideNavItems == null ? void 0 : sideNavItems.map(function (item, i) {
      return React__default.createElement(NavItem, {
        key: i,
        item: item
      });
    }))), React__default.createElement(Navbar.Section, null, React__default.createElement(CurrentUser, {
      menuContent: userMenuContent,
      menuLabel: userMenuLabel
    }))),
    header: React__default.createElement(Header, _objectSpread({
      display: "flex",
      height: 80,
      px: "xl",
      py: 0
    }, otherHeaderProps, {
      sx: _objectSpread({
        alignItems: "center",
        flexGrow: 1
      }, !!bodyMinWidth && _defineProperty({}, theme2.fn.smallerThan("".concat(totalMinWidth)), {
        position: "sticky",
        paddingLeft: "".concat(NAVBAR_WIDTH + 25, "px")
      }), {}, headerSx)
    }), React__default.createElement(Flex$1, {
      sx: {
        width: "100%",
        height: "100%"
      },
      align: "center"
    }, !noSidebarToggle && React__default.createElement(IconButton, _objectSpread({
      mr: 4,
      variant: "ghost",
      icon: React__default.createElement(Icon$1, {
        boxSize: 6,
        icon: icons.fi.Menu
      }),
      onClick: toggle
    }, {
      "aria-label": "Show/hide sidebar",
      color: "gray.800",
      bg: "transparent",
      _hover: {
        bg: "transparent"
      }
    })), headerContent)),
    styles: function styles(theme22) {
      return {
        main: {
          backgroundColor: innerShellBg || theme22.colors.gray[1]
        }
      };
    },
    sx: _objectSpread({}, !!bodyMinWidth && _defineProperty({
      minWidth: "".concat(totalMinWidth, "px")
    }, theme2.fn.smallerThan("".concat(totalMinWidth)), {
      ".mantine-AppShell-main": {
        paddingTop: "0.625rem"
      }
    }), {}, shellSx)
  }, otherShellProps), React__default.createElement(Box$1, _objectSpread({
    px: 12
  }, otherInnerShellProps), useGrid ? React__default.createElement(TapGrid, _objectSpread({}, gridProps), children) : children));
};

AppShell.NavbarUserMenuItem = NavbarUserMenuItem;
AppShell.HeaderTabs = HeaderTabs;

var InterstitialCloseButton = function InterstitialCloseButton(_ref70) {
  var onClick = _ref70.onClick,
      _ref70$variant = _ref70.variant,
      variant = _ref70$variant === void 0 ? "light-1" : _ref70$variant,
      rest = _objectWithoutProperties(_ref70, ["onClick", "variant"]);

  return React__default.createElement(IconButton, _objectSpread({
    icon: React__default.createElement(Icon$1, {
      icon: icons.io5.Close,
      boxSize: 5,
      color: Variants[variant].color
    }),
    size: "sm",
    width: "32px",
    height: "32px",
    position: "absolute",
    bg: Variants[variant].bg,
    top: 1,
    right: 1,
    rounded: "lg"
  }, {
    "aria-label": (rest == null ? void 0 : rest["aria-label"]) || "Close",
    sx: _objectSpread({
      _hover: {
        bg: Variants[variant].bg,
        boxShadow: "none",
        outline: 0,
        border: "none"
      },
      _active: {
        bg: Variants[variant].bg
      }
    }, rest == null ? void 0 : rest.sx)
  }, {}, rest, {
    onClick: onClick
  }));
};

var Variants = {
  "light-1": {
    color: "white",
    bg: "transparent"
  },
  "light-2": {
    color: "white",
    bg: "blackAlpha.500"
  },
  "dark-1": {
    color: "gray.700",
    bg: "transparent"
  },
  "dark-2": {
    color: "gray.700",
    bg: "whiteAlpha.500"
  }
};

var CurrencySaleBanner = function CurrencySaleBanner(_ref71) {
  var text = _ref71.text,
      subtitleText = _ref71.subtitleText,
      onClickContent = _ref71.onClickContent,
      onClose = _ref71.onClose,
      textProps = _ref71.textProps,
      closeButtonProps = _ref71.closeButtonProps,
      containerProps = _ref71.containerProps;
  return React__default.createElement(Flex$1, _objectSpread({
    w: "full",
    h: "full",
    position: "relative",
    p: 4,
    className: "sdk-currency-sale-banner",
    boxShadow: "md",
    rounded: "lg",
    bg: "gradients.orangeFuschia"
  }, containerProps), React__default.createElement(Flex$1, {
    h: "full",
    w: "full",
    align: "center",
    onClick: onClickContent
  }, React__default.createElement(Circle$1, {
    size: 14,
    fontSize: "xs",
    fontWeight: "bold",
    bg: "teal.800",
    color: "white"
  }, "SALE"), React__default.createElement(Flex$1, {
    w: "full",
    color: "white",
    flexDirection: "column",
    flexGrow: 1,
    ml: 4,
    align: "flex-start"
  }, React__default.createElement(Text$1, {
    py: 1,
    fontSize: "sm",
    fontWeight: "medium"
  }, subtitleText), React__default.createElement(Text$1, _objectSpread({
    py: 1,
    fontSize: "lg",
    fontWeight: "semibold"
  }, textProps), text))), React__default.createElement(InterstitialCloseButton, _objectSpread({
    variant: "light-1"
  }, {
    "aria-label": (closeButtonProps == null ? void 0 : closeButtonProps["aria-label"]) || "Close banner"
  }, {}, closeButtonProps, {
    onClick: onClose
  })));
};

var DisplayInterstitial = function DisplayInterstitial(_ref72) {
  var imageUrl = _ref72.imageUrl,
      closeButtonVariant = _ref72.closeButtonVariant,
      onClickContent = _ref72.onClickContent,
      onClose = _ref72.onClose,
      closeButtonProps = _ref72.closeButtonProps,
      containerProps = _ref72.containerProps;
  return React__default.createElement(Flex$1, _objectSpread({
    w: "full",
    h: "full",
    position: "relative",
    align: "center",
    justify: "center"
  }, containerProps), React__default.createElement(InterstitialCloseButton, _objectSpread({
    variant: closeButtonVariant
  }, {
    "aria-label": (closeButtonProps == null ? void 0 : closeButtonProps["aria-label"]) || "Close"
  }, {}, closeButtonProps, {
    onClick: onClose
  })), React__default.createElement(chakra$1.img, _objectSpread({
    src: imageUrl,
    onClick: onClickContent
  }, {
    w: "100%",
    h: "100%",
    sx: {
      aspectRatio: "auto",
      objectFit: "cover"
    }
  })));
};

var index =
/* @__PURE__ */
Object.freeze(
/* @__PURE__ */
Object.defineProperty({
  __proto__: null,
  Button: Button$2,
  Menu: Menu2
}, Symbol.toStringTag, {
  value: "Module"
}));
export { Accordion, AccordionItem, Alert, AlertDescription, AlertDialog, AlertDialogBody, AlertDialogCloseButton, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, AlertIcon, AlertTitle, AppShell, Badge$1 as Badge, Box$1 as Box, BreadcrumbNav, Button, ButtonGroup, ButtonStyles, Center$1 as Center, Checkbox, CheckboxGroup, Circle, CircularProgress, Colors, ConditionalTooltip, CurrencySaleBanner, DisplayInterstitial, Divider, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerFooter, DrawerHeader, DrawerOverlay, Flex$1 as Flex, FormControl2 as FormControl, FormControlStyles, FormErrorMessage, FormErrorMessageStyles, FormHelperText, FormHelperTextStyles, FormLabel, FormLabelStyles, Grid, GridItem2 as GridItem, Heading$1 as Heading, Icon$1 as Icon, IconButton, Image, InfoIcon, Input, InputLabel, InputStyles, InputWithElements, InterstitialCloseButton, LegacyThemeProvider, Link, LinkBox, LinkOverlay, List, ListIcon, ListItem, index as Mantine, MantineTheme, Menu, MenuButton, MenuCommand, MenuDivider, MenuGroup, MenuIcon, MenuItem, MenuItemOption, MenuList, MenuOptionGroup, Modal2 as Modal, ModalBody, ModalCloseButton2 as ModalCloseButton, ModalContent2 as ModalContent, ModalFooter2 as ModalFooter, ModalHeader2 as ModalHeader, ModalOverlay2 as ModalOverlay, MotionBox, NotificationBadge, NotificationBadgeContainer, NumberInput, OrderedList, Popover, PopoverArrow, PopoverBody, PopoverCloseButton, PopoverContent, PopoverFooter, PopoverHeader, PopoverTrigger, Progress, ProgressStyles, Radio, RadioGroup, Select, SimpleGrid$1 as SimpleGrid, SimpleIconButton, Skeleton, SkeletonCircle, SkeletonText, SlideUpModal, SlideUpModalFooter, SlideUpModalHeader, SlideUpModalScrollableContent, Slider, SliderFilledTrack, SliderThumb, SliderTrack, Spacer, Spinner, Stack$1 as Stack, Stat, StatArrow, StatGroup, StatHelpText, StatLabel, StatNumber, Swiper, SwiperModules, SwiperSlide, Switch, TABLE_VARIANTS, TRLogo, Tab, TabList, TabPanel, TabPanels, Table, TableCaption, Tabs, Tag, TagCloseButton, TagLabel, TagLeftIcon, TagRightIcon, TapGrid, TapGridItem, TapTheme, TapThemeProvider, Tbody, Td, Text$1 as Text, Textarea, Tfoot, Th, Thead, Tooltip, Tr, UnorderedList, chakra, css, icons, respond, useSwiper, useSwiperSlide };